'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

var SvgDAppsIcon = function SvgDAppsIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "DApps_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M633.387 130.133a85.333 85.333 0 0 1 120.704 0L889.813 265.9a85.333 85.333 0 0 1 0 120.661L754.091 522.325a85.333 85.333 0 0 1-120.704 0L497.62 386.56a85.333 85.333 0 0 1 0-120.661l135.766-135.766zM829.483 326.23 693.76 190.464 557.995 326.229 693.76 461.995l135.765-135.766zM47.829 133.163h362.667V382.42a113.45 113.45 0 0 1-113.45 113.451H47.871V133.205zm85.334 85.333v192h163.882a28.117 28.117 0 0 0 28.16-28.075V218.453h-192zM47.829 570.837h249.216A113.45 113.45 0 0 1 410.54 684.288v249.216H47.872V570.837zm85.334 85.334v192h192V684.288a28.117 28.117 0 0 0-28.118-28.117h-163.84zm465.792 0a28.117 28.117 0 0 0-28.16 28.117v163.883h192v-192h-163.84zM485.46 684.288a113.45 113.45 0 0 1 113.494-113.45h249.173v362.666H485.461V684.288z"
  }));
};

var SvgImIcon = function SvgImIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "IM_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M42.667 262.656c0-99.03 73.6-177.323 162.133-177.323h614.4c88.533 0 162.133 78.294 162.133 177.323v498.688c0 99.03-73.6 177.323-162.133 177.323H204.8c-88.533 0-162.133-78.294-162.133-177.323V262.656zm85.333 0v498.688c0 46.08 34.39 83.456 76.8 83.456h614.4c42.41 0 76.8-37.376 76.8-83.456V262.656c0-46.08-34.39-83.456-76.8-83.456H204.8c-42.41 0-76.8 37.376-76.8 83.456zM446.677 363.52h100.651l69.248 185.6h3.456l69.248-185.6h100.693V691.2h-79.146V501.76h-2.347l-66.347 186.88h-47.701l-66.304-188.16h-2.347V691.2H446.72V363.52zM234.667 691.2v-56.79h44.416V420.268h-44.416V363.52h163.84v56.79H354.09v214.1h44.416v56.79h-163.84z"
  }));
};

var SvgAccountswitchIcon = function SvgAccountswitchIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "accountswitch_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M189.61 91.008A189.61 189.61 0 0 0 0 280.661v455.083a189.61 189.61 0 0 0 189.61 189.653h455.126a37.93 37.93 0 0 0 0-75.861H189.611A113.792 113.792 0 0 1 75.86 735.744V280.661a113.792 113.792 0 0 1 113.75-113.834h417.194a113.792 113.792 0 0 1 113.792 113.792v37.93a37.93 37.93 0 0 0 75.862 0v-37.973a189.61 189.61 0 0 0-189.654-189.61H189.611zm303.446 303.403a75.861 75.861 0 1 0-151.723 0 75.861 75.861 0 0 0 151.723 0zm75.819 0c0 38.826-14.592 74.24-38.571 101.12 25.6 12.074 49.024 28.16 69.333 47.36a37.93 37.93 0 0 1-52.138 55.125A189.61 189.61 0 0 0 227.54 735.744a37.93 37.93 0 0 1-75.818 0 265.515 265.515 0 0 1 152.32-240.213 151.723 151.723 0 1 1 264.832-101.12zm417.194 161.834H767.061l59.136-59.136a37.93 37.93 0 0 0-53.632-53.632L655.872 560.171a37.845 37.845 0 0 0-10.965 30.378 37.93 37.93 0 0 0 37.76 41.558h303.402a37.93 37.93 0 0 0 0-75.862zM1024 727.68a39.253 39.253 0 0 1-.17 3.627 37.845 37.845 0 0 1-10.923 30.378L896.213 878.38a37.93 37.93 0 1 1-53.674-53.632l59.136-59.136H682.667a37.93 37.93 0 1 1 0-75.862h303.402c20.95 0 37.931 16.982 37.931 37.931z"
  }));
};

var SvgAddIcon = function SvgAddIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "add_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M938.667 512c0 235.648-191.019 426.667-426.667 426.667S85.333 747.648 85.333 512 276.352 85.333 512 85.333 938.667 276.352 938.667 512zM512 853.333a341.333 341.333 0 1 0 0-682.666 341.333 341.333 0 0 0 0 682.666zm0-554.666a42.667 42.667 0 0 1 42.667 42.666v128h128a42.667 42.667 0 1 1 0 85.334h-128v128a42.667 42.667 0 1 1-85.334 0v-128h-128a42.667 42.667 0 1 1 0-85.334h128v-128A42.667 42.667 0 0 1 512 298.667z"
  }));
};

var SvgAddSolidIcon = function SvgAddSolidIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "add_solid_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M981.333 512c0 259.2-210.133 469.333-469.333 469.333S42.667 771.2 42.667 512 252.8 42.667 512 42.667 981.333 252.8 981.333 512zM512 768a42.667 42.667 0 0 0 42.667-42.667V554.667h170.666a42.667 42.667 0 1 0 0-85.334H554.667V298.667a42.667 42.667 0 1 0-85.334 0v170.666H298.667a42.667 42.667 0 1 0 0 85.334h170.666v170.666A42.667 42.667 0 0 0 512 768z"
  }));
};

var SvgAdddecIcon = function SvgAdddecIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "adddec_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M234.667 469.333a42.667 42.667 0 1 0 85.333 0V362.667h106.667a42.667 42.667 0 1 0 0-85.334H320V170.667a42.667 42.667 0 1 0-85.333 0v106.666H128a42.667 42.667 0 0 0 0 85.334h106.667v106.666zm320 320a42.667 42.667 0 0 1 42.666-42.666H896A42.667 42.667 0 1 1 896 832H597.333a42.667 42.667 0 0 1-42.666-42.667zm-353.835-8.832a42.667 42.667 0 1 0 60.33 60.331l537.003-537.003a42.667 42.667 0 0 0-60.33-60.33L200.832 780.5z"
  }));
};

var SvgAirdropIcon = function SvgAirdropIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m19.936 1.114-.06-.364-.062.364a2.77 2.77 0 0 1-2.189 2.261c1.13.234 2 1.139 2.192 2.277l.058.348.06-.364a2.77 2.77 0 0 1 2.19-2.261 2.77 2.77 0 0 1-2.19-2.261ZM2 10.857a1.005 1.005 0 0 0 .348.776l7.396 6.432A2 2 0 0 0 8.25 20v1.25a2 2 0 0 0 2 2H13a2 2 0 0 0 2-2V20a2 2 0 0 0-1.494-1.935l7.4-6.435a.997.997 0 0 0 .344-.77C21.24 5.881 16.848 2 11.625 2 6.403 2 2.011 5.88 2 10.857Zm16.815-.059-4.726 4.109 1.465-3.66c.022-.056.039-.113.05-.17a2.26 2.26 0 0 1 .194-.175c.313-.255.815-.527 1.577-.527.659 0 1.123.203 1.44.423Zm-5.669.12c.111.085.207.171.285.248l-1.806 4.516-1.806-4.516a3.1 3.1 0 0 1 .285-.248c.37-.285.88-.543 1.521-.543.64 0 1.15.258 1.521.543Zm-5.45.328 1.465 3.661-4.688-4.076a2.437 2.437 0 0 1 1.402-.456c.64 0 1.15.258 1.521.543.103.079.192.158.267.23.01.033.02.066.034.098Zm-1.82-2.871c-.543 0-1.03.1-1.455.25C5.445 5.97 8.232 4 11.625 4c3.38 0 6.158 1.954 7.192 4.594-.42-.135-.9-.219-1.442-.219-1.292 0-2.227.478-2.838.974l-.074.06a5.236 5.236 0 0 0-.098-.077c-.605-.465-1.532-.957-2.74-.957-1.208 0-2.135.492-2.74.957a5.038 5.038 0 0 0-.135.108 5.07 5.07 0 0 0-.135-.108c-.605-.465-1.532-.957-2.74-.957ZM21.374 6l.008.06c.05.379.36.669.742.69l-.029.006a.895.895 0 0 0-.721.744.834.834 0 0 0-.682-.737l-.068-.013a.79.79 0 0 0 .747-.716L21.375 6Z"
  }));
};

var SvgAlertCircleSolidIcon = function SvgAlertCircleSolidIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "alert_circle_solid_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512 771.2 981.333 512 981.333 42.667 771.2 42.667 512zm426.666 213.333A42.667 42.667 0 0 0 512 768h.427a42.667 42.667 0 1 0 0-85.333H512a42.667 42.667 0 0 0-42.667 42.666zm85.334-426.666a42.667 42.667 0 1 0-85.334 0v256a42.667 42.667 0 1 0 85.334 0v-256z"
  }));
};

var SvgAlertTriangleSolidIcon = function SvgAlertTriangleSolidIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "alert_triangle_solid_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M461.227 115.499a57.77 57.77 0 0 1 101.546 0l410.624 732.586c22.571 40.278-5.632 90.582-50.773 90.582H101.376c-45.141 0-73.344-50.304-50.773-90.539l410.666-732.587zm8.106 695.168A42.667 42.667 0 0 0 512 853.333h.427a42.667 42.667 0 1 0 0-85.333H512a42.667 42.667 0 0 0-42.667 42.667zM554.667 384a42.667 42.667 0 1 0-85.334 0v256a42.667 42.667 0 1 0 85.334 0V384z"
  }));
};

var SvgAngleIcon = function SvgAngleIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "angle_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M789.333 170.667a64 64 0 1 0 0 128 64 64 0 0 0 0-128zm-149.333 64a149.333 149.333 0 1 1 71.808 127.658L610.347 463.83A404.096 404.096 0 0 1 724.779 768H896a42.667 42.667 0 1 1 0 85.333H369.621a149.333 149.333 0 1 1-70.656-198.826l355.542-355.542A148.779 148.779 0 0 1 640 234.667zM639.317 768a318.848 318.848 0 0 0-89.301-243.84l-187.69 187.648A149.12 149.12 0 0 1 382.505 768h256.811zm-340.65 21.333a64 64 0 1 0-128 0 64 64 0 0 0 128 0z"
  }));
};

var SvgApplynowIcon = function SvgApplynowIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "applynow_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M853.333 341.333a42.667 42.667 0 0 1-42.666-42.666v-85.334A42.667 42.667 0 0 0 768 170.667H256a42.667 42.667 0 0 0-42.667 42.666v597.334A42.667 42.667 0 0 0 256 853.333h85.333a42.667 42.667 0 1 1 0 85.334H256a128 128 0 0 1-128-128V213.333a128 128 0 0 1 128-128h512a128 128 0 0 1 128 128v85.334a42.667 42.667 0 0 1-42.667 42.666zM341.333 512a42.667 42.667 0 1 0 0 85.333h128a42.667 42.667 0 1 0 0-85.333h-128zm0-213.333a42.667 42.667 0 0 0 0 85.333h256a42.667 42.667 0 1 0 0-85.333h-256zM660.352 820.18l-66.133 17.366 17.365-66.134c2.688-10.282 8.107-19.669 15.573-27.178l230.528-230.528a42.667 42.667 0 0 1 60.374 60.33L687.488 804.565a59.99 59.99 0 0 1-27.136 15.616zM544.128 938.923l137.899-36.267a145.28 145.28 0 0 0 65.834-37.76L978.39 634.368a128 128 0 1 0-181.034-180.992L566.827 683.904a145.28 145.28 0 0 0-37.76 65.792L492.8 887.595a42.027 42.027 0 0 0 51.328 51.328z"
  }));
};

var SvgArrowIcon = function SvgArrowIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrow_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M597.333 128A42.667 42.667 0 0 1 640 85.333h256A42.667 42.667 0 0 1 938.667 128v256a42.667 42.667 0 1 1-85.334 0V229.12L365.355 717.013a149.333 149.333 0 1 1-60.928-59.733l486.698-486.656H640a42.667 42.667 0 0 1-42.667-42.667zM170.667 789.333a64 64 0 1 0 128 0 64 64 0 0 0-128 0z"
  }));
};

var SvgArrowchevron2DownIcon = function SvgArrowchevron2DownIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron2_down_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M328.832 225.835a42.667 42.667 0 0 0-60.33 60.33L481.834 499.5a42.667 42.667 0 0 0 60.33 0L755.5 286.165a42.667 42.667 0 0 0-60.331-60.33L512 409.003 328.832 225.835zm0 298.666a42.667 42.667 0 0 0-60.33 60.331l213.333 213.333a42.667 42.667 0 0 0 60.33 0L755.5 584.832a42.667 42.667 0 0 0-60.331-60.33L512 707.668 328.832 524.501z"
  }));
};

var SvgArrowchevron2LeftIcon = function SvgArrowchevron2LeftIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron2_left_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M499.499 328.832a42.667 42.667 0 0 0-60.331-60.33L225.835 481.834a42.667 42.667 0 0 0 0 60.33L439.168 755.5a42.667 42.667 0 0 0 60.33-60.331L316.332 512 499.5 328.832zm298.666 0a42.667 42.667 0 0 0-60.33-60.33L524.5 481.834a42.667 42.667 0 0 0 0 60.33L737.835 755.5a42.667 42.667 0 0 0 60.33-60.331L614.997 512l183.168-183.168z"
  }));
};

var SvgArrowchevron2RightIcon = function SvgArrowchevron2RightIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron2_right_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M225.835 328.832a42.667 42.667 0 0 1 60.33-60.33L499.5 481.834a42.667 42.667 0 0 1 0 60.33L286.165 755.5a42.667 42.667 0 0 1-60.33-60.331L409.003 512 225.835 328.832zm358.997-60.33a42.667 42.667 0 1 0-60.33 60.33L707.668 512 524.501 695.168a42.667 42.667 0 0 0 60.331 60.33l213.333-213.333a42.667 42.667 0 0 0 0-60.33L584.832 268.5z"
  }));
};

var SvgArrowchevron2UpIcon = function SvgArrowchevron2UpIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron2_up_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M542.165 225.835a42.667 42.667 0 0 0-60.33 0L268.5 439.168a42.667 42.667 0 1 0 60.331 60.33L512 316.332 695.168 499.5a42.667 42.667 0 0 0 60.33-60.331L542.166 225.835zm213.334 512L542.165 524.5a42.667 42.667 0 0 0-60.33 0L268.5 737.835a42.667 42.667 0 1 0 60.331 60.33L512 614.997l183.168 183.168a42.667 42.667 0 0 0 60.33-60.33z"
  }));
};

var SvgArrowchevronDownIcon = function SvgArrowchevronDownIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron_down_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M225.835 353.835a42.667 42.667 0 0 1 60.33 0L512 579.669l225.835-225.834a42.667 42.667 0 1 1 60.33 60.33l-256 256a42.667 42.667 0 0 1-60.33 0l-256-256a42.667 42.667 0 0 1 0-60.33z"
  }));
};

var SvgArrowchevronLeftIcon = function SvgArrowchevronLeftIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron_left_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M670.165 225.835a42.667 42.667 0 0 1 0 60.33L444.331 512l225.834 225.835a42.667 42.667 0 0 1-60.33 60.33l-256-256a42.667 42.667 0 0 1 0-60.33l256-256a42.667 42.667 0 0 1 60.33 0z"
  }));
};

var SvgArrowchevronRightIcon = function SvgArrowchevronRightIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron_right_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M353.835 225.835a42.667 42.667 0 0 1 60.33 0l256 256a42.667 42.667 0 0 1 0 60.33l-256 256a42.667 42.667 0 0 1-60.33-60.33L579.669 512 353.835 286.165a42.667 42.667 0 0 1 0-60.33z"
  }));
};

var SvgArrowchevronUpIcon = function SvgArrowchevronUpIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowchevron_up_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M481.835 353.835a42.667 42.667 0 0 1 60.33 0l256 256a42.667 42.667 0 0 1-60.33 60.33L512 444.331 286.165 670.165a42.667 42.667 0 0 1-60.33-60.33l256-256z"
  }));
};

var SvgArrowdownIcon = function SvgArrowdownIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowdown_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m561.707 657.75 194.389-262.23a60.416 60.416 0 0 0-13.312-85.077 62.165 62.165 0 0 0-36.437-11.776H317.653c-34.048 0-61.653 27.264-61.653 60.885 0 12.928 4.181 25.515 11.904 35.968l194.347 262.23a62.123 62.123 0 0 0 99.498 0z"
  }));
};

var SvgArrowleftIcon = function SvgArrowleftIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowleft_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m323.584 462.293 262.23-194.389a60.416 60.416 0 0 1 85.077 13.312c7.68 10.581 11.776 23.339 11.776 36.437v388.694c0 34.048-27.264 61.653-60.886 61.653-12.928 0-25.514-4.181-35.968-11.904L323.584 561.749a62.123 62.123 0 0 1 0-99.498z"
  }));
};

var SvgArrowmoreIcon = function SvgArrowmoreIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowmore_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M883.499 670.165a42.667 42.667 0 0 0 0-60.33L670.165 396.5a42.667 42.667 0 1 0-60.33 60.331l140.501 140.501h-451.67A85.333 85.333 0 0 1 213.334 512V170.667a42.667 42.667 0 0 0-85.333 0V512a170.667 170.667 0 0 0 170.667 170.667h451.669L609.835 823.168a42.667 42.667 0 0 0 60.33 60.33L883.5 670.166z"
  }));
};

var SvgArrowrightIcon = function SvgArrowrightIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowright_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m700.416 462.293-262.23-194.389a60.416 60.416 0 0 0-85.077 13.312c-7.68 10.581-11.776 23.339-11.776 36.437v388.694c0 34.048 27.264 61.653 60.886 61.653 12.928 0 25.514-4.181 35.968-11.904l262.229-194.347a62.123 62.123 0 0 0 0-99.498z"
  }));
};

var SvgArrowupIcon = function SvgArrowupIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "arrowup_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m561.707 323.584 194.389 262.23a60.416 60.416 0 0 1-13.312 85.077c-10.581 7.68-23.339 11.776-36.437 11.776H317.653A61.27 61.27 0 0 1 256 621.78c0-12.928 4.181-25.514 11.904-35.968l194.347-262.229a62.123 62.123 0 0 1 99.498 0z"
  }));
};

var SvgAssethistoryIcon = function SvgAssethistoryIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "assethistory_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M746.667 640a42.667 42.667 0 1 0-85.334 0v64a42.667 42.667 0 0 0 18.987 35.499l64 42.666a42.667 42.667 0 0 0 47.36-70.997l-45.013-29.995V640z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M448 704a256 256 0 1 1 512 0 256 256 0 0 1-512 0zm256-170.667a170.667 170.667 0 1 0 0 341.334 170.667 170.667 0 0 0 0-341.334z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M810.667 384A42.667 42.667 0 1 0 896 384V213.333a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h170.667a42.667 42.667 0 1 0 0-85.334H256a42.667 42.667 0 0 1-42.667-42.666V213.333A42.667 42.667 0 0 1 256 170.667h512a42.667 42.667 0 0 1 42.667 42.666V384z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M298.667 469.333a42.667 42.667 0 0 1 42.666-42.666h128a42.667 42.667 0 1 1 0 85.333h-128a42.667 42.667 0 0 1-42.666-42.667zm0-170.666A42.667 42.667 0 0 1 341.333 256h256a42.667 42.667 0 1 1 0 85.333h-256a42.667 42.667 0 0 1-42.666-42.666z"
  }));
};

var SvgAssetsMoreIcon = function SvgAssetsMoreIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "assets_more_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 853.333c-188.672 0-341.333-152.661-341.333-341.333 0-188.672 152.661-341.333 341.333-341.333 188.672 0 341.333 152.661 341.333 341.333 0 188.672-152.661 341.333-341.333 341.333zm0 85.334c235.776 0 426.667-190.891 426.667-426.667S747.776 85.333 512 85.333 85.333 276.224 85.333 512 276.224 938.667 512 938.667zm0-469.334a42.667 42.667 0 1 0 0 85.334 42.667 42.667 0 0 0 0-85.334zm-170.667 0a42.667 42.667 0 1 0 0 85.334 42.667 42.667 0 0 0 0-85.334zm341.334 0a42.667 42.667 0 1 0 0 85.334 42.667 42.667 0 0 0 0-85.334z"
  }));
};

var SvgAssureIcon = function SvgAssureIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "assure_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m549.547 919.637-38.528 19.03-38.059-19.84-14.25-7.296c-71.851-36.822-214.571-109.867-307.585-264.875-31.488-52.523-46.378-123.733-54.485-186.368-8.49-65.493-10.965-134.144-11.307-189.184a101.632 101.632 0 0 1 76.544-98.73L480.94 89.258a123.307 123.307 0 0 1 62.122 0l319.062 83.114a101.547 101.547 0 0 1 76.544 98.944c-.982 106.368-12.459 262.144-58.368 366.208-77.654 176.043-225.152 237.483-300.459 268.843-12.203 5.12-22.528 9.387-30.293 13.227zm-47.318-750.336-319.018 83.115a18.73 18.73 0 0 0-14.123 18.133c.683 106.966 9.6 259.755 54.101 333.91 9.728 16.213 20.096 31.445 30.934 45.653 66.688-73.6 155.477-109.781 252.245-109.781 103.339 0 197.12 41.472 264.917 123.562 11.691-17.749 22.528-37.461 32.214-59.434 38.528-87.296 50.432-228.011 51.413-333.91a18.688 18.688 0 0 0-14.08-18.133l-319.147-83.115a38.57 38.57 0 0 0-19.413 0zm213.59 560.427C662.997 657.792 588.8 623.915 506.325 623.915c-75.818 0-144.213 28.33-195.626 89.258 66.602 63.19 138.965 100.438 187.605 125.44l.085.043 13.568 6.997c11.435-5.674 24.747-11.306 39.254-17.493 48-20.523 109.653-46.89 164.608-98.432zM512.128 201.515c-86.528 0-156.63 69.29-156.63 154.752 0 85.418 70.102 154.709 156.587 154.709 86.528 0 156.672-69.29 156.672-154.71 0-85.46-70.144-154.709-156.629-154.709zm-71.979 154.752c0-39.296 32.214-71.168 72.022-71.168 39.765 0 72.021 31.872 72.021 71.168 0 39.253-32.256 71.125-72.021 71.125a71.595 71.595 0 0 1-72.022-71.125z"
  }));
};

var SvgBaseIcon = function SvgBaseIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "base_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M640 170.667A21.333 21.333 0 0 1 618.667 192H405.333a21.333 21.333 0 0 1 0-42.667h213.334A21.333 21.333 0 0 1 640 170.667zM618.667 64H405.333a106.667 106.667 0 0 0-97.792 64h-8.874A170.667 170.667 0 0 0 128 298.667v490.666A170.667 170.667 0 0 0 298.667 960h426.666A170.667 170.667 0 0 0 896 789.333V298.667A170.667 170.667 0 0 0 725.333 128h-8.874a106.667 106.667 0 0 0-97.792-64zm97.792 149.333h8.874a85.333 85.333 0 0 1 85.334 85.334v490.666a85.333 85.333 0 0 1-85.334 85.334H298.667a85.333 85.333 0 0 1-85.334-85.334V298.667a85.333 85.333 0 0 1 85.334-85.334h8.874a106.667 106.667 0 0 0 97.792 64h213.334a106.667 106.667 0 0 0 97.792-64zm-417.792 256c0-23.552 17.365-42.666 38.784-42.666h349.098c21.419 0 38.784 19.114 38.784 42.666S707.968 512 686.55 512H337.493c-21.461 0-38.826-19.115-38.826-42.667zm0 170.667c0-23.552 17.365-42.667 38.784-42.667h349.098c21.419 0 38.784 19.115 38.784 42.667s-17.365 42.667-38.784 42.667H337.493c-21.461 0-38.826-19.115-38.826-42.667z"
  }));
};

var SvgBatchIcon = function SvgBatchIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "batch_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M341.333 128A42.667 42.667 0 0 1 384 85.333h256a42.667 42.667 0 1 1 0 85.334H384A42.667 42.667 0 0 1 341.333 128zM256 213.333a42.667 42.667 0 0 0 0 85.334h512a42.667 42.667 0 1 0 0-85.334H256zm0 128A170.667 170.667 0 0 0 85.333 512v256A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V512A170.667 170.667 0 0 0 768 341.333H256zM170.667 512A85.333 85.333 0 0 1 256 426.667h512A85.333 85.333 0 0 1 853.333 512v256A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V512zm490.922 72.832a42.667 42.667 0 0 0-60.33-60.33L482.133 643.668 422.7 584.235a42.667 42.667 0 0 0-60.331 60.33l89.6 89.6a42.667 42.667 0 0 0 60.33 0l149.334-149.333z"
  }));
};

var SvgBellIcon = function SvgBellIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "bell_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 42.667a298.667 298.667 0 0 0-298.667 298.666c0 143.062-30.592 231.894-58.794 283.563a253.312 253.312 0 0 1-37.547 53.077 129.579 129.579 0 0 1-13.013 12.118l-.128.085A42.667 42.667 0 0 0 128 768h768a42.667 42.667 0 0 0 24.15-77.824l-.086-.085a129.792 129.792 0 0 1-13.056-12.075 253.397 253.397 0 0 1-37.547-53.12c-28.16-51.67-58.794-140.501-58.794-283.563A298.667 298.667 0 0 0 512 42.667zm292.267 640H219.733c3.2-5.334 6.486-10.966 9.728-16.896 35.84-65.664 69.206-168.832 69.206-324.438a213.333 213.333 0 1 1 426.666 0c0 155.606 33.408 258.774 69.206 324.438 3.242 5.973 6.528 11.562 9.77 16.896zM475.093 874.58a42.667 42.667 0 1 0-73.813 42.838 128 128 0 0 0 221.44 0 42.667 42.667 0 0 0-73.813-42.838 42.667 42.667 0 0 1-73.814 0z"
  }));
};

var SvgBookIcon = function SvgBookIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "book_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M277.333 170.667h533.334V640H277.333c-22.912 0-44.586 5.12-64 14.379V224c0-12.587 5.547-25.728 17.11-36.181a70.357 70.357 0 0 1 46.89-17.152zM128 224v576c0 38.315 16.939 74.027 45.355 99.584 28.288 25.43 65.706 39.083 103.978 39.083h533.334A85.333 85.333 0 0 0 896 853.333V170.667a85.333 85.333 0 0 0-85.333-85.334H277.333c-38.229 0-75.69 13.654-103.978 39.083A134.059 134.059 0 0 0 128 224zm149.333 501.333h533.334v128H277.333c-18.346 0-35.157-6.613-46.89-17.152A48.768 48.768 0 0 1 213.333 800v-10.667a64 64 0 0 1 64-64zm128-469.333a42.667 42.667 0 0 0 0 85.333h213.334a42.667 42.667 0 1 0 0-85.333H405.333z"
  }));
};

var SvgBotIcon = function SvgBotIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "bot_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M298.667 85.333A42.667 42.667 0 0 0 256 128v27.52A149.675 149.675 0 0 0 155.52 256H128a42.667 42.667 0 0 0 0 85.333h27.52A149.675 149.675 0 0 0 256 441.813v140.374a149.675 149.675 0 0 0-100.48 100.48H128A42.667 42.667 0 1 0 128 768h27.52A149.675 149.675 0 0 0 256 868.48V896a42.667 42.667 0 1 0 85.333 0v-27.52A149.675 149.675 0 0 0 441.813 768h140.374a149.675 149.675 0 0 0 100.48 100.48V896A42.667 42.667 0 1 0 768 896v-27.52A149.675 149.675 0 0 0 868.48 768H896a42.667 42.667 0 1 0 0-85.333h-27.52A149.675 149.675 0 0 0 768 582.187V441.813a149.675 149.675 0 0 0 100.48-100.48H896A42.667 42.667 0 1 0 896 256h-27.52A149.675 149.675 0 0 0 768 155.52V128a42.667 42.667 0 1 0-85.333 0v27.52A149.675 149.675 0 0 0 582.187 256H441.813a149.675 149.675 0 0 0-100.48-100.48V128a42.667 42.667 0 0 0-42.666-42.667zm42.666 356.48a149.675 149.675 0 0 0 100.48-100.48h140.374a149.675 149.675 0 0 0 100.48 100.48v140.374a149.675 149.675 0 0 0-100.48 100.48H441.813a149.675 149.675 0 0 0-100.48-100.48V441.813zm-42.666 219.52a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm362.666 64a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-490.666a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm-490.666 64a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
  }));
};

var SvgBottomLeftIcon = function SvgBottomLeftIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "bottom_left_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M343.424 620.373V300.928a42.667 42.667 0 0 0-85.333 0v421.973c0 23.766 19.285 43.094 43.093 43.094h421.973a42.667 42.667 0 1 0 0-85.334H403.712L755.2 329.216c15.616-15.616 14.763-41.813-1.92-58.453-16.64-16.64-42.837-17.494-58.453-1.878l-351.36 351.446z"
  }));
};

var SvgBottomRightIcon = function SvgBottomRightIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "bottom_right_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M620.245 680.661h-319.36a42.667 42.667 0 1 0 0 85.334H722.86a43.093 43.093 0 0 0 43.093-43.094V300.928a42.667 42.667 0 1 0-85.333 0v319.403L329.13 268.928c-15.616-15.659-41.814-14.805-58.454 1.877-16.64 16.64-17.493 42.838-1.92 58.454L620.203 680.66z"
  }));
};

var SvgBrokenIcon = function SvgBrokenIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "broken_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M203.093 451.84a43.008 43.008 0 1 0 11.094-85.333l-75.094-18.774a42.667 42.667 0 1 0-22.186 82.347L192 450.133a33.323 33.323 0 0 0 11.093 1.707zm164.694-238.507a42.667 42.667 0 0 0 42.666 31.574 34.987 34.987 0 0 0 11.094 0 42.667 42.667 0 0 0 29.866-52.054L431.36 117.76a42.667 42.667 0 1 0-82.347 22.187l18.774 73.386zM573.867 640A42.667 42.667 0 0 0 512 640L362.667 791.893a94.293 94.293 0 0 1-130.56 0 91.733 91.733 0 0 1 0-130.56L384 512a42.667 42.667 0 1 0-60.16-60.16L170.667 600.747a178.603 178.603 0 1 0 252.586 252.586L573.867 702.72a42.667 42.667 0 0 0 0-62.72zM221.013 281.173a42.667 42.667 0 0 0 60.16 0 42.667 42.667 0 0 0 0-60.16l-55.04-55.04a42.667 42.667 0 0 0-60.16 60.16l55.04 55.04zm686.08 312.747L832 573.867a42.667 42.667 0 1 0-21.333 82.346l75.093 20.054h11.093a43.008 43.008 0 1 0 11.094-85.334l-.854 2.987zm-250.88 216.747a42.667 42.667 0 0 0-82.346 22.186l20.053 75.094a42.667 42.667 0 0 0 42.667 31.573 48.19 48.19 0 0 0 11.093 0 42.795 42.795 0 0 0 30.293-52.48l-21.76-76.373zm146.774-66.987a42.667 42.667 0 0 0-60.16 60.16l55.04 55.04a42.667 42.667 0 0 0 60.16 0 42.667 42.667 0 0 0 0-60.16l-55.04-55.04zm101.546-445.013a177.493 177.493 0 0 0-303.786-128L450.133 322.56A43.605 43.605 0 0 0 512 384l149.333-151.893a94.293 94.293 0 0 1 130.56 0 91.733 91.733 0 0 1 0 130.56L640 512a42.667 42.667 0 0 0 0 60.16 42.667 42.667 0 0 0 60.16 0l153.173-148.907a178.773 178.773 0 0 0 51.2-124.586z"
  }));
};

var SvgBuyIcon = function SvgBuyIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "buy_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M128 853.333A85.333 85.333 0 0 1 42.667 768V256A85.333 85.333 0 0 1 128 170.667h768A85.333 85.333 0 0 1 981.333 256v512A85.333 85.333 0 0 1 896 853.333H128zM128 768h768V256H128v512zm128-85.333a42.667 42.667 0 1 1 0-85.334h128a42.667 42.667 0 1 1 0 85.334H256zm405.333-312.448a85.333 85.333 0 1 0 0 112.896 85.333 85.333 0 1 0 0-112.896z"
  }));
};

var SvgCalculatorIcon = function SvgCalculatorIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "calculator_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M128 234.667A170.667 170.667 0 0 1 298.667 64h426.666A170.667 170.667 0 0 1 896 234.667v554.666A170.667 170.667 0 0 1 725.333 960H298.667A170.667 170.667 0 0 1 128 789.333V234.667zm170.667-85.334a85.333 85.333 0 0 0-85.334 85.334v554.666a85.333 85.333 0 0 0 85.334 85.334h426.666a85.333 85.333 0 0 0 85.334-85.334V234.667a85.333 85.333 0 0 0-85.334-85.334H298.667zm0 149.334A85.333 85.333 0 0 1 384 213.333h256a85.333 85.333 0 0 1 85.333 85.334V384A85.333 85.333 0 0 1 640 469.333H384A85.333 85.333 0 0 1 298.667 384v-85.333zm341.333 0H384V384h256v-85.333zM384 597.333a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0zm170.667 0a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm128 42.667a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333zM384 746.667a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0zm128 42.666A42.667 42.667 0 1 0 512 704a42.667 42.667 0 0 0 0 85.333zm213.333-42.666a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0z"
  }));
};

var SvgCexHomeIcon = function SvgCexHomeIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "cex_home_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M469.333 149.333a405.333 405.333 0 1 1 0 810.667 405.333 405.333 0 0 1 0-810.667zm0-64C210.133 85.333 0 295.467 0 554.667S210.133 1024 469.333 1024s469.334-210.133 469.334-469.333S728.533 85.333 469.333 85.333zM272.94 646.955c9.898 3.882 20.992 5.845 33.237 5.845 16.64 0 30.592-3.84 41.728-11.435a82.773 82.773 0 0 0 26.88-32.426l-28.459-16.768a48.64 48.64 0 0 1-14.634 20.992c-6.571 5.674-15.062 8.533-25.515 8.533-13.141 0-23.595-4.267-31.403-12.8-7.594-8.661-11.434-21.077-11.434-37.205v-29.227c0-16 3.84-28.373 11.434-37.248 7.808-8.875 18.262-13.312 31.403-13.312 10.453 0 18.688 2.56 24.747 7.723a41.43 41.43 0 0 1 13.013 19.925l30.037-15.915c-6.57-14.378-15.36-25.088-26.325-32.213-10.965-7.083-24.832-10.624-41.472-10.624-12.245 0-23.339 2.133-33.28 6.4-9.728 4.267-18.133 10.539-25.216 18.859-6.912 8.149-12.245 18.346-15.957 30.592-3.755 12.074-5.59 25.898-5.59 41.472 0 15.616 1.835 29.354 5.547 41.216 3.755 11.69 9.088 21.546 16 29.525 7.083 7.979 15.488 13.995 25.259 18.09zM404.736 464v185.6h122.325v-31.104h-87.253v-47.36h77.141v-31.104h-77.141v-44.928h87.253v-31.147H404.736zm307.03 185.6h-40.96l-42.54-71.253h-.81L585.472 649.6h-38.315l60.118-95.19-57.472-90.453h40.96l39.381 65.963h.768L670.805 464h38.315l-57.984 90.41 60.63 95.19zm275.2-260.992a21.333 21.333 0 0 1-36.48-22.101A213.333 213.333 0 0 0 661.332 71.253 21.333 21.333 0 1 1 640 34.304a256 256 0 0 1 346.965 354.304z"
  }));
};

var SvgChartIcon = function SvgChartIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "chart_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M256 85.333A170.667 170.667 0 0 0 85.333 256v512A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V256A170.667 170.667 0 0 0 768 85.333H256zM170.667 256A85.333 85.333 0 0 1 256 170.667h512A85.333 85.333 0 0 1 853.333 256v512A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V256zm576 234.667a64 64 0 1 0-63.915-60.416L579.584 533.419a65.835 65.835 0 0 0-7.125 0l-82.219-82.176a64 64 0 1 0-127.147 0l-82.218 82.176a64 64 0 1 0 60.33 60.33l85.462-85.376 85.418 85.419a64 64 0 1 0 127.787 0l103.253-103.168 3.542.085z"
  }));
};

var SvgCheckCircleIcon = function SvgCheckCircleIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "check_circle_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M128 512a384 384 0 1 1 768 0 384 384 0 0 1-768 0zM512 42.667C252.8 42.667 42.667 252.8 42.667 512S252.8 981.333 512 981.333 981.333 771.2 981.333 512 771.2 42.667 512 42.667zm222.55 392.448a42.667 42.667 0 1 0-61.1-59.563L453.29 601.344l-103.85-98.901a42.667 42.667 0 1 0-58.88 61.781l134.101 127.701c17.067 16.299 44.118 15.787 60.587-1.109l249.301-255.701z"
  }));
};

var SvgCheckIcon = function SvgCheckIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "check_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M883.499 225.835a42.667 42.667 0 0 1 0 60.33L414.165 755.5a42.667 42.667 0 0 1-60.33 0L140.5 542.165a42.667 42.667 0 1 1 60.331-60.33L384 665.003l439.168-439.168a42.667 42.667 0 0 1 60.33 0z"
  }));
};

var SvgCircleIcon = function SvgCircleIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "circle_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 42.667C252.8 42.667 42.667 252.8 42.667 512S252.8 981.333 512 981.333 981.333 771.2 981.333 512 771.2 42.667 512 42.667zm222.55 392.448L485.247 690.816a43.093 43.093 0 0 1-60.587 1.11l-134.1-127.703a42.667 42.667 0 1 1 58.88-61.781l103.85 98.901 220.16-225.792a42.667 42.667 0 1 1 61.1 59.563z"
  }));
};

var SvgCirclepromptIcon = function SvgCirclepromptIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "circleprompt_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768zM42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512 771.2 981.333 512 981.333 42.667 771.2 42.667 512zm426.666 170.667A42.667 42.667 0 0 1 512 640h.427a42.667 42.667 0 1 1 0 85.333H512a42.667 42.667 0 0 1-42.667-42.666zm85.334-341.334a42.667 42.667 0 1 0-85.334 0V512a42.667 42.667 0 1 0 85.334 0V341.333z"
  }));
};

var SvgClearIcon = function SvgClearIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "clear_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M227.456 938.667A128 128 0 0 1 100.949 791.21l59.094-384a128 128 0 0 1 126.506-108.544h54.784v-85.334a170.667 170.667 0 0 1 341.334 0v85.334h54.784A128 128 0 0 1 863.957 407.21l59.094 384a128 128 0 0 1-126.507 147.456h-569.13zm199.21-725.334V320a64 64 0 0 1-64 64H286.55a42.667 42.667 0 0 0-42.197 36.181L230.272 512h563.499l-14.123-91.819A42.667 42.667 0 0 0 737.451 384h-76.118a64 64 0 0 1-64-64V213.333a85.333 85.333 0 1 0-170.666 0zm-209.535 384L185.3 804.181a42.667 42.667 0 0 0 42.112 49.152h369.92v-128a42.667 42.667 0 1 1 85.334 0v128h113.877a42.667 42.667 0 0 0 42.155-49.152l-31.83-206.848H217.173z"
  }));
};

var SvgCloseIcon = function SvgCloseIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "close_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M723.2 783.53a42.667 42.667 0 0 0 60.33-60.33L572.33 512l211.2-211.2a42.667 42.667 0 0 0-60.33-60.33L512 451.67l-211.2-211.2a42.667 42.667 0 0 0-60.33 60.33L451.67 512l-211.2 211.2a42.667 42.667 0 1 0 60.33 60.33L512 572.33l211.2 211.2z"
  }));
};

var SvgCoinComingIcon = function SvgCoinComingIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_coming_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M896 512a384 384 0 1 0-768 0 384 384 0 0 0 768 0zM512 42.667C771.2 42.667 981.333 252.8 981.333 512S771.2 981.333 512 981.333 42.667 771.2 42.667 512 252.8 42.667 512 42.667zM554.667 256a42.667 42.667 0 1 0-85.334 0v256a42.667 42.667 0 0 0 23.595 38.144l170.667 85.333a42.667 42.667 0 1 0 38.144-76.288l-147.072-73.557V256z"
  }));
};

var SvgCoinCountdownIcon = function SvgCoinCountdownIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_countdown_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M213.333 85.333a42.667 42.667 0 0 0 0 85.334H256v154.24a128 128 0 0 0 23.467 73.813l77.61 109.995a42.667 42.667 0 0 1 0 49.237l-77.653 109.995A128 128 0 0 0 256 741.76v111.573h-42.667a42.667 42.667 0 1 0 0 85.334h597.334a42.667 42.667 0 1 0 0-85.334H768V741.76a128 128 0 0 0-23.467-73.813l-77.61-109.995a42.667 42.667 0 0 1 0-49.237l77.653-109.995A128 128 0 0 0 768 324.907v-154.24h42.667a42.667 42.667 0 1 0 0-85.334H213.333zm469.334 85.334V256H341.333v-85.333h341.334zm-3.286 170.666a42.539 42.539 0 0 1-4.522 8.192L597.205 459.52a128 128 0 0 0 0 147.627l48.64 68.949h-267.69l48.64-68.95a128 128 0 0 0 0-147.626l-77.611-109.995a42.667 42.667 0 0 1-4.565-8.192H679.38zm3.286 420.096v91.904H341.333V761.43h341.334z"
  }));
};

var SvgCoinIneffectIcon = function SvgCoinIneffectIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_ineffect_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M840.619 254.976c8.277 2.133 12.8 9.088 12.714 15.573-.981 105.728-12.885 245.888-51.114 332.544-63.147 143.104-181.632 193.878-255.232 224.512l-1.579.683c-10.752 4.437-23.125 9.6-33.408 14.677l-14.336-7.381h-.043c-71.21-36.48-193.834-100.395-273.322-232.832-21.931-36.565-35.2-92.8-43.051-153.43-7.85-60.586-10.24-125.397-10.581-178.773a16.299 16.299 0 0 1 12.714-15.573l319.062-83.072a37.973 37.973 0 0 1 19.114 0l319.062 83.072zm-329.6 683.69 38.485-19.029c7.808-3.84 18.133-8.149 30.293-13.226 75.35-31.403 222.806-92.843 300.502-268.886 45.909-104.106 57.386-259.84 58.368-366.208a101.547 101.547 0 0 0-76.544-98.901L543.06 89.301a123.307 123.307 0 0 0-62.122 0l-319.062 83.115a101.632 101.632 0 0 0-76.544 98.688c.342 55.04 2.816 123.69 11.307 189.184 8.107 62.677 22.997 133.845 54.485 186.368C244.14 801.664 386.86 874.709 458.752 911.531l14.208 7.296 38.059 19.84zM712.02 353.025a42.667 42.667 0 0 1 1.622 60.33L511.317 626.689a42.667 42.667 0 0 1-61.909 0l-96.384-101.547a42.667 42.667 0 1 1 61.952-58.752l65.365 68.95 171.35-180.694a42.667 42.667 0 0 1 60.33-1.621z"
  }));
};

var SvgCoinProtectIcon = function SvgCoinProtectIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_protect_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M840.619 254.976c8.277 2.133 12.8 9.088 12.714 15.573-.981 105.728-12.885 245.888-51.114 332.544-63.147 143.104-181.632 193.878-255.232 224.512l-1.579.683c-10.752 4.437-23.125 9.6-33.408 14.677l-14.336-7.381h-.043c-71.21-36.48-193.834-100.395-273.322-232.832-21.931-36.565-35.2-92.8-43.051-153.43-7.85-60.586-10.24-125.397-10.581-178.773a16.299 16.299 0 0 1 12.714-15.573l319.062-83.072a37.973 37.973 0 0 1 19.114 0l319.062 83.072zm-329.6 683.69 38.485-19.029c7.808-3.84 18.133-8.149 30.293-13.226 75.35-31.403 222.806-92.843 300.502-268.886 45.909-104.106 57.386-259.84 58.368-366.208a101.547 101.547 0 0 0-76.544-98.901L543.06 89.301a123.307 123.307 0 0 0-62.122 0l-319.062 83.115a101.632 101.632 0 0 0-76.544 98.688c.342 55.04 2.816 123.69 11.307 189.184 8.107 62.677 22.997 133.845 54.485 186.368C244.14 801.664 386.86 874.709 458.752 911.531l14.208 7.296 38.059 19.84zm-41.686-256a42.667 42.667 0 1 0 85.334 0 42.667 42.667 0 1 0-85.334 0Zm42.667-384a42.667 42.667 0 0 1 42.667 42.667v213.334a42.667 42.667 0 1 1-85.334 0V341.333A42.667 42.667 0 0 1 512 298.667z"
  }));
};

var SvgCoinRemovedIcon = function SvgCoinRemovedIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_removed_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M213.333 170.667a42.667 42.667 0 0 0-42.666 42.666V640a42.667 42.667 0 0 0 42.666 42.667H256A42.667 42.667 0 1 1 256 768h-42.667a128 128 0 0 1-128-128V213.333a128 128 0 0 1 128-128h597.334a128 128 0 0 1 128 128V640a128 128 0 0 1-128 128H768a42.667 42.667 0 1 1 0-85.333h42.667A42.667 42.667 0 0 0 853.333 640V213.333a42.667 42.667 0 0 0-42.666-42.666H213.333zM298.667 384a42.667 42.667 0 0 1 42.666-42.667h341.334a42.667 42.667 0 1 1 0 85.334H341.333A42.667 42.667 0 0 1 298.667 384zM512 512a42.667 42.667 0 0 1 42.667 42.667v238.336l55.168-55.168a42.667 42.667 0 0 1 60.33 60.33l-128 128a42.667 42.667 0 0 1-60.33 0l-128-128a42.667 42.667 0 1 1 60.33-60.33l55.168 55.168V554.667A42.667 42.667 0 0 1 512 512z"
  }));
};

var SvgCoinWarnIcon = function SvgCoinWarnIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coin_warn_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M853.333 270.507a16.256 16.256 0 0 0-12.714-15.531l-319.062-83.03a37.973 37.973 0 0 0-19.114 0l-319.062 83.03a16.299 16.299 0 0 0-12.714 15.573c.341 53.376 2.73 118.187 10.581 178.774 7.85 60.629 21.12 116.864 43.093 153.429 79.446 132.437 202.07 196.352 273.28 232.832h.086L512 842.965c10.283-5.077 22.656-10.24 33.408-14.677l1.579-.683c73.6-30.634 192.085-81.408 255.232-224.512 38.229-86.656 50.133-226.816 51.114-332.544zm-303.786 649.13-38.528 19.03-38.059-19.84-14.25-7.296c-71.851-36.822-214.571-109.867-307.585-264.875-31.488-52.523-46.378-123.733-54.485-186.368-8.49-65.493-10.965-134.144-11.307-189.184a101.632 101.632 0 0 1 76.544-98.73L480.94 89.258a123.307 123.307 0 0 1 62.122 0l319.062 83.114a101.547 101.547 0 0 1 76.544 98.944c-.982 106.368-12.459 262.144-58.368 366.208-77.654 176.043-225.152 237.483-300.459 268.843-12.203 5.12-22.528 9.387-30.293 13.227zm122.88-498.389a19.2 19.2 0 0 1 7.85 6.827 14.123 14.123 0 0 1-1.706 17.664L507.776 633.045a20.864 20.864 0 0 1-7.595 5.12 25.899 25.899 0 0 1-16.298.982 21.717 21.717 0 0 1-10.667-6.187 14.848 14.848 0 0 1-4.096-9.984V520.832H362.41a25.045 25.045 0 0 1-11.52-3.2 18.133 18.133 0 0 1-7.466-7.68 14.08 14.08 0 0 1 1.707-17.067l170.794-187.221a21.803 21.803 0 0 1 10.71-6.187c4.266-1.109 8.96-1.066 13.226.043 4.438 1.152 8.32 3.413 10.966 6.528a14.635 14.635 0 0 1 3.754 10.496v102.144h106.752c3.926 0 7.808.853 11.136 2.56z"
  }));
};

var SvgCommentIcon = function SvgCommentIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "comment_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 384a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 512 384zM810.667 85.333H213.333a128 128 0 0 0-128 128V640a128 128 0 0 0 128 128H707.84l157.867 158.293A42.667 42.667 0 0 0 896 938.667a35.84 35.84 0 0 0 16.213-3.414A42.667 42.667 0 0 0 938.667 896V213.333a128 128 0 0 0-128-128zm42.666 707.84-97.706-98.133a42.667 42.667 0 0 0-30.294-12.373h-512A42.667 42.667 0 0 1 170.667 640V213.333a42.667 42.667 0 0 1 42.666-42.666h597.334a42.667 42.667 0 0 1 42.666 42.666v579.84zM341.333 384a42.667 42.667 0 1 0 0 85.333 42.667 42.667 0 0 0 0-85.333zm341.334 0a42.667 42.667 0 1 0 0 85.333 42.667 42.667 0 0 0 0-85.333z"
  }));
};

var SvgContinuousdrawingIcon = function SvgContinuousdrawingIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "continuousdrawing_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M895.936 85.312h-512A42.688 42.688 0 0 0 341.248 128v170.688h-85.312a42.688 42.688 0 0 0-42.688 42.688V512h-85.312a42.688 42.688 0 0 0-42.688 42.688V896a42.688 42.688 0 0 0 42.688 42.688h341.312A42.688 42.688 0 0 0 511.936 896v-85.312H682.56A42.688 42.688 0 0 0 725.248 768v-85.312h170.688A42.688 42.688 0 0 0 938.56 640V128A42.688 42.688 0 0 0 896 85.312zm-469.376 768h-256v-256h256v256zm213.376-128h-128v-170.56A42.688 42.688 0 0 0 469.248 512H298.56V384H640v341.376zm213.312-128h-128v-256a42.688 42.688 0 0 0-42.688-42.624h-256v-128h426.688v426.688z"
  }));
};

var SvgCopyIcon = function SvgCopyIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "copy_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M469.333 85.333a128 128 0 0 0-128 128v128h-128a128 128 0 0 0-128 128v341.334a128 128 0 0 0 128 128h341.334a128 128 0 0 0 128-128v-128h128a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H469.333zm341.334 512H469.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666h341.334a42.667 42.667 0 0 1 42.666 42.666v341.334a42.667 42.667 0 0 1-42.666 42.666zM341.333 426.667v128a128 128 0 0 0 128 128h128v128a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V469.333a42.667 42.667 0 0 1 42.666-42.666h128z"
  }));
};

var SvgCopytradingIcon = function SvgCopytradingIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "copytrading_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M238.933 307.157a341.461 341.461 0 0 1 608.64 142.08 42.667 42.667 0 1 0 83.926-15.573C894.677 235.434 720.896 85.334 512 85.334a425.941 425.941 0 0 0-339.072 167.68l-3.157-18.945a42.667 42.667 0 0 0-84.182 14.08l20.822 124.416a42.667 42.667 0 0 0 49.109 35.072l124.459-20.821a42.667 42.667 0 1 0-14.08-84.181l-26.923 4.522zm-50.048 315.136a42.667 42.667 0 1 0-80.768 27.563C165.42 817.792 324.523 938.666 512 938.666c121.088 0 230.4-50.517 308.01-131.413l2.049 20.694a42.667 42.667 0 0 0 84.906-8.448l-12.501-125.867a42.667 42.667 0 0 0-46.72-38.23L721.92 667.948a42.667 42.667 0 1 0 8.448 84.906l26.027-2.56a341.504 341.504 0 0 1-567.51-128zm122.027 10.24a42.667 42.667 0 0 1-42.667-42.666A170.667 170.667 0 0 1 438.912 419.2a42.667 42.667 0 1 1 0 85.333 85.333 85.333 0 0 0-73.941 42.667h47.274l.256.341a42.667 42.667 0 0 1-5.589 84.95h-96zm170.667-282.709a58.667 58.667 0 1 1-117.334 0 58.667 58.667 0 0 1 117.334 0zm192 32a58.667 58.667 0 1 1-117.334 0 58.667 58.667 0 0 1 117.334 0zm-213.334 224a154.667 154.667 0 0 1 309.334 0v16a42.667 42.667 0 0 1-42.667 42.667h-224a42.667 42.667 0 0 1-42.667-42.667v-15.957zm218.667-26.667a69.376 69.376 0 0 0-128 0h128z"
  }));
};

var SvgCouponIcon = function SvgCouponIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "coupon_icon_svg__icon",
    viewBox: "0 0 1066 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M149.333 213.333a64 64 0 0 0-64 64v128c0 37.12 29.227 59.563 54.272 65.28 22.059 5.078 35.712 22.998 35.712 41.387 0 18.39-13.653 36.31-35.712 41.387-25.045 5.674-54.272 28.16-54.272 65.28v128a64 64 0 0 0 64 64h768a64 64 0 0 0 64-64V597.419c0-23.638-19.2-42.752-42.752-42.752-28.416 0-47.402-21.248-47.402-42.667s18.986-42.667 47.36-42.667c23.68 0 42.794-19.114 42.794-42.752V277.333a64 64 0 0 0-64-64h-768zm21.334 177.494v-92.16h182.485v17.792a42.667 42.667 0 0 0 85.333 0v-17.792H896v92.16c-51.456 16.81-90.155 63.445-90.155 121.173S844.544 616.363 896 633.173v92.16H438.485v-17.792a42.667 42.667 0 1 0-85.333 0v17.792H170.667v-92.16C221.824 616.363 260.65 569.6 260.65 512s-38.827-104.363-89.984-121.173zm267.818 50.048a42.667 42.667 0 1 0-85.333 0v124.458a42.667 42.667 0 1 0 85.333 0V440.875z"
  }));
};

var SvgCrossIcon = function SvgCrossIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "cross_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M469.333 655.147V896a42.667 42.667 0 1 0 85.334 0V655.147a149.675 149.675 0 0 0 100.48-100.48H896a42.667 42.667 0 1 0 0-85.334H655.147a149.675 149.675 0 0 0-100.48-100.48V128a42.667 42.667 0 1 0-85.334 0v240.853a149.675 149.675 0 0 0-100.48 100.48H128a42.667 42.667 0 1 0 0 85.334h240.853a149.675 149.675 0 0 0 100.48 100.48zM448 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
  }));
};

var SvgCumulativeincomeIcon = function SvgCumulativeincomeIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "cumulativeincome_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M746.667 85.333a42.667 42.667 0 1 0 0 85.334h46.336l-128 128h-323.67a42.667 42.667 0 0 0-24.448 7.68L103.552 455.68a42.667 42.667 0 1 0 48.939 69.973L354.773 384h327.894a42.667 42.667 0 0 0 30.165-12.501l213.333-213.334A42.667 42.667 0 0 0 896 85.333H746.667zm149.333 256A42.667 42.667 0 0 1 938.667 384v512a42.667 42.667 0 1 1-85.334 0V384A42.667 42.667 0 0 1 896 341.333zM682.667 512a42.667 42.667 0 1 0-85.334 0v384a42.667 42.667 0 1 0 85.334 0V512zM384 554.667a42.667 42.667 0 0 1 42.667 42.666V896a42.667 42.667 0 1 1-85.334 0V597.333A42.667 42.667 0 0 1 384 554.667zM128 640a42.667 42.667 0 0 1 42.667 42.667V896a42.667 42.667 0 1 1-85.334 0V682.667A42.667 42.667 0 0 1 128 640z"
  }));
};

var SvgCutoverIcon = function SvgCutoverIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "cutover_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M496.896 700.501a38.613 38.613 0 0 0-57.813 0l-79.147 85.931V385.365a42.667 42.667 0 0 0-85.333 0v398.55l-76.8-83.414a38.613 38.613 0 0 0-57.814 0 47.147 47.147 0 0 0 0 62.763l149.547 162.39a38.613 38.613 0 0 0 57.813 0l149.547-162.39a47.147 47.147 0 0 0 0-62.763zm387.285-376.746a38.23 38.23 0 0 1-57.514 0l-77.782-85.163v399.701a42.667 42.667 0 0 1-85.333 0V241.067l-75.435 82.645a38.23 38.23 0 0 1-57.557 0 47.616 47.616 0 0 1 0-63.019L678.613 98.56a38.23 38.23 0 0 1 57.558 0l148.053 162.133c15.872 17.408 15.872 45.654 0 63.019z"
  }));
};

var SvgDataIcon = function SvgDataIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "data_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M768 85.333H256A170.667 170.667 0 0 0 85.333 256v512A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V256A170.667 170.667 0 0 0 768 85.333zM170.667 256A85.333 85.333 0 0 1 256 170.667h512A85.333 85.333 0 0 1 853.333 256v512A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V256zm554.666 256A42.667 42.667 0 1 0 640 512v213.333a42.667 42.667 0 1 0 85.333 0V512zM512 256a42.667 42.667 0 0 1 42.667 42.667v426.666a42.667 42.667 0 1 1-85.334 0V298.667A42.667 42.667 0 0 1 512 256zM384 426.667a42.667 42.667 0 0 0-85.333 0v298.666a42.667 42.667 0 1 0 85.333 0V426.667z"
  }));
};

var SvgDateIcon = function SvgDateIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "date_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M810.667 170.667h-85.334V128A42.667 42.667 0 0 0 640 128v42.667H384V128a42.667 42.667 0 0 0-85.333 0v42.667h-85.334a128 128 0 0 0-128 128v512a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128v-512a128 128 0 0 0-128-128zm42.666 640a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V512h682.666v298.667zm0-384H170.667v-128A42.667 42.667 0 0 1 213.333 256h85.334v42.667a42.667 42.667 0 0 0 85.333 0V256h256v42.667a42.667 42.667 0 0 0 85.333 0V256h85.334a42.667 42.667 0 0 1 42.666 42.667v128z"
  }));
};

var SvgDepositIcon = function SvgDepositIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "deposit_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M656 70.144a85.333 85.333 0 0 1 99.243 63.317l43.52 176.598a42.539 42.539 0 0 1-4.352 31.274h16.256A85.333 85.333 0 0 1 896 426.667v143.445h16.47a42.667 42.667 0 1 1 0 85.333H896v197.888a85.333 85.333 0 0 1-85.333 85.334H213.333A85.333 85.333 0 0 1 128 853.333V578.39a42.453 42.453 0 0 1-11.05-20.522L55.082 276.565a85.333 85.333 0 0 1 66.986-102.101L656 70.144zm154.667 499.968V426.667H213.333v426.666h597.334V655.445H616.576l42.581 41.643a42.667 42.667 0 0 1-59.69 61.013l-150.614-147.37 152.662-131.115a42.667 42.667 0 0 1 55.552 64.81l-29.995 25.729h183.595zm-94.72-239.659L672.427 153.9 138.41 258.219l22.272 101.29c14.506-11.392 32.81-18.176 52.65-18.176h506.88a42.837 42.837 0 0 1-4.309-10.88z"
  }));
};

var SvgDetailsIcon = function SvgDetailsIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "details_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M192 320a64 64 0 1 0 0-128 64 64 0 0 0 0 128zm0 256a64 64 0 1 0 0-128 64 64 0 0 0 0 128zm64 192a64 64 0 1 1-128 0 64 64 0 0 1 128 0zm128-512a42.667 42.667 0 0 0 42.667 42.667h426.666a42.667 42.667 0 1 0 0-85.334H426.667A42.667 42.667 0 0 0 384 256zm0 256a42.667 42.667 0 0 0 42.667 42.667h426.666a42.667 42.667 0 1 0 0-85.334H426.667A42.667 42.667 0 0 0 384 512zm42.667 298.667a42.667 42.667 0 1 1 0-85.334h426.666a42.667 42.667 0 1 1 0 85.334H426.667z"
  }));
};

var SvgDirectiondownIcon = function SvgDirectiondownIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "directiondown_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M554.667 707.84 780.5 482.005a42.667 42.667 0 0 1 60.331 60.331L542.464 840.704a43.093 43.093 0 0 1-60.928 0L183.168 542.336a42.667 42.667 0 1 1 60.33-60.33L469.334 707.84V210.859c0-22.102 19.115-40.022 42.667-40.022s42.667 17.92 42.667 40.022V707.84z"
  }));
};

var SvgDirectionleftIcon = function SvgDirectionleftIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "directionleft_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M316.245 469.419 542.08 243.584a42.667 42.667 0 1 0-60.33-60.33L183.38 481.62a43.093 43.093 0 0 0 0 60.928l298.37 298.369a42.667 42.667 0 0 0 60.331-60.33L316.245 554.752h496.982c22.101 0 40.021-19.115 40.021-42.667s-17.92-42.666-40.021-42.666H316.245z"
  }));
};

var SvgDirectionrightIcon = function SvgDirectionrightIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "directionright_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M707.755 554.752 481.92 780.587a42.667 42.667 0 1 0 60.33 60.33L840.62 542.55a43.093 43.093 0 0 0 0-60.928L542.293 183.253a42.667 42.667 0 1 0-60.33 60.331l225.834 225.835H210.773c-22.101 0-40.021 19.114-40.021 42.666s17.92 42.667 40.021 42.667h496.982z"
  }));
};

var SvgDirectionupIcon = function SvgDirectionupIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "directionup_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M554.667 316.33 780.5 542.166a42.667 42.667 0 0 0 60.331-60.33L542.464 183.467a43.093 43.093 0 0 0-60.928 0L183.168 481.835a42.667 42.667 0 1 0 60.33 60.33l225.835-225.834v496.981c0 22.101 19.115 40.021 42.667 40.021s42.667-17.92 42.667-40.021V316.331z"
  }));
};

var SvgDiscordIcon = function SvgDiscordIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M20.857 5.384s-1.72-1.82-5.623-2.084v.575s2.141-.125 4.792 2.485C18.025 4.92 15.17 4.018 12 4.018c-3.17 0-6.025.902-8.026 2.342 2.651-2.61 4.792-2.485 4.792-2.485V3.3c-3.904.264-5.623 2.084-5.623 2.084C.168 9.216 0 17.599 0 17.599c2.802 3.378 6.323 2.947 6.323 2.947l1.294-1.869c-1.668-.45-2.86-1.487-3.575-2.293 1.997 1.411 4.823 2.293 7.958 2.293s5.96-.882 7.958-2.293c-.716.806-1.907 1.842-3.575 2.293l1.294 1.869s3.52.43 6.323-2.947c0 0-.168-8.383-3.143-12.215ZM8.264 15.228c-1.125 0-2.036-.968-2.036-2.163 0-1.195.911-2.163 2.036-2.163 1.124 0 2.036.968 2.036 2.163 0 1.195-.912 2.163-2.036 2.163Zm7.473 0c-1.125 0-2.036-.968-2.036-2.163 0-1.195.911-2.163 2.036-2.163 1.124 0 2.036.968 2.036 2.163 0 1.195-.912 2.163-2.036 2.163Z"
  }));
};

var SvgDownload2Icon = function SvgDownload2Icon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M8.29 13.29a1 1 0 0 0 0 1.42l3 3a1.002 1.002 0 0 0 1.42 0l3-3a1.004 1.004 0 1 0-1.42-1.42L13 14.59V3a1 1 0 0 0-2 0v11.59l-1.29-1.3a1 1 0 0 0-1.42 0ZM18 9h-2a1 1 0 1 0 0 2h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h2a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a3 3 0 0 0-3-3Z"
  }));
};

var SvgDownloadIcon = function SvgDownloadIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "download_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m610.56 737.579-55.083 55.466V554.411a42.667 42.667 0 0 0-85.418 0v238.634l-55.083-55.466a42.88 42.88 0 0 0-60.672 60.586l128.128 128.128a42.667 42.667 0 0 0 14.08 8.96 40.107 40.107 0 0 0 32.47 0 42.667 42.667 0 0 0 14.08-8.96l128.127-128.085a42.837 42.837 0 1 0-60.586-60.63zm176.384-472.662a298.88 298.88 0 0 0-486.699-90.837 298.837 298.837 0 0 0-83.882 171.605 170.837 170.837 0 0 0-73.472 293.888 170.88 170.88 0 0 0 113.621 42.966 42.71 42.71 0 1 0 0-85.419 85.419 85.419 0 1 1 0-170.752 42.71 42.71 0 0 0 42.71-42.667 213.419 213.419 0 0 1 178.687-210.176 213.59 213.59 0 0 1 236.843 141.398 42.667 42.667 0 0 0 33.323 28.586 128.128 128.128 0 0 1 10.24 249.387 42.752 42.752 0 1 0 21.333 82.773 213.547 213.547 0 0 0 118.059-332.074 213.504 213.504 0 0 0-110.763-78.635z"
  }));
};

var SvgDragdropIcon = function SvgDragdropIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "dragdrop_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M384 298.667A85.333 85.333 0 1 0 384 128a85.333 85.333 0 0 0 0 170.667zm256 0A85.333 85.333 0 1 0 640 128a85.333 85.333 0 0 0 0 170.667zM469.333 512a85.333 85.333 0 1 1-170.666 0 85.333 85.333 0 0 1 170.666 0zM640 597.333a85.333 85.333 0 1 0 0-170.666 85.333 85.333 0 0 0 0 170.666zM469.333 810.667a85.333 85.333 0 1 1-170.666 0 85.333 85.333 0 0 1 170.666 0zM640 896a85.333 85.333 0 1 0 0-170.667A85.333 85.333 0 0 0 640 896z"
  }));
};

var SvgDrawingIcon = function SvgDrawingIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "drawing_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M853.312 690.368V333.632a128 128 0 1 0-163.008-162.944H333.632a128 128 0 1 0-163.008 162.944v356.736a128 128 0 1 0 163.008 162.944h356.672a128 128 0 1 0 163.008-162.944zm-42.688-519.68a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312zm-597.312 0a42.688 42.688 0 1 1 0 85.312 42.688 42.688 0 0 1 0-85.312zm0 682.624a42.624 42.624 0 1 1 0-85.248 42.624 42.624 0 0 1 0 85.248zM690.304 768H333.632A128 128 0 0 0 256 690.368V333.632A128 128 0 0 0 333.632 256h356.672A128.064 128.064 0 0 0 768 333.632v356.736A128 128 0 0 0 690.368 768zm120.32 85.312a42.688 42.688 0 1 1 0-85.312 42.688 42.688 0 0 1 0 85.312z"
  }));
};

var SvgEarningstodayIcon = function SvgEarningstodayIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "earningstoday_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M170.667 512a341.333 341.333 0 1 1 182.528 302.208 42.667 42.667 0 0 0-39.766 75.52A424.96 424.96 0 0 0 512 938.667c235.648 0 426.667-191.019 426.667-426.667S747.648 85.333 512 85.333 85.333 276.352 85.333 512c0 63.147 13.739 123.136 38.4 177.152a42.667 42.667 0 0 0 73.942 6.528l145.792-97.195 96.853 64.598a42.667 42.667 0 0 0 53.845-5.334l241.067-241.066a42.667 42.667 0 0 0-30.165-72.832H584.533a42.667 42.667 0 0 0 0 85.333h17.494L458.58 572.672l-91.434-60.97a42.667 42.667 0 0 0-47.36 0l-136.875 91.306A341.76 341.76 0 0 1 170.667 512z"
  }));
};

var SvgEarphoneIcon = function SvgEarphoneIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "earphone_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M258.56 247.637c34.304-43.818 102.57-76.97 253.44-76.97 150.912 0 219.179 33.152 253.44 76.97 33.195 42.496 43.477 105.216 45.013 195.2A128.043 128.043 0 0 0 682.667 570.88v95.573a128 128 0 0 0 84.181 120.32c-1.963 14.336-6.144 23.168-10.752 29.099-6.4 8.277-18.005 16.512-41.13 23.04-23.467 6.699-54.955 10.496-96.854 12.459-41.643 1.962-90.71 1.962-148.779 1.962a42.667 42.667 0 1 0 0 85.334h.854c57.045 0 108.074 0 151.893-2.048 43.776-2.048 83.157-6.23 116.181-15.574 33.366-9.429 63.787-25.173 85.248-52.906 17.878-23.04 26.582-50.475 29.056-80.768a128 128 0 0 0 86.102-120.918V570.88c0-37.717-16.427-72.107-43.094-95.744.299-1.92.427-3.84.427-5.803 0-101.888-6.656-201.728-63.36-274.261C773.76 119.765 671.36 85.333 512 85.333c-159.403 0-261.803 34.432-320.64 109.739C134.656 267.605 128 367.445 128 469.333c0 1.963.128 3.926.427 5.803a127.915 127.915 0 0 0-43.094 95.787v95.53a128 128 0 0 0 256 0V570.88a128.043 128.043 0 0 0-127.786-128c1.536-90.027 11.818-152.747 45.056-195.243zM256 570.88v95.53a42.667 42.667 0 0 1-85.333 0v-95.573a42.667 42.667 0 1 1 85.333 0zm562.005 137.515A42.667 42.667 0 0 1 768 666.453V570.88a42.667 42.667 0 0 1 85.333 0v95.573a42.667 42.667 0 0 1-35.328 41.984z"
  }));
};

var SvgEditIcon = function SvgEditIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "edit_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M819.499 136.832a47.83 47.83 0 0 1 67.669 67.67l-396.97 396.97-90.24 22.57 22.57-90.24 396.97-396.97zm33.834-99.285a133.182 133.182 0 0 0-94.165 38.997L353.835 481.877a42.667 42.667 0 0 0-11.222 19.84l-42.666 170.667a42.667 42.667 0 0 0 51.754 51.712l170.667-42.667a42.624 42.624 0 0 0 19.797-11.221L947.5 264.875a133.163 133.163 0 0 0-94.166-227.328zm-640 47.786a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V512a42.667 42.667 0 1 0-85.334 0v298.667a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666H512a42.667 42.667 0 1 0 0-85.334H213.333z"
  }));
};

var SvgEmptyIcon = function SvgEmptyIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "empty_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 981.333c259.2 0 469.333-210.133 469.333-469.333S771.2 42.667 512 42.667 42.667 252.8 42.667 512 252.8 981.333 512 981.333zM353.835 353.835a42.667 42.667 0 0 1 60.33 0L512 451.669l97.835-97.834a42.667 42.667 0 1 1 60.33 60.33L572.331 512l97.834 97.835a42.667 42.667 0 0 1-60.33 60.33L512 572.331l-97.835 97.834a42.667 42.667 0 0 1-60.33-60.33L451.669 512l-97.834-97.835a42.667 42.667 0 0 1 0-60.33z"
  }));
};

var SvgExchangeIcon = function SvgExchangeIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "exchange_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M656.213 661.76h193.28A42.667 42.667 0 0 1 890.88 704v192a42.667 42.667 0 0 1-85.333 0v-75.52A426.667 426.667 0 0 1 85.333 512a42.667 42.667 0 1 1 85.334 0 341.333 341.333 0 0 0 587.946 235.093h-102.4a42.667 42.667 0 0 1 0-85.333zm-437.76-458.24A426.667 426.667 0 0 1 512 85.333 426.667 426.667 0 0 1 938.667 512a42.667 42.667 0 0 1-85.334 0 341.333 341.333 0 0 0-587.946-234.667h102.4a42.667 42.667 0 0 1 0 85.334h-192A42.667 42.667 0 0 1 133.12 320V128a42.667 42.667 0 0 1 85.333 0v75.52zM469.333 512a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0zM512 384a128 128 0 1 0 0 256 128 128 0 0 0 0-256z"
  }));
};

var SvgExitDrawingIcon = function SvgExitDrawingIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "exit-drawing_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M151.723 430.165a85.333 85.333 0 0 1 20.053-31.616l269.91-269.952a178.176 178.176 0 1 1 251.989 251.947L423.68 650.496a85.333 85.333 0 0 1-31.616 20.053l-204.33 72.918C119.935 767.7 54.442 702.25 78.676 634.41l73.003-204.288zm80.341 28.715-72.96 204.288 204.288-73.003 269.952-269.952a92.843 92.843 0 0 0-131.328-131.285L232.106 458.88z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M390.997 199.125a42.667 42.667 0 0 1 60.331 0l156.587 156.587a42.667 42.667 0 0 1-60.331 60.33L390.997 259.457a42.667 42.667 0 0 1 0-60.33zM174.08 416.085a42.667 42.667 0 0 1 60.33 0l156.587 156.587a42.667 42.667 0 1 1-60.33 60.33L174.08 476.417a42.667 42.667 0 0 1 0-60.33zM721.664 512a42.667 42.667 0 0 1 42.667-42.667h89.002a85.333 85.333 0 0 1 85.334 85.334v309.632a85.333 85.333 0 0 1-85.334 85.333h-89.002a42.667 42.667 0 1 1 0-85.333h89.002V554.667h-89.002A42.667 42.667 0 0 1 721.664 512zm-51.499 55.168a42.667 42.667 0 0 1 0 60.33l-128 128a42.667 42.667 0 0 1-60.33-60.33l128-128a42.667 42.667 0 0 1 60.33 0z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M481.835 695.168a42.667 42.667 0 0 1 60.33 0l128 128a42.667 42.667 0 0 1-60.33 60.33l-128-128a42.667 42.667 0 0 1 0-60.33z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M469.333 725.333A42.667 42.667 0 0 1 512 682.667h213.333a42.667 42.667 0 1 1 0 85.333H512a42.667 42.667 0 0 1-42.667-42.667z"
  }));
};

var SvgExpandIcon = function SvgExpandIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "expand_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M85.333 874.667A42.667 42.667 0 0 1 128 832h768a42.667 42.667 0 1 1 0 85.333H128a42.667 42.667 0 0 1-42.667-42.666zm292.48-213.334H896A42.667 42.667 0 1 0 896 576H377.813a149.675 149.675 0 0 0-100.48-100.48v-33.707a149.632 149.632 0 0 0 101.12-102.741l276.779-17.28a149.333 149.333 0 1 0-14.08-84.608l-264.064 16.512a149.419 149.419 0 0 0-291.755 44.97A149.376 149.376 0 0 0 192 441.814v33.707A149.419 149.419 0 0 0 234.667 768a149.419 149.419 0 0 0 143.146-106.667zm-79.146-42.666a64 64 0 1 1-128 0 64 64 0 0 1 128 0zm0-320.299v.512a64 64 0 1 1 0-.512zM789.333 192a64 64 0 1 1 0 128 64 64 0 0 1 0-128z"
  }));
};

var SvgExtendIcon = function SvgExtendIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "extend_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M256 85.333A170.667 170.667 0 0 0 85.333 256v512A170.667 170.667 0 0 0 256 938.667h512A170.667 170.667 0 0 0 938.667 768V256A170.667 170.667 0 0 0 768 85.333H256zM170.667 256A85.333 85.333 0 0 1 256 170.667h512A85.333 85.333 0 0 1 853.333 256v512A85.333 85.333 0 0 1 768 853.333H256A85.333 85.333 0 0 1 170.667 768V256zM512 298.667a42.667 42.667 0 0 1 42.667 42.666v128h128a42.667 42.667 0 1 1 0 85.334h-128v128a42.667 42.667 0 1 1-85.334 0v-128h-128a42.667 42.667 0 1 1 0-85.334h128v-128A42.667 42.667 0 0 1 512 298.667z"
  }));
};

var SvgEyeoffIcon = function SvgEyeoffIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "eyeoff_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M93.61 93.653a43.093 43.093 0 0 1 60.886 0l128.597 128.64c63.19-39.466 138.454-66.56 226.688-66.56 245.888 0 391.254 210.219 454.955 313.472a81.493 81.493 0 0 1 0 85.675c-31.445 50.944-82.773 127.915-156.245 192.853l121.77 121.728a43.05 43.05 0 1 1-60.885 60.886L739.115 800.128c-63.744 40.363-139.904 68.181-229.334 68.181-245.888 0-391.253-210.176-454.954-313.472a81.536 81.536 0 0 1 0-85.632c31.744-51.498 83.797-129.578 158.506-194.858L93.611 154.58a43.093 43.093 0 0 1 0-60.928zm181.25 242.134-3.584 3.072C209.152 392.96 162.688 459.819 130.347 512c32.341 52.181 78.805 119.04 140.928 173.141 63.018 54.827 141.909 96.384 238.506 96.384 62.635 0 117.803-17.493 166.059-44.714l-85.632-85.675a160.725 160.725 0 0 1-219.605-219.605l-95.787-95.744zm162.218 162.218a73.941 73.941 0 0 0 86.614 86.614l-86.614-86.614zm309.931 188.16 1.28-1.024C810.411 631.04 856.832 564.181 889.216 512c-32.384-52.181-78.805-119.04-140.97-173.141-62.977-54.827-141.867-96.384-238.507-96.384-61.398 0-115.67 16.81-163.286 43.178l400.555 400.555z"
  }));
};

var SvgEyeonIcon = function SvgEyeonIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "eyeon_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M271.275 338.859C209.152 392.96 162.688 459.819 130.347 512c32.341 52.181 78.805 119.04 140.928 173.141 63.018 54.827 141.909 96.384 238.506 96.384 96.555 0 175.488-41.557 238.507-96.426C810.411 631.04 856.832 564.18 889.216 512c-32.384-52.181-78.805-119.04-140.97-173.141-62.977-54.827-141.867-96.384-238.507-96.384-96.555 0-175.446 41.557-238.464 96.384zM125.355 512C190.293 406.741 313.94 238.208 509.78 238.208c-195.84 0-319.488 168.533-384.426 273.792zm-70.528-42.837c63.701-103.254 209.066-313.43 454.954-313.43s391.254 210.176 454.955 313.43a81.493 81.493 0 0 1 0 85.674c-63.701 103.254-209.067 313.43-454.955 313.43S118.528 658.09 54.827 554.795a81.536 81.536 0 0 1 0-85.632zm454.954-31.147a73.941 73.941 0 1 0 0 147.925 73.941 73.941 0 0 0 0-147.882zM349.013 512a160.725 160.725 0 1 1 321.451 0 160.725 160.725 0 0 1-321.45 0z"
  }));
};

var SvgFacebookIcon = function SvgFacebookIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M1.002 11.998a11.005 11.005 0 0 0 9.28 10.867v-7.688h-2.79v-3.179h2.794v-2.42a3.88 3.88 0 0 1 4.15-4.29c.826.014 1.65.087 2.464.22v2.705h-1.39a1.59 1.59 0 0 0-1.79 1.72v2.065h3.047l-.487 3.18h-2.56v7.687a11 11 0 0 0-2.291-21.85A11 11 0 0 0 1.002 11.998Z"
  }));
};

var SvgFiatdepositIcon = function SvgFiatdepositIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "fiatdeposit_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M170.667 512A341.333 341.333 0 0 1 568.96 175.36a42.667 42.667 0 0 0 14.08-84.139A429.355 429.355 0 0 0 512 85.333C276.352 85.333 85.333 276.352 85.333 512S276.352 938.667 512 938.667 938.667 747.648 938.667 512c0-24.192-2.006-47.915-5.888-71.04a42.667 42.667 0 0 0-84.182 14.08A341.333 341.333 0 1 1 170.667 512zM640 213.333a42.667 42.667 0 1 0 0 85.334h85.333V384a42.667 42.667 0 1 0 85.334 0v-85.333H896a42.667 42.667 0 1 0 0-85.334h-85.333V128a42.667 42.667 0 1 0-85.334 0v85.333H640zM554.667 288a42.667 42.667 0 1 0-85.334 0v37.333a111.701 111.701 0 0 0-79.402 34.006 115.712 115.712 0 0 0-32.598 80.64c0 30.037 11.606 59.093 32.598 80.64a111.701 111.701 0 0 0 80.085 34.048h83.968c6.87 0 13.696 2.773 18.944 8.149a30.379 30.379 0 0 1 8.405 21.163c0 8.192-3.157 15.786-8.405 21.205a26.368 26.368 0 0 1-18.944 8.15H427.989a42.667 42.667 0 0 0 0 85.333h41.344V736a42.667 42.667 0 1 0 85.334 0v-37.333a111.701 111.701 0 0 0 79.402-34.006 115.712 115.712 0 0 0 32.598-80.64c0-30.037-11.606-59.093-32.598-80.64a111.701 111.701 0 0 0-80.085-34.048h-83.968a26.368 26.368 0 0 1-18.944-8.149 30.379 30.379 0 0 1-8.405-21.163c0-8.192 3.157-15.786 8.405-21.205a26.368 26.368 0 0 1 18.944-8.15h125.995a42.667 42.667 0 0 0 0-85.333h-41.344V288z"
  }));
};

var SvgFilterIcon = function SvgFilterIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "filter_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M46.635 110.08a42.667 42.667 0 0 1 38.698-24.747h853.334a42.667 42.667 0 0 1 32.597 70.23L640 547.243V896a42.667 42.667 0 0 1-61.739 38.144l-170.666-85.333A42.667 42.667 0 0 1 384 810.667V547.243L52.736 155.563a42.667 42.667 0 0 1-6.101-45.526zm130.645 60.587 281.984 333.397a42.667 42.667 0 0 1 10.07 27.563v252.672l85.333 42.666V531.627a42.667 42.667 0 0 1 10.069-27.563L846.72 170.667H177.28z"
  }));
};

var SvgFilterPressed1Icon = function SvgFilterPressed1Icon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "filter_pressed1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M46.635 110.08a42.667 42.667 0 0 1 38.698-24.747h853.334a42.667 42.667 0 0 1 32.597 70.23L640 547.243V896a42.667 42.667 0 0 1-61.739 38.144l-170.666-85.333A42.667 42.667 0 0 1 384 810.667V547.243L52.736 155.563a42.667 42.667 0 0 1-6.101-45.526z"
  }));
};

var SvgFluctuationIcon = function SvgFluctuationIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "fluctuation_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M406.997 298.667c17.11-.128 32.683 10.197 39.51 26.154L552.32 572.544l70.57-143.701a42.667 42.667 0 0 1 38.4-24.064 42.667 42.667 0 0 1 38.23 24.405l100.693 209.067h95.702c23.594 0 42.752 19.498 42.752 43.52 0 24.064-19.158 43.562-42.752 43.562H773.547a42.667 42.667 0 0 1-38.4-24.362l-74.411-154.539-72.875 148.395a42.667 42.667 0 0 1-39.381 24.021c-16.64-.427-31.445-10.667-38.059-26.155l-102.4-239.616-100.906 245.547c-6.656 16.213-22.187 26.71-39.424 26.71H128.085a43.136 43.136 0 0 1-42.752-43.52c0-24.065 19.158-43.52 42.752-43.52h111.147l128.64-312.918c6.613-16.085 22.016-26.581 39.125-26.71z"
  }));
};

var SvgFoldIcon = function SvgFoldIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "fold_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M298.667 512a42.667 42.667 0 0 1 42.666-42.667h341.334a42.667 42.667 0 1 1 0 85.334H341.333A42.667 42.667 0 0 1 298.667 512zM85.333 256A170.667 170.667 0 0 1 256 85.333h512A170.667 170.667 0 0 1 938.667 256v512A170.667 170.667 0 0 1 768 938.667H256A170.667 170.667 0 0 1 85.333 768V256zM256 170.667A85.333 85.333 0 0 0 170.667 256v512A85.333 85.333 0 0 0 256 853.333h512A85.333 85.333 0 0 0 853.333 768V256A85.333 85.333 0 0 0 768 170.667H256z"
  }));
};

var SvgFollowersIcon = function SvgFollowersIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "followers_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M256 234.667a106.667 106.667 0 1 1 213.333 0 106.667 106.667 0 0 1-213.333 0zm106.667-192a192 192 0 1 0 0 384 192 192 0 0 0 0-384zm362.666 362.666a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 0 298.667 149.333 149.333 0 0 0 0-298.667zM128 789.333a234.667 234.667 0 1 1 469.333 0V896a42.667 42.667 0 1 0 85.334 0V789.333a106.667 106.667 0 0 1 213.333 0V896a42.667 42.667 0 1 0 85.333 0V789.333a192 192 0 0 0-328.49-135.04 320 320 0 0 0-610.176 135.04V896A42.667 42.667 0 1 0 128 896V789.333z"
  }));
};

var SvgFullscreenOffIcon = function SvgFullscreenOffIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "fullscreen_off_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M469.333 426.667a42.667 42.667 0 0 1-42.666 42.666H256A42.667 42.667 0 1 1 256 384h67.67l-97.835-97.835a42.667 42.667 0 0 1 60.33-60.33L384 323.669V256a42.667 42.667 0 0 1 85.333 0v170.667zm97.92 140.373a42.539 42.539 0 0 1 30.08-12.373H768A42.667 42.667 0 1 1 768 640h-67.67l97.835 97.835a42.667 42.667 0 0 1-60.33 60.33L640 700.331V768a42.667 42.667 0 1 1-85.333 0V597.333a42.539 42.539 0 0 1 12.373-30.08l.213-.17z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M810.667 170.667a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666h597.334zM213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333z"
  }));
};

var SvgFullscreenOnIcon = function SvgFullscreenOnIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "fullscreen_on_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M213.333 256A42.667 42.667 0 0 1 256 213.333h170.667a42.667 42.667 0 1 1 0 85.334h-67.67l97.835 97.834a42.667 42.667 0 0 1-60.33 60.331l-97.835-97.835v67.67a42.667 42.667 0 1 1-85.334 0V256zM798.08 798.293A42.539 42.539 0 0 1 768 810.667H597.333a42.667 42.667 0 1 1 0-85.334h67.67L567.168 627.5a42.667 42.667 0 0 1 60.33-60.331l97.835 97.835v-67.67a42.667 42.667 0 1 1 85.334 0V768a42.539 42.539 0 0 1-12.374 30.08l-.213.17zm12.587-627.626a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333a42.667 42.667 0 0 1 42.666-42.666h597.334zM213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333z"
  }));
};

var SvgGiftIcon = function SvgGiftIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "gift_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M514.603 171.435C546.432 113.579 605.61 42.667 704 42.667A149.333 149.333 0 0 1 838.912 256h99.755a42.667 42.667 0 0 1 42.666 42.667V512a42.667 42.667 0 0 1-42.666 42.667H896v384a42.667 42.667 0 0 1-42.667 42.666H170.667A42.667 42.667 0 0 1 128 938.667v-384H85.333A42.667 42.667 0 0 1 42.667 512V298.667A42.667 42.667 0 0 1 85.333 256h99.755A149.333 149.333 0 0 1 320 42.667c98.39 0 157.568 70.912 189.397 128.768l2.603 4.821 2.603-4.821zm-45.27 169.898H128v128h341.333v-128zM454.571 256a350.208 350.208 0 0 0-19.968-43.435C407.765 163.755 370.944 128 320 128a64 64 0 0 0 0 128h134.57zm294.698-18.773A64 64 0 0 0 704 128c-50.944 0-87.765 35.755-114.603 84.565A350.208 350.208 0 0 0 569.43 256H704a64 64 0 0 0 45.227-18.773zM554.667 469.333H896v-128H554.667v128zm0 426.667h256V554.667h-256V896zm-85.334-341.333h-256V896h256V554.667z"
  }));
};

var SvgGithubIcon = function SvgGithubIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M12.01 1C18.078 1 23.017 5.958 23 12.09c0 4.904-3.153 9.053-7.528 10.523-.546.11-.747-.24-.747-.533 0-.367.018-1.56.018-3.048 0-1.047-.346-1.708-.747-2.057 2.46-.275 5.03-1.212 5.03-5.472 0-1.212-.419-2.203-1.13-2.974.11-.276.493-1.414-.109-2.938 0 0-.93-.294-3.026 1.138a10.588 10.588 0 0 0-2.752-.367c-.93 0-1.855.124-2.752.367C7.16 5.297 6.23 5.591 6.23 5.591c-.601 1.524-.219 2.662-.11 2.938a4.342 4.342 0 0 0-1.13 2.974c0 4.26 2.57 5.215 5.013 5.472-.31.276-.601.771-.693 1.488-.637.293-2.223.77-3.207-.919 0 0-.584-1.064-1.696-1.138 0 0-1.075 0-.073.68 0 0 .73.33 1.222 1.615 0 0 .637 1.983 3.7 1.322 0 .919.018 1.8.018 2.057 0 .294-.2.643-.747.532A11.082 11.082 0 0 1 1 12.091C1 5.958 5.921 1 12.01 1Z"
  }));
};

var SvgGlobeIcon = function SvgGlobeIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "globe_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M406.187 187.392a341.717 341.717 0 0 0-232.918 281.941h127.872c9.686-100.821 45.995-197.418 104.96-281.941zm211.626 0c59.008 84.523 95.318 181.12 105.003 281.941h127.872a341.717 341.717 0 0 0-232.832-281.941zm19.2 281.941C625.536 368.085 582.4 271.275 512 190.293c-70.4 80.939-113.536 177.75-125.013 279.04h250.026zm-250.026 85.334C398.464 655.915 441.6 752.725 512 833.707c70.4-80.982 113.536-177.792 125.013-279.04H386.987zm-85.803 0H173.312a341.717 341.717 0 0 0 232.832 281.941c-58.965-84.523-95.275-181.12-104.917-281.941zm316.672 281.941a341.675 341.675 0 0 0 232.832-281.941H722.816c-9.685 100.821-45.995 197.418-104.96 281.941zM85.333 512C85.333 276.352 276.352 85.333 512 85.333S938.667 276.352 938.667 512 747.648 938.667 512 938.667 85.333 747.648 85.333 512z"
  }));
};

var SvgGoogleIcon = function SvgGoogleIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "google_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M964.352 426.837a42.667 42.667 0 0 0-41.984-35.072H520.533a42.667 42.667 0 0 0-42.666 42.667v165.035a42.667 42.667 0 0 0 42.666 42.666H689.58a155.973 155.973 0 0 1-48.256 50.646 215.893 215.893 0 0 1-120.79 33.536 210.56 210.56 0 0 1-198.229-146.688v-.086a209.237 209.237 0 0 1 0-135.125v-.085a210.603 210.603 0 0 1 198.23-146.603 186.795 186.795 0 0 1 133.589 51.925 42.667 42.667 0 0 0 59.69-.64l122.368-122.368a42.667 42.667 0 0 0-1.066-61.397A453.29 453.29 0 0 0 520.533 42.667a467.2 467.2 0 0 0-419.37 258.517l-.043.085A466.005 466.005 0 0 0 51.2 512a472.704 472.704 0 0 0 49.92 210.773l.043.043a467.2 467.2 0 0 0 419.37 258.517 449.11 449.11 0 0 0 311.254-114.645l.042-.043A460.203 460.203 0 0 0 972.8 521.728a536 536 0 0 0-8.448-94.89zM520.533 128a370.475 370.475 0 0 1 222.251 71.381l-62.037 61.995a275.755 275.755 0 0 0-160.214-48.981A293.845 293.845 0 0 0 264.96 363.86l-45.568-35.328-24.96-19.37A381.995 381.995 0 0 1 520.533 128zm-363.52 507.861a385.28 385.28 0 0 1 0-247.722l76.032 58.965a292.437 292.437 0 0 0 0 129.792l-76.074 58.965zM520.533 896A381.952 381.952 0 0 1 194.39 714.837l16.171-12.544 54.443-42.24a293.76 293.76 0 0 0 255.53 151.595 310.485 310.485 0 0 0 141.056-32.043l72.15 56.022A379.264 379.264 0 0 1 520.533 896zm278.443-117.76-7.808-6.101-58.752-45.611a239.19 239.19 0 0 0 59.733-119.253 42.667 42.667 0 0 0-41.984-50.475H563.2v-79.701h322.09a455.654 455.654 0 0 1 2.177 44.629 386.219 386.219 0 0 1-88.491 256.47z"
  }));
};

var SvgGuideIcon = function SvgGuideIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "guide_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M256 149.333a85.333 85.333 0 0 0-85.333 85.334v449.792c17.92-8.022 37.76-12.459 58.666-12.459h624V234.667A85.333 85.333 0 0 0 768 149.333H256zM229.333 960a144 144 0 0 1-143.53-132.352 43.05 43.05 0 0 1-.47-6.315V234.667A170.667 170.667 0 0 1 256 64h512a170.667 170.667 0 0 1 170.667 170.667v480A42.667 42.667 0 0 1 896 757.333H229.333a58.667 58.667 0 1 0 0 117.334H768A42.667 42.667 0 1 1 768 960H229.333z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M444.672 302.379c4.224-12.587 22.101-28.032 51.157-30.123 26.539-1.92 54.358 8.533 71.467 37.12 9.045 15.061 10.837 26.965 9.984 36.352-.896 9.813-5.12 20.01-12.8 30.55-16.128 21.93-43.648 39.68-64.683 48.725a38.4 38.4 0 1 0 30.251 70.613c28.715-12.33 69.461-37.248 96.341-73.941 13.824-18.774 24.832-41.942 27.35-68.822 2.56-27.306-4.011-55.381-20.566-82.986-34.048-56.747-91.605-77.952-142.933-74.24-48.81 3.541-101.29 31.104-118.443 82.474a38.4 38.4 0 0 0 72.875 24.32zM512.085 608a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333z"
  }));
};

var SvgHalfscreenOffIcon = function SvgHalfscreenOffIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "halfscreen_off_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M926.165 158.165 742.997 341.333h96.128a42.667 42.667 0 1 1 0 85.334H640A42.667 42.667 0 0 1 597.333 384V184.875a42.667 42.667 0 1 1 85.334 0v96.128L865.835 97.835a42.667 42.667 0 1 1 60.33 60.33zm-828.33 768a42.667 42.667 0 0 0 60.33 0l183.04-183.04v96.128a42.667 42.667 0 1 0 85.334 0V643.456a42.581 42.581 0 0 0-45.995-45.995H184.747a42.667 42.667 0 1 0 0 85.334h96.128l-183.04 183.04a42.667 42.667 0 0 0 0 60.33z"
  }));
};

var SvgHalfscreenOnIcon = function SvgHalfscreenOnIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "halfscreen_on_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m609.835 353.835 183.168-183.168h-96.128a42.667 42.667 0 1 1 0-85.334H896A42.667 42.667 0 0 1 938.667 128v199.125a42.667 42.667 0 1 1-85.334 0v-96.128L670.165 414.165a42.667 42.667 0 0 1-60.33-60.33zm-195.67 256a42.667 42.667 0 0 0-60.33 0l-183.04 183.04v-96.128a42.667 42.667 0 1 0-85.334 0v195.797a42.581 42.581 0 0 0 46.038 45.995h195.754a42.667 42.667 0 1 0 0-85.334h-96.085l183.04-183.04a42.667 42.667 0 0 0 0-60.33z"
  }));
};

var SvgHelpCircleSolidIcon = function SvgHelpCircleSolidIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "help_circle_solid_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 981.333c259.2 0 469.333-210.133 469.333-469.333S771.2 42.667 512 42.667 42.667 252.8 42.667 512 252.8 981.333 512 981.333zm7.168-638.762a85.333 85.333 0 0 0-94.89 55.765 42.667 42.667 0 1 1-80.513-28.288 170.667 170.667 0 0 1 331.648 56.832c0 65.28-48.426 108.416-82.986 131.456a343.723 343.723 0 0 1-71.936 36.224l-1.494.512-.426.17-.214.043h-.042l-.086.043a42.667 42.667 0 0 1-27.008-80.939l.683-.213a250.88 250.88 0 0 0 15.53-6.272c10.54-4.693 24.235-11.605 37.675-20.565 29.44-19.627 44.971-40.448 44.971-60.502v-.042a85.333 85.333 0 0 0-70.912-84.224zm-53.675 382.976a42.667 42.667 0 0 1 42.667-42.667h.427a42.667 42.667 0 1 1 0 85.333h-.427a42.667 42.667 0 0 1-42.667-42.666z"
  }));
};

var SvgHelpIcon = function SvgHelpIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "help_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768zM42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512 771.2 981.333 512 981.333 42.667 771.2 42.667 512zm426.666 213.333A42.667 42.667 0 0 1 512 682.667h.427a42.667 42.667 0 1 1 0 85.333H512a42.667 42.667 0 0 1-42.667-42.667zm-3.968-372.437a85.333 85.333 0 0 1 128.555 73.685v.086c0 20.053-15.573 40.874-45.013 60.501a258.133 258.133 0 0 1-53.163 26.795l-.683.256a42.667 42.667 0 0 0 27.008 80.938l-13.482-40.49c13.482 40.49 13.525 40.448 13.568 40.448h.042l.171-.086.47-.128 1.493-.512 4.949-1.834a343.467 343.467 0 0 0 66.987-34.39c34.56-23.04 82.944-66.133 82.986-131.456a170.667 170.667 0 0 0-331.648-56.874 42.667 42.667 0 0 0 80.47 28.33 85.333 85.333 0 0 1 37.29-45.226z"
  }));
};

var SvgHighindexIcon = function SvgHighindexIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "highindex_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 170.667a426.667 426.667 0 0 0-369.493 640A42.837 42.837 0 0 0 216.747 768a337.92 337.92 0 0 1-46.08-170.667A341.333 341.333 0 1 1 807.68 768a42.667 42.667 0 1 0 73.813 42.667 426.667 426.667 0 0 0-369.493-640zm121.173 245.76-66.133 65.706a124.16 124.16 0 0 0-55.04-12.8 128 128 0 1 0 128 128 123.733 123.733 0 0 0-12.8-54.613l66.133-65.707a42.752 42.752 0 0 0-30.08-72.96 42.667 42.667 0 0 0-30.08 12.374zM512 640a42.667 42.667 0 0 1 0-85.333 42.667 42.667 0 0 1 29.867 11.946 42.667 42.667 0 0 1 12.8 30.72A42.667 42.667 0 0 1 512 640z"
  }));
};

var SvgHomeIcon = function SvgHomeIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "home_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M704 640H320v85.333h384V640zM559.787 83.541a85.333 85.333 0 0 0-96.683.043L100.907 332.885A85.333 85.333 0 0 0 64 403.2v466.901a85.333 85.333 0 0 0 85.333 85.334h725.419a85.333 85.333 0 0 0 85.333-85.334V403.2a85.333 85.333 0 0 0-37.034-70.315L559.787 83.541zM511.488 153.9l363.221 249.3v466.901H149.333V403.2l362.24-249.301z"
  }));
};

var SvgHotkeyIcon = function SvgHotkeyIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "hotkey_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M71.168 213.333A85.333 85.333 0 0 1 156.501 128h711.126a85.333 85.333 0 0 1 85.333 85.333v597.334A85.333 85.333 0 0 1 867.627 896H156.5a85.333 85.333 0 0 1-85.333-85.333V213.333zm796.459 0H156.5v597.334h711.126V213.333zm-568.96 227.584a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm0 170.667a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm128-128a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333zM640 440.917a42.667 42.667 0 1 1-85.333 0 42.667 42.667 0 0 1 85.333 0zm128 42.667a42.667 42.667 0 1 0 0-85.333 42.667 42.667 0 0 0 0 85.333zm42.667 128a42.667 42.667 0 1 1-85.334 0 42.667 42.667 0 0 1 85.334 0zm-384-42.667a42.667 42.667 0 1 0 0 85.334h170.666a42.667 42.667 0 1 0 0-85.334H426.667z"
  }));
};

var SvgIconCompassIcon = function SvgIconCompassIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "icon-compass_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M723.243 341.205a32 32 0 0 0-40.448-40.49l-271.36 90.453a32 32 0 0 0-20.267 20.267l-90.453 271.36a32 32 0 0 0 40.533 40.448l271.36-90.454a32 32 0 0 0 20.181-20.224l90.454-271.36zM381.696 642.304l65.152-195.456 195.456-65.152-65.152 195.413-195.456 65.195zM512 53.333C258.688 53.333 53.333 258.688 53.333 512S258.688 970.667 512 970.667 970.667 765.312 970.667 512 765.312 53.333 512 53.333zM117.333 512a394.667 394.667 0 1 1 789.334 0 394.667 394.667 0 0 1-789.334 0z"
  }));
};

var SvgImportIcon = function SvgImportIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "import_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M786.944 307.627a298.88 298.88 0 0 0-486.699-90.88 298.837 298.837 0 0 0-83.882 171.52A170.837 170.837 0 0 0 142.89 682.24a170.837 170.837 0 0 0 113.621 42.923 42.667 42.667 0 1 0 0-85.376 85.419 85.419 0 0 1 0-170.795 42.667 42.667 0 0 0 42.71-42.667A213.419 213.419 0 0 1 622.207 243.5a213.461 213.461 0 0 1 92.587 114.048 42.667 42.667 0 0 0 33.28 28.586 128.128 128.128 0 0 1 79.701 201.387c-17.067 23.381-41.557 40.277-69.461 48a42.795 42.795 0 0 0 21.333 82.773 213.547 213.547 0 0 0 118.06-332.074 213.504 213.504 0 0 0-110.763-78.592zm-243.84 216.49a42.667 42.667 0 0 0-14.08-8.96c-10.41-4.266-22.101-4.266-32.47 0a42.667 42.667 0 0 0-14.08 8.96l-128.17 128.086a42.88 42.88 0 1 0 60.672 60.586l55.083-55.466v238.634a42.667 42.667 0 1 0 85.418 0V657.323l55.083 55.466a42.752 42.752 0 0 0 69.973-13.866 42.624 42.624 0 0 0-9.344-46.72L543.104 524.117z"
  }));
};

var SvgInformationdisclosureIcon = function SvgInformationdisclosureIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "informationdisclosure_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M426.667 341.333h256a42.667 42.667 0 1 0 0-85.333h-256a42.667 42.667 0 0 0 0 85.333zM341.333 512h341.334a42.667 42.667 0 0 0 0-85.333H341.333a42.667 42.667 0 0 0 0 85.333zm0 170.667h341.334a42.667 42.667 0 0 0 0-85.334H341.333a42.667 42.667 0 0 0 0 85.334zm512-597.334H170.667A42.667 42.667 0 0 0 128 128v768a42.667 42.667 0 0 0 68.267 34.133L284.587 864l87.893 66.133a42.667 42.667 0 0 0 51.2 0L512 864l88.32 66.133a42.667 42.667 0 0 0 51.2 0L739.413 864l88.32 66.133a42.667 42.667 0 0 0 61.867-11.818A42.667 42.667 0 0 0 896 896V128a42.667 42.667 0 0 0-42.667-42.667zm-42.666 725.334-45.654-34.134a42.667 42.667 0 0 0-51.2 0l-87.893 66.134-88.32-66.134a42.667 42.667 0 0 0-51.2 0l-88.32 66.134-87.893-66.134a42.667 42.667 0 0 0-51.2 0l-45.654 34.134v-640h597.334v640z"
  }));
};

var SvgInstagramIcon = function SvgInstagramIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm0 8a3 3 0 1 1 0-5.999A3 3 0 0 1 12 15Zm5-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4.94 2.24a7.51 7.51 0 0 0-.48-2.5 5.56 5.56 0 0 0-3.2-3.2 7.51 7.51 0 0 0-2.5-.48C14.79 2 14.47 2 12 2c-2.47 0-2.79 0-3.76.06a7.51 7.51 0 0 0-2.5.48 5.56 5.56 0 0 0-3.2 3.2 7.51 7.51 0 0 0-.48 2.5C2 9.22 2 9.54 2 12s0 2.78.06 3.76c.017.855.179 1.7.48 2.5a5.56 5.56 0 0 0 3.2 3.2 7.51 7.51 0 0 0 2.5.48c1 0 1.29.06 3.76.06 2.47 0 2.79 0 3.76-.06a7.51 7.51 0 0 0 2.5-.48 5.56 5.56 0 0 0 3.2-3.2 7.51 7.51 0 0 0 .48-2.5c0-1 .06-1.3.06-3.76s0-2.78-.06-3.76Zm-2 7.43a6 6 0 0 1-.35 1.86 3.4 3.4 0 0 1-.82 1.25 3.26 3.26 0 0 1-1.25.81 5.75 5.75 0 0 1-1.87.36c-.94 0-1.23.05-3.66.05H8.34a6 6 0 0 1-1.87-.35 3.4 3.4 0 0 1-1.25-.82 3.26 3.26 0 0 1-.81-1.25 5.74 5.74 0 0 1-.36-1.86V8.38a5.86 5.86 0 0 1 .36-1.87 3.3 3.3 0 0 1 .81-1.24 3.26 3.26 0 0 1 1.25-.81 5.75 5.75 0 0 1 1.87-.36C9.28 4 9.57 4 12 4h3.66a5.87 5.87 0 0 1 1.88.36 3.3 3.3 0 0 1 1.24.81c.363.349.64.776.81 1.25A5.74 5.74 0 0 1 20 8.33c0 1 .05 1.25.05 3.67S20 14.71 20 15.67h-.06Z"
  }));
};

var SvgJobmanagementIcon = function SvgJobmanagementIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "jobmanagement_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M320 213.333a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128v79.659h45.44A146.56 146.56 0 0 1 896 439.595a42.667 42.667 0 1 1-85.333 0c0-33.835-27.435-61.27-61.227-61.27H256a85.333 85.333 0 0 0-85.333 85.334V768A85.333 85.333 0 0 0 256 853.333h128.299a42.667 42.667 0 1 1 0 85.334H256A170.667 170.667 0 0 1 85.333 768V463.659A170.667 170.667 0 0 1 256 292.992h64v-79.659zm298.667 0A42.667 42.667 0 0 0 576 170.667H448a42.667 42.667 0 0 0-42.667 42.666v79.659h213.334v-79.659zM486.955 672l62.336-107.947a106.667 106.667 0 0 1 92.373-53.333h124.715a106.667 106.667 0 0 1 92.373 53.333L921.131 672a106.667 106.667 0 0 1 0 106.667l-62.379 107.989a106.667 106.667 0 0 1-92.373 53.333H641.707a106.667 106.667 0 0 1-92.374-53.333L487.04 778.709a106.667 106.667 0 0 1 0-106.666zm73.898 42.667a21.333 21.333 0 0 0 0 21.333l62.336 107.99a21.333 21.333 0 0 0 18.475 10.666h124.715a21.333 21.333 0 0 0 18.474-10.667l62.336-107.946a21.333 21.333 0 0 0 0-21.334l-62.293-108.032a21.333 21.333 0 0 0-18.517-10.666H641.707a21.333 21.333 0 0 0-18.475 10.666l-62.293 107.99zM704 789.333a64 64 0 1 0 0-128 64 64 0 0 0 0 128zM341.333 512A42.667 42.667 0 1 0 256 512v128a42.667 42.667 0 1 0 85.333 0V512z"
  }));
};

var SvgKlineEntranceAppIcon = function SvgKlineEntranceAppIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "kline_entrance_app_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M480 85.333a42.667 42.667 0 1 1 85.333 0v85.334c0 .853 0 1.621-.085 2.432A120.32 120.32 0 0 1 661.333 290.9v442.2a120.32 120.32 0 0 1-96.085 117.8 41.813 41.813 0 0 1 .085 2.432v85.334a42.667 42.667 0 1 1-85.333 0v-85.334c0-.853 0-1.621.085-2.432A120.32 120.32 0 0 1 384 733.1V290.9a120.32 120.32 0 0 1 96.085-117.8 41.728 41.728 0 0 1-.085-2.432V85.333zM504.235 256a34.901 34.901 0 0 0-34.902 34.901V733.1c0 19.285 15.616 34.901 34.902 34.901h36.864A34.901 34.901 0 0 0 576 733.099V290.9a34.901 34.901 0 0 0-34.901-34.9h-36.864zM160 170.667a42.667 42.667 0 0 1 85.333 0V256c0 .853 0 1.621-.085 2.432a120.32 120.32 0 0 1 96.085 117.803v271.53a120.32 120.32 0 0 1-96.085 117.803l.085 2.432v85.333a42.667 42.667 0 1 1-85.333 0V768c0-.853 0-1.621.085-2.432A120.32 120.32 0 0 1 64 647.765v-271.53a120.32 120.32 0 0 1 96.085-117.803A43.307 43.307 0 0 1 160 256v-85.333zm24.235 170.666a34.901 34.901 0 0 0-34.902 34.902v271.53c0 19.286 15.616 34.902 34.902 34.902h36.864A34.901 34.901 0 0 0 256 647.765v-271.53a34.901 34.901 0 0 0-34.901-34.902h-36.864zm770.389 163.03-87.467 118.016a27.947 27.947 0 0 1-44.757 0l-87.467-118.016a27.136 27.136 0 0 1-5.333-16.171c0-15.104 12.416-27.392 27.733-27.392h174.934a27.903 27.903 0 0 1 16.384 5.29c12.373 8.96 15.018 26.07 5.973 38.273z"
  }));
};

var SvgKtvAreaIcon = function SvgKtvAreaIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_area_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M806.272 163.925a42.667 42.667 0 0 1 64.256 56.192l-134.4 153.6A42.667 42.667 0 0 1 704 388.267h-96L467.072 546.73a42.667 42.667 0 0 1-59.179 4.437l-85.333-71.04-126.037 126.037a42.667 42.667 0 0 1-60.331-60.33l153.6-153.6a42.667 42.667 0 0 1 57.472-2.603l83.456 69.547 126.165-141.91a42.667 42.667 0 0 1 31.915-14.336h95.83l121.642-139.008zm18.432 167.296a42.667 42.667 0 0 1 75.563 27.179v460.8a42.667 42.667 0 0 1-42.667 42.667H166.4a42.667 42.667 0 0 1-42.667-42.667v-80.64a42.667 42.667 0 0 1 14.422-32l167.594-147.84a42.667 42.667 0 0 1 58.496 1.963l74.454 75.05 179.157-180.65a42.667 42.667 0 0 1 30.293-12.63H732.8l91.904-111.232zm-9.77 145.792L785.748 512.3a42.667 42.667 0 0 1-32.853 15.488h-1.28l63.317 74.24V477.013zM605.78 588.416l151.851 188.16h57.301v-43.179L651.648 542.165l-45.867 46.251zM499.627 695.509l64.341 77.184a47.072 47.072 0 0 1 2.859 3.84h81.152L545.323 649.387l-45.654 46.08zm-203.819-14.208 76.16 91.392c1.067 1.238 2.005 2.56 2.859 3.84h81.28l-34.134-40.96a42.667 42.667 0 0 1-13.568-9.216l-76.373-77.013-36.224 31.957zm-86.741 76.459v18.773h55.04l-32.299-38.826-22.741 20.053z"
  }));
};

var SvgKtvBarsIcon = function SvgKtvBarsIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_bars_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M725.333 85.333A42.667 42.667 0 0 1 768 128v469.333h85.333a42.667 42.667 0 1 1 0 85.334H768v128a42.667 42.667 0 1 1-85.333 0V341.333h-85.334a42.667 42.667 0 1 1 0-85.333h85.334V128a42.667 42.667 0 0 1 42.666-42.667zm-426.666 85.334A42.667 42.667 0 0 0 256 213.333v512h-85.333a42.667 42.667 0 1 0 0 85.334H256V896a42.667 42.667 0 1 0 85.333 0V469.333h85.334a42.667 42.667 0 1 0 0-85.333h-85.334V213.333a42.667 42.667 0 0 0-42.666-42.666z"
  }));
};

var SvgKtvBaselineIcon = function SvgKtvBaselineIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_baseline_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M462.336 213.333a42.667 42.667 0 0 1 38.101 24.406l119.68 252.928h-94.464L460.8 353.536l-36.821 73.6a42.667 42.667 0 0 1-74.24 3.627l-6.528-10.368-38.4 70.272h-97.28l95.658-175.019a42.667 42.667 0 0 1 73.558-2.219l4.821 7.68 42.112-84.181a42.667 42.667 0 0 1 38.656-23.595zm252.16 476.928-33.835-71.594H586.24l89.77 189.781a42.667 42.667 0 0 0 77.185-.085l89.429-189.696h-94.336l-33.75 71.594zm-576.81-71.594h97.28l-69.462 127.146a42.667 42.667 0 0 1-74.88-40.96l47.104-86.186zm670.975-128h94.294l31.701-67.158a42.667 42.667 0 0 0-77.227-36.352l-48.768 103.51zm-642.346 29.866H93.867V588.8h72.405v-68.267zm153.6 0h-76.587V588.8h76.544v-68.267zm153.6 0h-76.587V588.8h76.544v-68.267zm153.6 0H550.57V588.8h76.544v-68.267zm153.6 0H704.17V588.8h76.544v-68.267zm149.461 0h-72.405V588.8h72.362v-68.267z"
  }));
};

var SvgKtvCandlesIcon = function SvgKtvCandlesIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_candles_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M362.667 128a42.667 42.667 0 0 0-85.334 0v87.083a128 128 0 0 0-106.666 126.25v341.334a128 128 0 0 0 106.666 126.25V896a42.667 42.667 0 1 0 85.334 0v-87.083a128 128 0 0 0 106.666-126.25V341.333a128 128 0 0 0-106.666-126.25V128zm-21.334 597.333h-42.666A42.667 42.667 0 0 1 256 682.667V341.333a42.667 42.667 0 0 1 42.667-42.666h42.666A42.667 42.667 0 0 1 384 341.333v341.334a42.667 42.667 0 0 1-42.667 42.666zm405.334-512a42.667 42.667 0 1 0-85.334 0v87.083a128 128 0 0 0-106.666 126.25V640a128 128 0 0 0 106.666 126.25v87.083a42.667 42.667 0 1 0 85.334 0v-87.082A128 128 0 0 0 853.333 640V426.667a128 128 0 0 0-106.666-126.251v-87.083zm-21.334 469.334h-42.666A42.667 42.667 0 0 1 640 640V426.667A42.667 42.667 0 0 1 682.667 384h42.666A42.667 42.667 0 0 1 768 426.667V640a42.667 42.667 0 0 1-42.667 42.667z"
  }));
};

var SvgKtvHeikinashiIcon = function SvgKtvHeikinashiIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_heikinashi_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M704 85.333A42.667 42.667 0 0 1 746.667 128v87.083a128 128 0 0 1 106.666 126.25v213.334a128 128 0 0 1-128 128h-42.666a128 128 0 0 1-128-128V341.333a128 128 0 0 1 106.666-126.25V128A42.667 42.667 0 0 1 704 85.333zm21.333 213.334h-42.666A42.667 42.667 0 0 0 640 341.333v213.334a42.667 42.667 0 0 0 42.667 42.666h42.666A42.667 42.667 0 0 0 768 554.667V341.333a42.667 42.667 0 0 0-42.667-42.666zM320 128a42.667 42.667 0 0 1 42.667 42.667v87.082A128 128 0 0 1 469.333 384v384a128 128 0 0 1-128 128h-42.666a128 128 0 0 1-128-128V384a128 128 0 0 1 106.666-126.25v-87.083A42.667 42.667 0 0 1 320 128zm21.333 213.333h-42.666A42.667 42.667 0 0 0 256 384v384a42.667 42.667 0 0 0 42.667 42.667h42.666A42.667 42.667 0 0 0 384 768V384a42.667 42.667 0 0 0-42.667-42.667z"
  }));
};

var SvgKtvHollowcandlesIcon = function SvgKtvHollowcandlesIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_hollowcandles_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M362.667 128a42.667 42.667 0 1 0-85.334 0v87.083a128 128 0 0 0-106.666 126.25v341.334a128 128 0 0 0 106.666 126.25V896a42.667 42.667 0 1 0 85.334 0v-87.083a128 128 0 0 0 106.666-126.25V341.333a128 128 0 0 0-106.666-126.25V128zm-21.334 597.333h-42.666a42.667 42.667 0 0 1-11.648-1.621L384 669.867v12.8a42.667 42.667 0 0 1-42.667 42.666zm-85.333-384a42.667 42.667 0 0 1 42.667-42.666h42.666a42.667 42.667 0 0 1 11.648 1.621L256 354.133v-12.8zm128 39.339v43.179l-128 76.8v-48.896l128-71.083zM256 643.328v-43.179l128-76.8v48.896l-128 71.083zm490.667-429.995a42.667 42.667 0 1 0-85.334 0v87.083a128 128 0 0 0-106.666 126.25V640a128 128 0 0 0 106.666 126.25v87.083a42.667 42.667 0 1 0 85.334 0v-87.082A128 128 0 0 0 853.333 640V426.667a128 128 0 0 0-106.666-126.251v-87.083zm-21.334 469.334h-42.666A42.667 42.667 0 0 1 640 640V426.667A42.667 42.667 0 0 1 682.667 384h42.666A42.667 42.667 0 0 1 768 426.667V640a42.667 42.667 0 0 1-42.667 42.667z"
  }));
};

var SvgKtvLineIcon = function SvgKtvLineIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ktv_line_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M924.33 309.461a42.667 42.667 0 0 1 3.542 60.203l-170.667 192A42.667 42.667 0 0 1 725.333 576H593.664L414.165 755.499a42.667 42.667 0 0 1-62.933-2.859l-76.8-92.117-116.267 116.309a42.667 42.667 0 0 1-60.33-60.33l149.333-149.334a42.667 42.667 0 0 1 62.933 2.859l76.8 92.117 158.934-158.976A42.667 42.667 0 0 1 576 490.667h130.133l157.995-177.664a42.667 42.667 0 0 1 60.203-3.542z"
  }));
};

var SvgLabelUpgradeIcon = function SvgLabelUpgradeIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "label_upgrade_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m536.661 94.976 392.534 395.093a33.024 33.024 0 0 1 6.954 35.755 32.768 32.768 0 0 1-30.25 20.224H728.747v196.053a65.707 65.707 0 0 1-65.622 65.622H363.904A65.707 65.707 0 0 1 298.24 742.1V546.133H118.23a32.853 32.853 0 0 1-23.297-56.064L490.155 94.976a32.768 32.768 0 0 1 46.506 0zM298.667 853.333a42.667 42.667 0 1 0 0 85.334h426.666a42.667 42.667 0 1 0 0-85.334H298.667z"
  }));
};

var SvgLayerIcon = function SvgLayerIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "layer_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M897.877 255.275c80.64 24.576 80.64 138.752 0 163.285L549.291 524.672a128 128 0 0 1-74.582 0L126.165 418.56c-80.64-24.533-80.64-138.71 0-163.285l348.587-106.07a128 128 0 0 1 74.581 0l348.587 106.07zm-24.832 81.664L524.46 230.827a42.667 42.667 0 0 0-24.875 0l-348.63 106.112 348.587 106.069a42.667 42.667 0 0 0 24.875 0l348.63-106.07z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M949.76 522.07a42.667 42.667 0 0 1-27.008 53.973L552.491 699.435a128 128 0 0 1-80.939 0L101.291 576.043a42.667 42.667 0 1 1 26.965-80.982l370.261 123.435a42.667 42.667 0 0 0 26.966 0l370.261-123.435a42.667 42.667 0 0 1 53.973 27.008z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M949.76 698.581a42.667 42.667 0 0 1-27.008 53.974L552.491 875.989a128 128 0 0 1-80.982 0L101.248 752.555a42.667 42.667 0 1 1 27.008-80.939l370.261 123.435a42.667 42.667 0 0 0 26.966 0l370.261-123.435a42.667 42.667 0 0 1 53.973 27.008z"
  }));
};

var SvgLevelIcon = function SvgLevelIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "level_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M448 512a64 64 0 1 0 128 0 64 64 0 0 0-128 0zm-79.147 42.667H85.333a42.667 42.667 0 1 1 0-85.334h283.52a149.419 149.419 0 0 1 286.294 0h283.52a42.667 42.667 0 1 1 0 85.334h-283.52a149.419 149.419 0 0 1-286.294 0z"
  }));
};

var SvgLine1Icon = function SvgLine1Icon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "line_1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M308.139 369.493a87.637 87.637 0 0 0-18.56 28.075L224.81 554.795a88.576 88.576 0 0 0 16.853 93.866c23.381 25.174 59.136 33.963 91.307 22.443l162.005-58.07a86.492 86.492 0 0 0 32.128-20.522L759.68 357.12l.128-.128a161.536 161.536 0 0 0 0-225.835c-64.47-65.536-160.939-57.13-219.093 1.963L308.139 369.493zm40.96 110.208 19.925-48.341L601.6 194.987c27.733-28.16 69.59-30.123 97.323-1.92 27.733 28.16 27.733 73.856 0 102.058l-232.576 235.35-52.523 18.816-109.568 39.253 44.843-108.843zM106.667 768a21.333 21.333 0 0 0 0 42.667h810.666a21.333 21.333 0 0 0 0-42.667H106.667z"
  }));
};

var SvgLine2Icon = function SvgLine2Icon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "line_2_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M308.139 369.493a87.637 87.637 0 0 0-18.56 28.075L224.81 554.795a88.576 88.576 0 0 0 16.853 93.866c23.381 25.174 59.136 33.963 91.307 22.443l162.005-58.07a86.492 86.492 0 0 0 32.128-20.522L759.68 357.12l.128-.128a161.536 161.536 0 0 0 0-225.835c-64.47-65.536-160.939-57.13-219.093 1.963L308.139 369.493zm40.96 110.208 19.925-48.341L601.6 194.987c27.733-28.16 69.59-30.123 97.323-1.92 27.733 28.16 27.733 73.856 0 102.058l-232.576 235.35-52.523 18.816-109.568 39.253 44.843-108.843zM128 768a42.667 42.667 0 1 0 0 85.333h768A42.667 42.667 0 1 0 896 768H128z"
  }));
};

var SvgLineBoldIcon = function SvgLineBoldIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "line_bold_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M308.139 369.493a87.637 87.637 0 0 0-18.56 28.075L224.81 554.795a88.576 88.576 0 0 0 16.853 93.866c23.381 25.174 59.136 33.963 91.307 22.443l162.005-58.07a86.492 86.492 0 0 0 32.128-20.522L759.68 357.12l.128-.128a161.536 161.536 0 0 0 0-225.835c-64.47-65.536-160.939-57.13-219.093 1.963L308.139 369.493zm40.96 110.208 19.925-48.341L601.6 194.987c27.733-28.16 69.59-30.123 97.323-1.92 27.733 28.16 27.733 73.856 0 102.058l-232.576 235.35-52.523 18.816-109.568 39.253 44.843-108.843zM138.667 768a53.333 53.333 0 1 0 0 106.667h746.666a53.333 53.333 0 1 0 0-106.667H138.667z"
  }));
};

var SvgLineDottedIcon = function SvgLineDottedIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "line_dotted_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M289.579 397.568a86.825 86.825 0 0 1 18.56-28.075L540.672 133.12c58.197-59.093 154.667-67.499 219.136-1.963a161.536 161.536 0 0 1 0 225.835l-.128.128-232.533 235.392c-9.131 9.173-20.054 16.17-32.171 20.48l-162.048 58.155a85.163 85.163 0 0 1-91.307-22.443 88.576 88.576 0 0 1-16.81-93.867l64.768-157.226zm79.445 33.792-19.925 48.341-44.8 108.886 109.525-39.254 52.48-18.858 232.619-235.35a72.96 72.96 0 0 0 0-102.058c-27.734-28.16-69.547-26.24-97.28 1.962L369.024 431.403zM128 768a42.667 42.667 0 1 0 0 85.333h85.333a42.667 42.667 0 1 0 0-85.333H128zm213.333 0a42.667 42.667 0 1 0 0 85.333h85.334a42.667 42.667 0 1 0 0-85.333h-85.334zM512 810.667A42.667 42.667 0 0 1 554.667 768H640a42.667 42.667 0 1 1 0 85.333h-85.333A42.667 42.667 0 0 1 512 810.667zM768 768a42.667 42.667 0 1 0 0 85.333h85.333a42.667 42.667 0 1 0 0-85.333H768z"
  }));
};

var SvgLinePointIcon = function SvgLinePointIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "line_point_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M308.139 369.493a87.637 87.637 0 0 0-18.56 28.075L224.81 554.795a88.576 88.576 0 0 0 16.853 93.866c23.381 25.174 59.136 33.963 91.307 22.443l162.005-58.07a86.492 86.492 0 0 0 32.128-20.522L759.68 357.12l.128-.128a161.536 161.536 0 0 0 0-225.835c-64.47-65.536-160.939-57.13-219.093 1.963L308.139 369.493zm40.96 110.208 19.925-48.341L601.6 194.987c27.733-28.16 69.59-30.123 97.323-1.92 27.733 28.16 27.733 73.856 0 102.058l-232.576 235.35-52.523 18.816-109.568 39.253 44.843-108.843zM128 768a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 128 768zm128 0a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 256 768zm85.333 42.667a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0zM512 768a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 512 768zm85.333 42.667a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0zM768 768a42.667 42.667 0 1 0 0 85.333A42.667 42.667 0 0 0 768 768zm85.333 42.667a42.667 42.667 0 1 1 85.334 0 42.667 42.667 0 0 1-85.334 0z"
  }));
};

var SvgLinkIcon = function SvgLinkIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "link_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M516.693 656.64 351.147 822.187a107.52 107.52 0 0 1-149.334 0 105.387 105.387 0 0 1 0-149.334L367.36 507.307a42.837 42.837 0 0 0-60.587-60.587L141.227 612.693a191.147 191.147 0 0 0 270.08 270.08L577.28 717.227a42.837 42.837 0 1 0-60.587-60.587zm366.08-515.413a191.573 191.573 0 0 0-270.08 0L446.72 306.773a42.837 42.837 0 1 0 60.587 60.587l165.546-165.547a107.52 107.52 0 0 1 149.334 0 105.387 105.387 0 0 1 0 149.334L656.64 516.693a42.539 42.539 0 0 0-9.344 46.72c2.133 5.163 5.333 9.899 9.344 13.867a42.667 42.667 0 0 0 60.587 0l165.546-165.973a191.573 191.573 0 0 0 0-270.08zM376.747 647.253a42.581 42.581 0 0 0 30.293 12.374 42.667 42.667 0 0 0 30.293-12.374l209.92-209.92a42.837 42.837 0 0 0-60.586-60.586l-209.92 209.92a42.624 42.624 0 0 0 0 60.586z"
  }));
};

var SvgLinkinIcon = function SvgLinkinIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M2 7.714h3.81V22H2V7.714ZM3.893 5.81h-.02C2.734 5.81 2 4.962 2 3.904 2 2.823 2.758 2 3.915 2c1.16 0 1.873.823 1.895 1.904 0 1.058-.736 1.906-1.917 1.906ZM22 12.952a5.238 5.238 0 0 0-5.238-5.238 5.229 5.229 0 0 0-4.286 2.233V7.714h-3.81V22h3.81v-7.619a2.857 2.857 0 1 1 5.714 0V22H22v-9.048Z"
  }));
};

var SvgListIcon = function SvgListIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "list_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M85.333 213.333a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128v128a128 128 0 0 1-128 128h-128a128 128 0 0 1-128-128v-128zm128-42.666a42.667 42.667 0 0 0-42.666 42.666v128A42.667 42.667 0 0 0 213.333 384h128A42.667 42.667 0 0 0 384 341.333v-128a42.667 42.667 0 0 0-42.667-42.666h-128zm-128 512a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128v128a128 128 0 0 1-128 128h-128a128 128 0 0 1-128-128v-128zm128-42.667a42.667 42.667 0 0 0-42.666 42.667v128a42.667 42.667 0 0 0 42.666 42.666h128A42.667 42.667 0 0 0 384 810.667v-128A42.667 42.667 0 0 0 341.333 640h-128zm341.334-469.333A42.667 42.667 0 0 1 597.333 128H896a42.667 42.667 0 1 1 0 85.333H597.333a42.667 42.667 0 0 1-42.666-42.666zm0 469.333a42.667 42.667 0 0 1 42.666-42.667H896a42.667 42.667 0 1 1 0 85.334H597.333A42.667 42.667 0 0 1 554.667 640zm42.666-298.667a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H597.333zm-42.666 512a42.667 42.667 0 0 1 42.666-42.666H896A42.667 42.667 0 1 1 896 896H597.333a42.667 42.667 0 0 1-42.666-42.667z"
  }));
};

var SvgLoadingIcon = function SvgLoadingIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "loading_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M373.077 200.235a341.333 341.333 0 1 1-202.41 311.978v-35.328a42.667 42.667 0 0 0-85.334 0v35.328a426.71 426.71 0 0 0 784.598 232.022 426.667 426.667 0 0 0-531.584-621.952 42.667 42.667 0 0 0 34.73 77.952z"
  }));
};

var SvgLockIcon = function SvgLockIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "lock_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M341.333 341.333V384h341.334v-42.667a170.667 170.667 0 0 0-341.334 0zM256 384v-42.667a256 256 0 1 1 512 0V384h42.667a128 128 0 0 1 128 128v298.667a128 128 0 0 1-128 128H213.333a128 128 0 0 1-128-128V512a128 128 0 0 1 128-128H256zm-42.667 85.333A42.667 42.667 0 0 0 170.667 512v298.667a42.667 42.667 0 0 0 42.666 42.666h597.334a42.667 42.667 0 0 0 42.666-42.666V512a42.667 42.667 0 0 0-42.666-42.667H213.333zm341.334 197.035v58.965a42.667 42.667 0 1 1-85.334 0v-58.965a64 64 0 1 1 85.334 0z"
  }));
};

var SvgLogOutIcon = function SvgLogOutIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "log-out_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M371.499 755.499a42.667 42.667 0 0 1-60.331 0L97.835 542.165a42.667 42.667 0 0 1 0-60.33L311.168 268.5a42.667 42.667 0 0 1 60.33 60.331L188.332 512 371.5 695.168a42.667 42.667 0 0 1 0 60.33z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M682.667 512A42.667 42.667 0 0 1 640 554.667H128a42.667 42.667 0 1 1 0-85.334h512A42.667 42.667 0 0 1 682.667 512z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M810.667 853.333a42.667 42.667 0 0 0 42.666-42.666V213.333a42.667 42.667 0 0 0-42.666-42.666H640a42.667 42.667 0 1 1 0-85.334h170.667a128 128 0 0 1 128 128v597.334a128 128 0 0 1-128 128H640a42.667 42.667 0 1 1 0-85.334h170.667z"
  }));
};

var SvgLowindexIcon = function SvgLowindexIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "lowindex_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 170.667a426.667 426.667 0 0 1 369.493 640A42.795 42.795 0 0 1 807.253 768a337.92 337.92 0 0 0 46.08-170.667A341.333 341.333 0 1 0 216.32 768a42.667 42.667 0 1 1-73.813 42.667 426.667 426.667 0 0 1 369.493-640zm-121.173 245.76 66.133 65.706a124.16 124.16 0 0 1 55.04-12.8 128 128 0 1 1-128 128 123.733 123.733 0 0 1 12.8-54.613l-66.133-65.707a42.667 42.667 0 1 1 60.16-60.586zM512 640a42.667 42.667 0 0 0 0-85.333 42.667 42.667 0 0 0-29.867 11.946 42.752 42.752 0 0 0-12.8 30.72A42.667 42.667 0 0 0 512 640z"
  }));
};

var SvgMagneticIcon = function SvgMagneticIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "magnetic_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M775.296 124.16a38.827 38.827 0 1 0-77.568 0v155.093a38.827 38.827 0 0 0 43.605 38.528l111.574-13.952v111.19a38.827 38.827 0 1 0 77.568 0V259.883a38.827 38.827 0 0 0-43.606-38.486L775.296 235.35V124.117zM620.459 337.835 417.067 134.443 182.4 369.109a331.904 331.904 0 0 0 469.333 469.419l234.71-234.71-203.393-203.39-234.666 234.665a44.245 44.245 0 1 1-62.592-62.549l234.667-234.71zM244.992 431.7l172.075-172.074 78.25 78.208L323.2 509.952a132.779 132.779 0 1 0 187.733 187.733l172.118-172.117 78.25 78.25-172.117 172.118a243.413 243.413 0 0 1-344.235-344.235z"
  }));
};

var SvgMailIcon = function SvgMailIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "mail_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M213.333 170.667a128 128 0 0 0-128 128v426.666a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V298.667a128 128 0 0 0-128-128H213.333zm-42.666 138.666 315.477 236.63c15.36 11.477 36.395 11.477 51.712 0l315.477-236.63v416A42.667 42.667 0 0 1 810.667 768H213.333a42.667 42.667 0 0 1-42.666-42.667v-416zM782.208 256 512 458.667 241.792 256h540.416z"
  }));
};

var SvgManualIcon = function SvgManualIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "manual_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M768 64H256A170.667 170.667 0 0 0 85.333 234.667v554.666A170.667 170.667 0 0 0 256 960h512a170.667 170.667 0 0 0 170.667-170.667V234.667A170.667 170.667 0 0 0 768 64zM170.667 234.667A85.333 85.333 0 0 1 256 149.333v256a42.667 42.667 0 0 0 68.267 34.134l59.733-44.8 59.733 44.8A42.667 42.667 0 0 0 512 405.333v-256h256a85.333 85.333 0 0 1 85.333 85.334v554.666A85.333 85.333 0 0 1 768 874.667H256a85.333 85.333 0 0 1-85.333-85.334V234.667zm256-85.334V320L409.6 307.2a42.667 42.667 0 0 0-51.2 0L341.333 320V149.333h85.334z"
  }));
};

var SvgMapPinIcon = function SvgMapPinIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "map-pin_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M270.636 185.3a341.331 341.331 0 0 1 582.695 241.364c0 132.18-86.015 260.436-180.308 359.976A1254.904 1254.904 0 0 1 512 928.976a1255.203 1255.203 0 0 1-161.023-142.293c-94.293-99.626-180.308-227.881-180.308-360.019A341.331 341.331 0 0 1 270.636 185.3zm217.684 831.526L512 981.327l23.68 35.499a42.666 42.666 0 0 1-47.36 0zm0 0L512 981.327c23.68 35.499 23.723 35.456 23.723 35.456l.085-.043.299-.213.98-.64 3.5-2.432c3.071-2.133 7.423-5.12 12.885-9.13a1341.133 1341.133 0 0 0 181.503-159.018c97.706-103.04 203.689-252.116 203.689-418.643a426.664 426.664 0 0 0-853.328 0c0 166.484 105.983 315.56 203.69 418.685a1340.92 1340.92 0 0 0 181.502 158.975 805.84 805.84 0 0 0 16.384 11.52l.981.683.3.213.127.086zm-61.653-590.162a85.333 85.333 0 1 1 170.666 0 85.333 85.333 0 0 1-170.666 0zM512 255.998a170.666 170.666 0 1 0 0 341.332 170.666 170.666 0 0 0 0-341.332z"
  }));
};

var SvgMarketIcon = function SvgMarketIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "market_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M551.68 216.277c-57.899-30.89-109.227-45.61-182.4-45.61-42.24 0-83.285 6.229-117.803 16.512a45.653 45.653 0 0 0-80.81 29.098V807.68a45.653 45.653 0 0 0 91.264 0V574.89c34.73-6.357 77.482-10.24 107.306-10.24 55.51 0 93.867 10.582 140.544 35.457 45.782 24.405 99.414 36.266 163.414 36.266 67.242 0 125.994-13.184 165.376-37.461a32.853 32.853 0 0 0 10.88-10.624 25.43 25.43 0 0 0 3.882-13.355v-333.44l-.341-4.266a27.733 27.733 0 0 0-7.68-14.336 38.4 38.4 0 0 0-15.616-9.387 46.805 46.805 0 0 0-19.328-2.005c-6.57.725-12.8 2.773-18.005 5.973-25.302 15.616-68.864 24.832-119.254 24.832-49.621 0-87.978-8.277-121.386-26.027z"
  }));
};

var SvgMediumIcon = function SvgMediumIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("g", {
    clipPath: "url(#medium_icon_svg__a)"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M13.538 11.815c0 3.764-3.031 6.816-6.77 6.816C3.032 18.63 0 15.579 0 11.815S3.03 5 6.769 5c3.738 0 6.769 3.051 6.769 6.815Zm7.428.002c0 3.543-1.515 6.416-3.384 6.416-1.87 0-3.385-2.873-3.385-6.416S15.712 5.4 17.581 5.4c1.87 0 3.385 2.872 3.385 6.416Zm1.845 5.752c.658 0 1.19-2.575 1.19-5.748 0-3.175-.533-5.748-1.19-5.748-.657 0-1.19 2.574-1.19 5.748 0 3.174.533 5.748 1.19 5.748Z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "medium_icon_svg__a"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

var SvgMenuIcon = function SvgMenuIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "menu_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M128 256a42.667 42.667 0 0 1 42.667-42.667h682.666a42.667 42.667 0 1 1 0 85.334H170.667A42.667 42.667 0 0 1 128 256zm0 256a42.667 42.667 0 0 1 42.667-42.667h682.666a42.667 42.667 0 1 1 0 85.334H170.667A42.667 42.667 0 0 1 128 512zm42.667 213.333a42.667 42.667 0 1 0 0 85.334h682.666a42.667 42.667 0 1 0 0-85.334H170.667z"
  }));
};

var SvgMoonIcon = function SvgMoonIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "moon_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M487.595 101.845a42.667 42.667 0 0 1 5.546 42.88A298.667 298.667 0 0 0 873.9 541.1a42.667 42.667 0 0 1 57 48.04C892.843 785.792 719.787 934.315 512 934.315c-235.648 0-426.667-191.062-426.667-426.667 0-213.76 157.099-390.699 362.112-421.845a42.667 42.667 0 0 1 40.15 16.042zm-96.598 86.486a341.333 341.333 0 1 0 435.115 453.034A384 384 0 0 1 391.04 188.331z"
  }));
};

var SvgMorehorizontalIcon = function SvgMorehorizontalIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "morehorizontal_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M213.333 426.667a85.333 85.333 0 1 0 0 170.666 85.333 85.333 0 0 0 0-170.666zM426.667 512a85.333 85.333 0 1 1 170.666 0 85.333 85.333 0 0 1-170.666 0zm298.666 0A85.333 85.333 0 1 1 896 512a85.333 85.333 0 0 1-170.667 0z"
  }));
};

var SvgNewcomerIcon = function SvgNewcomerIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "newcomer_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M48.853 321.579c-30.677 16.213-30.72 62.464-.042 78.506l406.528 213.462a118.187 118.187 0 0 0 106.197 2.09L883.072 462.72v131.413L853.589 624a22.827 22.827 0 0 0-.682 30.976l37.12 41.088a19.925 19.925 0 0 0 29.354.683l38.912-39.382a22.827 22.827 0 0 0 .683-30.976l-27.861-30.805.085-1.707V439.851l43.35-20.608c31.231-14.891 33.023-61.099 3.029-78.507l-403.2-233.643a118.272 118.272 0 0 0-115.2-2.261L48.853 321.579zm424.918 383.445L225.237 578.987V776.66a42.667 42.667 0 0 0 23.979 38.315L465.237 920.49a128 128 0 0 0 115.627-1.707l197.376-103.51a42.667 42.667 0 0 0 22.87-37.76V578.988L550.783 705.195a85.333 85.333 0 0 1-77.013-.128z"
  }));
};

var SvgNewsIcon = function SvgNewsIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "news_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M200.622 81.92c-73.318 0-139.182 63.652-139.182 150.692v517.734c0 87.04 65.864 150.774 139.182 150.774h242.36c1.23.082 2.458.164 3.687.164h375.44c75.325 0 140.492-63.734 140.492-147.784V252.928H801.382v-20.275c0-87.081-65.863-150.733-139.223-150.733H200.622zm600.76 262.062h79.053V753.46c0 27.976-22.937 56.73-58.327 56.73h-20.726V343.982zM719.258 810.19h-57.099v-.164H200.622c-32.194 0-57.057-27.443-57.057-59.679V232.653c0-32.236 24.863-59.679 57.057-59.679H662.16c32.236 0 57.099 27.443 57.099 59.679v577.536zm-452.65-409.6c0-25.109 18.35-45.466 40.96-45.466h246.498c22.65 0 41 20.357 41 45.466 0 25.108-18.35 45.465-40.96 45.465H307.61c-22.651 0-41.001-20.398-41.001-45.465zM471.9 537.109c22.692 0 41.083 20.357 41.083 45.465 0 25.15-18.432 45.548-41.083 45.548H307.65c-22.65 0-41.041-20.398-41.041-45.507 0-25.15 18.39-45.507 41.042-45.507H471.9z"
  }));
};

var SvgOrderIcon = function SvgOrderIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "order_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M682.667 64H341.333A213.333 213.333 0 0 0 128 277.333v469.334A213.333 213.333 0 0 0 341.333 960h341.334A213.333 213.333 0 0 0 896 746.667V277.333A213.333 213.333 0 0 0 682.667 64zM213.333 277.333a128 128 0 0 1 128-128h341.334a128 128 0 0 1 128 128v469.334a128 128 0 0 1-128 128H341.333a128 128 0 0 1-128-128V277.333zm128 21.334a42.667 42.667 0 0 0 0 85.333h341.334a42.667 42.667 0 1 0 0-85.333H341.333zm0 170.666a42.667 42.667 0 1 0 0 85.334h341.334a42.667 42.667 0 1 0 0-85.334H341.333zm-42.666 213.334A42.667 42.667 0 0 1 341.333 640h256a42.667 42.667 0 1 1 0 85.333h-256a42.667 42.667 0 0 1-42.666-42.666z"
  }));
};

var SvgOrdersIcon = function SvgOrdersIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "orders_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M256 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h512a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H256zm-42.667 128A42.667 42.667 0 0 1 256 170.667h512a42.667 42.667 0 0 1 42.667 42.666v597.334A42.667 42.667 0 0 1 768 853.333H256a42.667 42.667 0 0 1-42.667-42.666V213.333zm128 426.667A42.667 42.667 0 0 1 384 597.333h256a42.667 42.667 0 1 1 0 85.334H384A42.667 42.667 0 0 1 341.333 640zm0-256A42.667 42.667 0 0 1 384 341.333h256a42.667 42.667 0 1 1 0 85.334H384A42.667 42.667 0 0 1 341.333 384z"
  }));
};

var SvgOriginalorderIcon = function SvgOriginalorderIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "originalorder_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M277.333 234.667h8.875a106.667 106.667 0 0 0 97.792 64h213.333a106.667 106.667 0 0 0 97.792-64H704A85.333 85.333 0 0 1 789.333 320v113.792a42.667 42.667 0 1 0 85.334 0V320A170.667 170.667 0 0 0 704 149.333h-8.875a106.667 106.667 0 0 0-97.792-64H384a106.667 106.667 0 0 0-97.792 64h-8.875A170.667 170.667 0 0 0 106.667 320v469.333A170.667 170.667 0 0 0 277.333 960h128a42.667 42.667 0 1 0 0-85.333h-128A85.333 85.333 0 0 1 192 789.333V320a85.333 85.333 0 0 1 85.333-85.333zm106.667-64h213.333a21.333 21.333 0 0 1 0 42.666H384a21.333 21.333 0 0 1 0-42.666zM277.333 405.333A42.667 42.667 0 0 1 320 362.667h341.333a42.667 42.667 0 1 1 0 85.333H320a42.667 42.667 0 0 1-42.667-42.667zM320 576a42.667 42.667 0 1 0 0 85.333h64A42.667 42.667 0 1 0 384 576h-64zm366.933 0a153.6 153.6 0 1 0 0 307.2 153.6 153.6 0 0 0 0-307.2zm-230.4 153.6a230.4 230.4 0 1 1 460.8 0 230.4 230.4 0 0 1-460.8 0zm220.8-96a38.4 38.4 0 0 1 38.4 38.4v56.235l40.534 27.008a38.4 38.4 0 0 1-42.667 63.914l-57.6-38.4a38.4 38.4 0 0 1-17.067-31.957V672a38.4 38.4 0 0 1 38.4-38.4z"
  }));
};

var SvgOverviewIcon = function SvgOverviewIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "overview_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M180.139 128c-71.595 0-137.472 55.339-137.472 133.163v506.069c0 77.824 65.877 133.163 137.472 133.163h218.538a8.107 8.107 0 0 1 4.694 1.365L512 981.333l108.672-79.573a8.064 8.064 0 0 1 4.65-1.365h218.54c71.594 0 137.471-55.339 137.471-133.12V261.12c0-77.781-65.877-133.12-137.472-133.12H618.155c-8.576 0-17.152.768-25.6 2.304l-5.547 1.024L512 167.808l-75.008-36.48-5.547-1.024a142.165 142.165 0 0 0-25.6-2.304H180.14zM128 261.163c0-20.224 19.03-44.374 52.139-44.374h225.706c2.006 0 3.968.086 5.931.299l57.557 27.947v596.48L452.48 829.14a91.05 91.05 0 0 0-53.76-17.493H180.096c-33.152 0-52.139-24.192-52.139-44.373V261.12zm426.667 580.352v-596.48l57.557-27.947a60.16 60.16 0 0 1 5.93-.299h225.707c33.152 0 52.139 24.15 52.139 44.374v506.069c0 20.224-18.987 44.373-52.139 44.373H625.323c-19.03 0-37.974 5.974-53.76 17.536l-16.896 12.374z"
  }));
};

var SvgPadIcon = function SvgPadIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "pad_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 853.333A42.667 42.667 0 1 1 512 768a42.667 42.667 0 0 1 0 85.333zM256 42.71A170.667 170.667 0 0 0 85.333 213.376v597.333A170.667 170.667 0 0 0 256 981.376h512a170.667 170.667 0 0 0 170.667-170.667V213.376A170.667 170.667 0 0 0 768 42.709H256zm-85.333 170.667A85.333 85.333 0 0 1 256 128.043h512a85.333 85.333 0 0 1 85.333 85.333v597.333A85.333 85.333 0 0 1 768 896.043H256a85.333 85.333 0 0 1-85.333-85.334V213.376z"
  }));
};

var SvgParallelIcon = function SvgParallelIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "parallel_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M506.07 710.4 346.367 870.059a42.667 42.667 0 1 0 60.33 60.373L566.4 770.731A149.333 149.333 0 0 0 768.81 568.32l156.033-156.032a42.667 42.667 0 0 0-60.331-60.33L708.48 507.946a149.333 149.333 0 0 0-202.41 202.41zM336.596 559.787 559.104 337.28a149.333 149.333 0 1 0-57.77-62.933L273.108 502.528a149.333 149.333 0 1 0 63.531 57.259zM145.024 637.44a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm490.667-492.373a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm-62.251 494.25a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
  }));
};

var SvgPcIcon = function SvgPcIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "pc_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M170.667 64A170.667 170.667 0 0 0 0 234.667v384a170.667 170.667 0 0 0 170.667 170.666h298.666v85.334h-256V960h597.334v-85.333h-256v-85.334h298.666A170.667 170.667 0 0 0 1024 618.667v-384A170.667 170.667 0 0 0 853.333 64H170.667zM85.333 234.667a85.333 85.333 0 0 1 85.334-85.334h682.666a85.333 85.333 0 0 1 85.334 85.334v384A85.333 85.333 0 0 1 853.333 704H170.667a85.333 85.333 0 0 1-85.334-85.333v-384z"
  }));
};

var SvgPencilIcon = function SvgPencilIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "pencil_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M580.565 149.59c83.286-83.329 212.736-86.785 296.064-3.5 83.286 83.329 83.371 216.577 0 301.74L448 874.666a42.667 42.667 0 0 1-22.485 11.776l-289.835 57.6a42.667 42.667 0 0 1-49.664-49.664l54.101-293.675a42.667 42.667 0 0 1 11.819-22.485l428.63-428.63zM816.3 206.463c-50.006-50.005-125.44-46.507-175.403 3.456l-16.64 16.64 176.47 176.427 15.573-15.531a128 128 0 0 0 0-180.992zM275.627 575.147 451.328 750.89l288.896-287.702L563.925 286.89 275.627 575.146zm-55.894 64.768-38.57 209.066 205.653-41.984-167.083-167.082z"
  }));
};

var SvgPerpIcon = function SvgPerpIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "perp_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333zm-42.666 128a42.667 42.667 0 0 1 42.666-42.666h597.334a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V213.333zm128 85.334a42.667 42.667 0 0 0 0 85.333h426.666a42.667 42.667 0 1 0 0-85.333H298.667zM512 512a42.667 42.667 0 0 1 42.667-42.667h170.666a42.667 42.667 0 1 1 0 85.334H554.667A42.667 42.667 0 0 1 512 512zm0 170.667A42.667 42.667 0 0 1 554.667 640h170.666a42.667 42.667 0 1 1 0 85.333H554.667A42.667 42.667 0 0 1 512 682.667zM371.499 478.165a42.667 42.667 0 0 0-60.331 60.331l60.33 60.33-59.647 59.649a42.667 42.667 0 1 0 60.33 60.33l87.467-87.466a42.667 42.667 0 0 0 2.347-62.635l-90.454-90.539z"
  }));
};

var SvgPhoneIcon = function SvgPhoneIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "phone_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M426.667 725.333a42.667 42.667 0 1 0 0 85.334h170.666a42.667 42.667 0 1 0 0-85.334H426.667zm-128-682.666A170.667 170.667 0 0 0 128 213.333v597.334a170.667 170.667 0 0 0 170.667 170.666h426.666A170.667 170.667 0 0 0 896 810.667V213.333A170.667 170.667 0 0 0 725.333 42.667H298.667zm-85.334 170.666A85.333 85.333 0 0 1 298.667 128h426.666a85.333 85.333 0 0 1 85.334 85.333v597.334A85.333 85.333 0 0 1 725.333 896H298.667a85.333 85.333 0 0 1-85.334-85.333V213.333z"
  }));
};

var SvgPlacardIcon = function SvgPlacardIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "placard_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m446.507 743.85-3.84-18.645 311.168 149.718c84.394 40.576 184.832-18.134 184.832-110.422v-555.69c0-92.288-100.438-151.04-184.832-110.422L373.973 281.173H213.12c-70.187 0-127.787 54.827-127.787 123.35v164.266c0 48.214 28.587 89.728 69.974 110.038l43.221 166.442c14.379 55.126 65.621 93.398 124.032 93.398h12.245c84.395 0 146.432-77.995 122.88-157.355l-11.093-37.419zm-165.718 81.238-34.56-132.907h102.955l14.507 69.632a40.49 40.49 0 0 0 .81 3.286l11.606 39.04c7.594 25.6-12.288 52.053-41.387 52.053h-12.16a42.624 42.624 0 0 1-41.728-31.104zm121.942-211.072a43.05 43.05 0 0 0-18.774-4.267H213.12c-24.107 0-42.965-18.688-42.965-40.96V404.523c0-22.272 18.858-40.96 42.965-40.96h170.752c6.528 0 12.97-1.451 18.816-4.267l388.779-187.008c29.141-14.08 62.293 6.656 62.293 36.523V764.5c0 29.867-33.152 50.56-62.293 36.566L402.73 613.973z"
  }));
};

var SvgPlaceanorderIcon = function SvgPlaceanorderIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "placeanorder_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M810.667 426.667a42.667 42.667 0 1 0 85.333 0V213.333a128 128 0 0 0-128-128H256a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h256a42.667 42.667 0 1 0 0-85.334H256a42.667 42.667 0 0 1-42.667-42.666V213.333A42.667 42.667 0 0 1 256 170.667h512a42.667 42.667 0 0 1 42.667 42.666v213.334zm-512 128A42.667 42.667 0 0 1 341.333 512h128a42.667 42.667 0 1 1 0 85.333h-128a42.667 42.667 0 0 1-42.666-42.666zm0-213.334a42.667 42.667 0 0 1 42.666-42.666h256a42.667 42.667 0 1 1 0 85.333h-256a42.667 42.667 0 0 1-42.666-42.667zm311.253 462.72 127.872 122.923c4.053 3.755 8.832 6.656 14.08 8.619 10.325 4.096 21.973 4.096 32.341 0 5.248-1.963 10.027-4.864 14.08-8.619l127.83-122.923a40.363 40.363 0 0 0 12.544-29.098 40.363 40.363 0 0 0-12.544-29.099 43.69 43.69 0 0 0-30.251-12.075c-11.35 0-22.187 4.352-30.25 12.075l-54.955 53.29v-229.12c0-10.837-4.523-21.29-12.502-28.97a43.52 43.52 0 0 0-30.122-11.99 43.52 43.52 0 0 0-30.123 11.99 40.192 40.192 0 0 0-12.501 29.013v229.078l-54.955-53.334a42.795 42.795 0 0 0-30.293-12.074 44.032 44.032 0 0 0-30.251 12.117 39.637 39.637 0 0 0 0 58.197z"
  }));
};

var SvgPlusIcon = function SvgPlusIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "plus_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M554.667 213.333a42.667 42.667 0 1 0-85.334 0v256h-256a42.667 42.667 0 1 0 0 85.334h256v256a42.667 42.667 0 1 0 85.334 0v-256h256a42.667 42.667 0 1 0 0-85.334h-256v-256z"
  }));
};

var SvgPm1Icon = function SvgPm1Icon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "pm1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M853.333 170.667A42.667 42.667 0 0 1 896 213.333v469.334a42.667 42.667 0 0 1-42.667 42.666H298.667A42.667 42.667 0 0 1 256 682.667V213.333a42.667 42.667 0 0 1 42.667-42.666h554.666zM298.667 85.333a128 128 0 0 0-128 128v469.334a128 128 0 0 0 128 128h554.666a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H298.667zm119.381 200.534c33.45 0 61.867 10.538 82.133 29.184 20.31 18.73 31.488 44.842 31.488 74.24 0 29.354-11.178 55.466-31.488 74.24-20.224 18.602-48.725 29.141-82.133 29.141h-58.795v117.461h-73.386V285.867h132.266zm213.333 0 83.883 169.557 82.304-169.557h68.565v324.266h-73.386v-158.08l-51.755 103.979h-51.157l-53.632-105.13v159.231h-73.387V285.867h68.523zM359.168 425.984h56.192c14.379 0 25.045-3.925 31.915-9.856 6.656-5.717 11.008-14.421 11.008-26.88 0-12.416-4.352-21.248-11.094-27.093-6.826-6.016-17.536-9.984-31.829-9.984h-56.15v73.813zM128 384a42.667 42.667 0 0 0-85.333 0v341.333A213.333 213.333 0 0 0 256 938.667h341.333a42.667 42.667 0 1 0 0-85.334H256a128 128 0 0 1-128-128V384z"
  }));
};

var SvgQuickjumpIcon = function SvgQuickjumpIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "quickjump_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M764.587 282.453a42.667 42.667 0 0 0-23.04-23.04A42.667 42.667 0 0 0 725.333 256H298.667a42.667 42.667 0 0 0 0 85.333h323.84L268.373 695.04a42.667 42.667 0 0 0 13.867 69.93 42.667 42.667 0 0 0 46.72-9.343l353.707-354.134v323.84a42.667 42.667 0 0 0 85.333 0V298.667a42.539 42.539 0 0 0-3.413-16.214z"
  }));
};

var SvgQuoraIcon = function SvgQuoraIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M22.146 18.127h-1.373c-.07.632-.492 1.443-1.547 1.443-.961 0-1.655-.665-2.32-1.678 2.071-1.603 3.501-4.101 3.501-7.172.005-5.508-4.528-9.22-9.3-9.22-4.673 0-9.267 3.736-9.267 9.22 0 6.286 6.155 10.388 11.672 8.86.923 1.575 2.142 2.92 4.462 2.92 3.835 0 4.256-3.53 4.172-4.373ZM15.42 15.43c-.914-1.368-2.048-2.447-4.289-2.447-1.43 0-2.545.47-3.234 1.07l.572 1.138c.29-.14.61-.187.928-.187 1.664 0 2.517 1.443 3.244 2.873-.469.14-.97.197-1.533.197-3.516 0-5.039-2.484-5.039-7.345 0-4.894 1.523-7.402 5.039-7.402 3.572 0 5.095 2.508 5.095 7.392.005 1.96-.253 3.544-.783 4.711Z"
  }));
};

var SvgQuotesCutoverIcon = function SvgQuotesCutoverIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "quotes_cutover_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M725.333 85.333A42.667 42.667 0 0 0 682.667 128v85.333a128 128 0 0 0-128 128v341.334a128 128 0 0 0 128 128V896A42.667 42.667 0 1 0 768 896v-85.333a128 128 0 0 0 128-128V341.333a128 128 0 0 0-128-128V128a42.667 42.667 0 0 0-42.667-42.667zm-85.333 256a42.667 42.667 0 0 1 42.667-42.666H768a42.667 42.667 0 0 1 42.667 42.666v341.334A42.667 42.667 0 0 1 768 725.333h-85.333A42.667 42.667 0 0 1 640 682.667V341.333zM298.667 170.667A42.667 42.667 0 0 0 256 213.333v85.334a128 128 0 0 0-128 128V640a128 128 0 0 0 128 128v85.333a42.667 42.667 0 1 0 85.333 0V768a128 128 0 0 0 128-128V426.667a128 128 0 0 0-128-128v-85.334a42.667 42.667 0 0 0-42.666-42.666zm-85.334 256A42.667 42.667 0 0 1 256 384h85.333A42.667 42.667 0 0 1 384 426.667V640a42.667 42.667 0 0 1-42.667 42.667H256A42.667 42.667 0 0 1 213.333 640V426.667z"
  }));
};

var SvgRateIcon = function SvgRateIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "rate_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M153.6 512c0 198.101 160.299 358.4 358.4 358.4 198.101 0 358.4-160.299 358.4-358.4 0-198.101-160.299-358.4-358.4-358.4A358.187 358.187 0 0 0 153.6 512zm806.4 0c0 247.595-200.405 448-448 448S64 759.595 64 512 264.405 64 512 64s448 200.405 448 448zM591.36 663.68a29.653 29.653 0 1 1 59.307 0 29.653 29.653 0 0 1-59.307 0zm29.61-93.653a93.653 93.653 0 1 0 0 187.306 93.653 93.653 0 0 0 0-187.306zm-217.983-239.36a29.653 29.653 0 1 0 0 59.306 29.653 29.653 0 0 0 0-59.306zm-93.654 29.653a93.653 93.653 0 1 1 187.307 0 93.653 93.653 0 0 1-187.307 0zm.768 282.325c-19.669 19.67-22.144 49.152-5.504 65.835 16.683 16.64 46.166 14.208 65.878-5.504l340.949-340.992c19.712-19.67 22.187-49.152 5.547-65.835-16.683-16.64-46.166-14.208-65.878 5.547L310.101 642.603z"
  }));
};

var SvgRaysIcon = function SvgRaysIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "rays_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M905.259 176.085a42.667 42.667 0 0 0-60.331-60.33L559.744 400.896A149.333 149.333 0 0 0 355.84 597.632l-56.875 56.875a149.333 149.333 0 1 0 63.36 57.301l50.859-50.773a149.333 149.333 0 0 0 207.787-200.662l284.288-284.288zM234.667 725.333a64 64 0 1 1 0 128 64 64 0 0 1 0-128zm192-192a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
  }));
};

var SvgRectangleIcon = function SvgRectangleIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "rectangle_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M796.16 166.784a61.056 61.056 0 1 0 0 122.112 61.056 61.056 0 0 0 0-122.112zm-467.03 83.115a79.232 79.232 0 0 0-79.23 79.231v326.23a142.635 142.635 0 0 1 118.74 118.741h326.23a79.232 79.232 0 0 0 79.23-79.231V368.64a142.635 142.635 0 0 1-118.74-118.741H329.13zm-164.565 418.56V329.088a164.565 164.565 0 0 1 164.566-164.565h339.285A142.507 142.507 0 1 1 859.435 355.54v339.286a164.565 164.565 0 0 1-164.566 164.565H355.584a142.507 142.507 0 1 1-191.019-191.019zm2.219 127.701a61.056 61.056 0 1 0 122.112 0 61.056 61.056 0 0 0-122.112 0z"
  }));
};

var SvgRecurringbuyIcon = function SvgRecurringbuyIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "recurringbuy_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M725.333 128A42.667 42.667 0 1 0 640 128v42.667H384V128a42.667 42.667 0 0 0-85.333 0v42.667h-85.334a128 128 0 0 0-128 128v512a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128v-512a128 128 0 0 0-128-128h-85.334V128zM298.667 298.667a42.667 42.667 0 0 0 85.333 0V256h256v42.667a42.667 42.667 0 1 0 85.333 0V256h85.334a42.667 42.667 0 0 1 42.666 42.667v512a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666v-512A42.667 42.667 0 0 1 213.333 256h85.334v42.667zm448 256a64 64 0 1 0-63.915-60.416L579.584 597.419a65.835 65.835 0 0 0-7.125 0l-82.219-82.176a64 64 0 1 0-127.147 0l-82.218 82.176a64 64 0 1 0 60.33 60.33l85.462-85.376 85.418 85.419a64 64 0 1 0 127.787 0l103.253-103.168 3.542.085z"
  }));
};

var SvgRedditIcon = function SvgRedditIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M9.478 12c.63 0 1.145.515 1.145 1.145s-.514 1.145-1.145 1.145c-.63 0-1.145-.515-1.145-1.145S8.848 12 9.478 12ZM12.013 17.005c.437 0 1.93-.052 2.714-.837a.33.33 0 0 0 .026-.424.303.303 0 0 0-.424 0c-.502.489-1.544.669-2.303.669-.76 0-1.814-.18-2.303-.67a.303.303 0 0 0-.425 0 .303.303 0 0 0 0 .425c.772.772 2.277.837 2.715.837ZM13.377 13.145c0 .63.514 1.145 1.145 1.145.63 0 1.145-.515 1.145-1.145S15.152 12 14.522 12s-1.145.515-1.145 1.145Z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Zm-5.275-1.608c-.437 0-.823.167-1.106.45-1.094-.785-2.612-1.3-4.284-1.364l.733-3.435 2.38.502a1.146 1.146 0 0 0 2.29-.051c0-.63-.515-1.145-1.145-1.145-.45 0-.836.257-1.016.643l-2.664-.566a.32.32 0 0 0-.218.038.313.313 0 0 0-.129.18l-.81 3.834c-1.712.052-3.243.554-4.349 1.364a1.623 1.623 0 0 0-1.106-.45 1.609 1.609 0 0 0-.657 3.075 3.01 3.01 0 0 0-.038.489c0 2.47 2.869 4.464 6.42 4.464 3.55 0 6.42-1.994 6.42-4.465 0-.167-.013-.321-.039-.476.527-.257.926-.823.926-1.479 0-.888-.72-1.608-1.608-1.608Z"
  }));
};

var SvgReduceIcon = function SvgReduceIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "reduce_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M170.667 512a42.667 42.667 0 0 1 42.666-42.667h597.334a42.667 42.667 0 1 1 0 85.334H213.333A42.667 42.667 0 0 1 170.667 512z"
  }));
};

var SvgRefreshIcon = function SvgRefreshIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "refresh_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M262.912 139.008a426.667 426.667 0 0 1 507.435 70.912l125.61 118.059V170.667a42.667 42.667 0 1 1 85.334 0v256.896a42.539 42.539 0 0 1-42.667 41.77h-256a42.667 42.667 0 1 1 0-85.333h148.31L711.466 271.744a341.333 341.333 0 1 0 79.872 354.09 42.667 42.667 0 0 1 80.426 28.331 426.667 426.667 0 1 1-608.853-515.157z"
  }));
};

var SvgRemoveIcon = function SvgRemoveIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "remove_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 938.667c235.648 0 426.667-191.019 426.667-426.667S747.648 85.333 512 85.333 85.333 276.352 85.333 512 276.352 938.667 512 938.667zM853.333 512a341.333 341.333 0 1 1-682.666 0 341.333 341.333 0 0 1 682.666 0zm-512-42.667a42.667 42.667 0 1 0 0 85.334h341.334a42.667 42.667 0 1 0 0-85.334H341.333z"
  }));
};

var SvgRemoveSolidIcon = function SvgRemoveSolidIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "remove_solid_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M981.333 512c0 259.2-210.133 469.333-469.333 469.333S42.667 771.2 42.667 512 252.8 42.667 512 42.667 981.333 252.8 981.333 512zm-640-42.667a42.667 42.667 0 1 0 0 85.334h341.334a42.667 42.667 0 1 0 0-85.334H341.333z"
  }));
};

var SvgResourceIcon = function SvgResourceIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "resource_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M715.093 128H308.907a128.085 128.085 0 0 0-114.56 70.997v.043L47.573 492.16A42.496 42.496 0 0 0 42.667 512v256a128 128 0 0 0 128 128h682.666a128 128 0 0 0 128-128V510.379a42.496 42.496 0 0 0-4.906-18.262L829.653 199.04v-.043A128 128 0 0 0 715.093 128zm154.454 341.333h-186.88a42.667 42.667 0 0 0-35.499 18.987l-72.661 109.013H449.493L376.832 488.32a42.667 42.667 0 0 0-35.499-18.987h-186.88l116.224-232.192L256 234.667l14.763 2.346a42.667 42.667 0 0 1 38.144-23.68h406.186a42.667 42.667 0 0 1 38.144 23.68l.086.128 116.224 232.192zM128 554.667h190.507l72.661 109.013a42.667 42.667 0 0 0 35.499 18.987h170.666a42.667 42.667 0 0 0 35.499-18.987l72.661-109.013H896V768a42.667 42.667 0 0 1-42.667 42.667H170.667A42.667 42.667 0 0 1 128 768V554.667z"
  }));
};

var SvgRetraceIcon = function SvgRetraceIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "retrace_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M234.667 725.333a64 64 0 1 0 0 128 64 64 0 0 0 0-128zm0-85.333a149.419 149.419 0 0 1 143.146 106.667H896A42.667 42.667 0 1 1 896 832H377.813a149.419 149.419 0 0 1-292.48-42.667A149.333 149.333 0 0 1 234.667 640zM85.333 576A42.667 42.667 0 0 1 128 533.333h768a42.667 42.667 0 1 1 0 85.334H128A42.667 42.667 0 0 1 85.333 576zm0-426.667A42.667 42.667 0 0 1 128 106.667h768A42.667 42.667 0 1 1 896 192H128a42.667 42.667 0 0 1-42.667-42.667zM128 320a42.667 42.667 0 1 0 0 85.333h390.187a149.419 149.419 0 0 0 286.293 0H896A42.667 42.667 0 1 0 896 320h-91.52a149.419 149.419 0 0 0-286.293 0H128zm597.333 42.667a64 64 0 1 1-128 0 64 64 0 0 1 128 0z"
  }));
};

var SvgRewardsIcon = function SvgRewardsIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m10.827 7.148 4.178-2.412 1.393 2.412h-5.571Zm-4 0 7.178-4.144a2 2 0 0 1 2.732.732l1.97 3.412H20a2 2 0 0 1 2 2v2c0 .553-.474.98-.959 1.245a2 2 0 0 0 0 3.511c.485.265.959.692.959 1.244v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V17c0-.552.475-.98.959-1.245a2 2 0 0 0 0-3.51C2.475 11.978 2 11.551 2 11V9.148a2 2 0 0 1 2-2h2.827Zm4.898 4.198a.29.29 0 0 1 .55 0l.584 1.716h1.85c.284 0 .4.367.165.53l-1.485 1.03.575 1.69a.29.29 0 0 1-.441.333L12 15.588l-1.523 1.057a.29.29 0 0 1-.44-.332l.574-1.69-1.486-1.032a.29.29 0 0 1 .166-.53h1.85l.584-1.715ZM20 10.684V9.148H4v1.387a3.999 3.999 0 0 1 0 6.93v1.683h16v-1.535a4 4 0 0 1 0-6.929Z"
  }));
};

var SvgRmIcon = function SvgRmIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "rm_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M42.667 262.656c0-99.03 73.6-177.323 162.133-177.323h614.4c88.533 0 162.133 78.294 162.133 177.323v498.688c0 99.03-73.6 177.323-162.133 177.323H204.8c-88.533 0-162.133-78.294-162.133-177.323V262.656zm85.333 0v498.688c0 46.08 34.39 83.456 76.8 83.456h614.4c42.41 0 76.8-37.376 76.8-83.456V262.656c0-46.08-34.39-83.456-76.8-83.456H204.8c-42.41 0-76.8 37.376-76.8 83.456zm361.259 105.643h100.693l69.205 185.6h3.499l69.248-185.6h100.65v327.68h-79.146v-189.44h-2.304l-66.347 186.88h-47.701l-66.347-188.16h-2.304v190.72H489.26v-327.68zm-34.219 122.88h-82.005a66.176 66.176 0 0 0-4.694-20.31 46.08 46.08 0 0 0-25.728-25.941 55.467 55.467 0 0 0-20.778-3.67c-13.568 0-25.088 3.627-34.475 10.88-9.301 7.254-16.384 17.665-21.248 31.19-4.736 13.568-7.125 29.824-7.125 48.81 0 20.054 2.432 36.865 7.253 50.39 4.95 13.44 12.075 23.595 21.419 30.421 9.301 6.699 20.48 10.07 33.578 10.07 7.467 0 14.166-1.024 20.054-3.03a45.91 45.91 0 0 0 26.026-23.381c2.859-5.632 4.736-11.99 5.718-19.03l82.005.64a131.84 131.84 0 0 1-10.581 42.411 138.325 138.325 0 0 1-26.027 39.68c-11.179 12.032-25.003 21.76-41.472 29.099-16.512 7.381-35.627 11.05-57.472 11.05-27.307 0-51.883-6.442-73.6-19.37-21.632-12.885-38.741-31.872-51.328-56.96-12.501-25.045-18.773-55.723-18.773-91.99 0-36.48 6.4-67.2 19.2-92.16 12.8-25.087 30.08-43.989 51.797-56.789a139.648 139.648 0 0 1 72.704-19.37c18.816 0 36.139 2.816 51.925 8.49 15.787 5.632 29.696 13.91 41.6 24.79 11.947 10.752 21.547 24.064 28.8 39.85 7.254 15.787 11.691 33.835 13.227 54.23z"
  }));
};

var SvgRulerIcon = function SvgRulerIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "ruler_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M898.56 253.568 774.357 129.28a165.973 165.973 0 0 0-234.752 0L129.28 539.563a165.973 165.973 0 0 0 0 234.752l124.288 124.288a165.973 165.973 0 0 0 234.752 0L898.603 488.32a165.973 165.973 0 0 0 0-234.752zm-60.33 60.33a80.64 80.64 0 0 1 0 114.091L427.99 838.23a80.64 80.64 0 0 1-114.091 0L189.61 713.984a80.64 80.64 0 0 1 0-114.09l3.242-3.2c1.579 2.474 3.499 4.82 5.675 6.997l106.496 106.496a42.667 42.667 0 0 0 60.33-60.331L258.86 543.36a43.05 43.05 0 0 0-6.998-5.675l63.574-63.573a42.667 42.667 0 0 0 2.261 2.475l54.827 54.869a42.667 42.667 0 0 0 60.373-60.373l-54.87-54.87a43.264 43.264 0 0 0-2.474-2.261L431.19 358.4a42.581 42.581 0 0 0 5.675 6.997L543.36 471.893a42.667 42.667 0 0 0 60.33-60.33L497.196 305.067a43.008 43.008 0 0 0-6.998-5.675l55.595-55.637c.725.853 1.493 1.706 2.304 2.474l54.827 54.827a42.667 42.667 0 1 0 60.373-60.33l-54.87-54.87a43.008 43.008 0 0 0-2.133-2.005 80.683 80.683 0 0 1 107.691 5.76L838.23 313.899z"
  }));
};

var SvgSafetyIcon = function SvgSafetyIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "safety_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m549.547 919.637-38.528 19.03-38.059-19.84-14.25-7.296c-71.851-36.822-214.571-109.867-307.585-264.875-31.488-52.523-46.378-123.733-54.485-186.368-8.49-65.493-10.965-134.144-11.307-189.184a101.632 101.632 0 0 1 76.544-98.73L480.94 89.258a123.307 123.307 0 0 1 62.122 0l319.062 83.114a101.547 101.547 0 0 1 76.544 98.944c-.982 106.368-12.459 262.144-58.368 366.208-77.654 176.043-225.152 237.483-300.459 268.843-12.203 5.12-22.528 9.387-30.293 13.227zM485.248 648.15l249.301-255.701a42.667 42.667 0 1 0-61.098-59.563L453.29 558.677l-103.85-98.901a42.667 42.667 0 1 0-58.88 61.781L424.661 649.26c17.067 16.298 44.118 15.786 60.587-1.11z"
  }));
};

var SvgScanIcon = function SvgScanIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "scan_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M213.333 85.333a128 128 0 0 0-128 128v128a42.667 42.667 0 0 0 85.334 0v-128a42.667 42.667 0 0 1 42.666-42.666h128a42.667 42.667 0 0 0 0-85.334h-128zm469.334 0a42.667 42.667 0 1 0 0 85.334h128a42.667 42.667 0 0 1 42.666 42.666v128a42.667 42.667 0 1 0 85.334 0v-128a128 128 0 0 0-128-128h-128zm-512 597.334a42.667 42.667 0 1 0-85.334 0v128a128 128 0 0 0 128 128h128a42.667 42.667 0 1 0 0-85.334h-128a42.667 42.667 0 0 1-42.666-42.666v-128zm768 0a42.667 42.667 0 1 0-85.334 0v128a42.667 42.667 0 0 1-42.666 42.666h-128a42.667 42.667 0 1 0 0 85.334h128a128 128 0 0 0 128-128v-128zM128 469.333a42.667 42.667 0 1 0 0 85.334h768a42.667 42.667 0 1 0 0-85.334H128z"
  }));
};

var SvgScreenshotIcon = function SvgScreenshotIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "screenshot_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M412.16 128a128 128 0 0 0-111.104 64.512l-48.47 84.821h-39.253a128 128 0 0 0-128 128V768a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V405.333a128 128 0 0 0-128-128h-39.254l-48.469-84.821A128 128 0 0 0 611.84 128H412.203zm-37.035 106.837a42.667 42.667 0 0 1 37.078-21.504h199.594a42.667 42.667 0 0 1 37.078 21.504l60.757 106.326a42.667 42.667 0 0 0 37.035 21.504h64a42.667 42.667 0 0 1 42.666 42.666V768a42.667 42.667 0 0 1-42.666 42.667H213.333A42.667 42.667 0 0 1 170.667 768V405.333a42.667 42.667 0 0 1 42.666-42.666h64a42.667 42.667 0 0 0 37.035-21.504l60.757-106.326zM512 768a213.333 213.333 0 1 0 0-426.667A213.333 213.333 0 0 0 512 768zm128-213.333a128 128 0 1 1-256 0 128 128 0 0 1 256 0z"
  }));
};

var SvgSearchIcon = function SvgSearchIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "search_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M170.667 469.333a298.667 298.667 0 1 1 597.333 0 298.667 298.667 0 0 1-597.333 0zm298.666-384a384 384 0 1 0 239.702 684.032l156.8 156.8a42.667 42.667 0 0 0 60.33-60.33l-156.8-156.8A384 384 0 0 0 469.333 85.333z"
  }));
};

var SvgSectorIcon = function SvgSectorIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "sector_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "m635.733 388.267 60.459-213.334a386.219 386.219 0 0 1 152.875 152.918l-213.248 60.416zm314.454-44.715A470.784 470.784 0 0 0 680.448 73.813c-21.973-8.448-45.653 4.907-52.053 27.563l-95.574 337.11a42.667 42.667 0 0 0 52.694 52.693l337.109-95.574c22.699-6.4 36.01-30.08 27.563-52.053zM170.667 512A341.333 341.333 0 0 1 512 170.667a42.667 42.667 0 1 0 0-85.334C276.352 85.333 85.333 276.352 85.333 512S276.352 938.667 512 938.667 938.667 747.648 938.667 512a42.667 42.667 0 1 0-85.334 0 341.333 341.333 0 1 1-682.666 0z"
  }));
};

var SvgServiceIcon = function SvgServiceIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "service_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M170.667 554.667V576a64 64 0 0 1-128 0v-85.333a64 64 0 0 1 50.944-62.678C132.608 232.576 305.109 85.333 512 85.333c206.933 0 379.392 147.243 418.39 342.656a64 64 0 0 1 50.943 62.678V576a64 64 0 0 1-50.944 62.677 427.221 427.221 0 0 1-205.44 285.824 64 64 0 1 1-10.794-43.306 384.427 384.427 0 0 0 173.866-248.32A64 64 0 0 1 853.333 576v-64a341.333 341.333 0 1 0-682.666 0v42.667z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M810.752 512a298.667 298.667 0 0 1-457.387 253.013l-137.984 34.475a21.333 21.333 0 0 1-24.32-30.08l57.472-116.779A298.667 298.667 0 1 1 810.752 512zM512.085 682.667a170.752 170.752 0 0 0 165.291-128h-44.587a128.043 128.043 0 0 1-241.408 0h-44.586c18.944 73.6 85.76 128 165.29 128z"
  }));
};

var SvgSettingIcon = function SvgSettingIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "setting_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M719.53 193.067a42.752 42.752 0 0 0-37.034-21.547H341.504a42.611 42.611 0 0 0-37.035 21.547L133.973 490.453c-7.68 13.355-7.68 29.782 0 43.094L304.47 830.933c7.638 13.355 21.76 21.547 37.035 21.547h340.992a42.611 42.611 0 0 0 37.035-21.547l170.496-297.386c7.68-13.355 7.68-29.782 0-43.094L719.53 193.067zM230.4 149.973a128.213 128.213 0 0 1 111.104-64.64h340.992c45.867 0 88.235 24.619 111.147 64.64L964.139 447.36a130.048 130.048 0 0 1 0 129.28L793.643 874.027a128.213 128.213 0 0 1-111.147 64.64H341.504a128.213 128.213 0 0 1-111.104-64.64L59.904 576.64a130.048 130.048 0 0 1 0-129.28L230.4 149.973zm195.243 361.174c0-47.574 38.314-86.187 85.546-86.187 47.275 0 85.59 38.613 85.59 86.187 0 47.616-38.315 86.186-85.59 86.186a85.888 85.888 0 0 1-85.546-86.186zm85.546-172.374c-94.506 0-171.136 77.184-171.136 172.374S416.683 683.52 511.19 683.52s171.136-77.184 171.136-172.373-76.629-172.374-171.093-172.374z"
  }));
};

var SvgSettingKlineIcon = function SvgSettingKlineIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "setting_kline_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M341.333 256a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 143.147 192H896a42.667 42.667 0 1 0 0-85.334H548.48a149.419 149.419 0 0 0-143.147-106.666zM213.333 256a42.667 42.667 0 0 1-42.666 42.667H128a42.667 42.667 0 0 1 0-85.334h42.667A42.667 42.667 0 0 1 213.333 256zM640 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 143.147 192H896a42.667 42.667 0 1 0 0-85.334h-48.853A149.419 149.419 0 0 0 704 362.667zM512 512a42.667 42.667 0 0 1-42.667 42.667H128a42.667 42.667 0 1 1 0-85.334h341.333A42.667 42.667 0 0 1 512 512zM320 704a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM128 810.667h48.853A149.419 149.419 0 0 0 469.333 768a149.333 149.333 0 0 0-292.48-42.667H128a42.667 42.667 0 1 0 0 85.334zm426.667-85.334a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H554.667z"
  }));
};

var SvgShareIcon = function SvgShareIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "share_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M640 85.333h256l42.667 42.88V384a42.667 42.667 0 1 1-85.334 0V230.997L456.832 627.5a42.667 42.667 0 0 1-60.33-60.331l396.5-396.501H640a42.667 42.667 0 1 1 0-85.334zm256 0L938.667 128c0-1.024 0-2.048-.128-3.072A42.496 42.496 0 0 0 896 85.333zM183.168 311.168a42.667 42.667 0 0 1 30.165-12.501h256a42.667 42.667 0 1 0 0-85.334h-256a128 128 0 0 0-128 128v469.334a128 128 0 0 0 128 128h469.334a128 128 0 0 0 128-128v-256a42.667 42.667 0 1 0-85.334 0v256a42.667 42.667 0 0 1-42.666 42.666H213.333a42.667 42.667 0 0 1-42.666-42.666V341.333a42.667 42.667 0 0 1 12.501-30.165z"
  }));
};

var SvgSortDefault1Icon = function SvgSortDefault1Icon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "sort_default1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M465.579 105.43 230.656 356.01c-38.101 40.662-9.259 107.137 46.421 107.137h469.846c55.68 0 84.48-66.475 46.421-107.094L558.421 105.387a63.616 63.616 0 0 0-92.842 0zm91.818 815.829 230.187-204.63c46.933-41.728 17.45-119.381-45.355-119.381H281.771c-62.806 0-92.331 77.653-45.355 119.381l230.187 204.63c25.898 23.04 64.896 23.04 90.794 0z"
  }));
};

var SvgSortIcon = function SvgSortIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "sort_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M469.333 149.333a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H469.333zm0 426.667a42.667 42.667 0 1 0 0 85.333H896A42.667 42.667 0 1 0 896 576H469.333zm-42.666-170.667a42.667 42.667 0 0 1 42.666-42.666H896A42.667 42.667 0 1 1 896 448H469.333a42.667 42.667 0 0 1-42.666-42.667zm42.666 384a42.667 42.667 0 1 0 0 85.334H896a42.667 42.667 0 1 0 0-85.334H469.333zm-234.666-704a42.667 42.667 0 0 1 30.165 12.502L371.499 204.5a42.667 42.667 0 0 1-60.331 60.331l-33.835-33.835V384A42.667 42.667 0 0 1 192 384V230.997l-33.835 33.835a42.667 42.667 0 0 1-60.33-60.33L204.5 97.834a42.667 42.667 0 0 1 30.166-12.502zm0 853.334a42.667 42.667 0 0 0 30.165-12.502L371.499 819.5a42.667 42.667 0 1 0-60.331-60.331l-33.835 33.835V640A42.667 42.667 0 1 0 192 640v153.003l-33.835-33.835a42.667 42.667 0 0 0-60.33 60.33L204.5 926.166a42.667 42.667 0 0 0 30.166 12.502z"
  }));
};

var SvgSpotIcon = function SvgSpotIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "spot_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M785.92 128.939A158.805 158.805 0 0 1 901.12 281.6V320a43.52 43.52 0 0 1-87.04 0v-38.4a71.68 71.68 0 0 0-71.68-71.68H704a43.52 43.52 0 0 1-30.72-74.283l38.4-38.4a43.52 43.52 0 0 1 74.24 31.702zM263.253 679.168a312.32 312.32 0 1 1 416-416 43.52 43.52 0 0 1-13.952 54.016 312.363 312.363 0 1 1-348.16 348.16 43.52 43.52 0 0 1-53.888 13.824zm52.011-67.285A312.32 312.32 0 0 1 612.011 315.22a43.392 43.392 0 0 1-11.435-14.762 225.28 225.28 0 1 0-300.032 300.074c5.845 2.774 10.795 6.656 14.72 11.35zM852.437 627.2a225.28 225.28 0 1 0-450.517 0 225.28 225.28 0 0 0 450.56 0zm-729.6 76.8a43.52 43.52 0 0 1 87.04 0v38.4c0 39.595 32.128 71.68 71.68 71.68h38.4a43.52 43.52 0 0 1 30.806 74.283l-38.4 38.4a43.52 43.52 0 0 1-74.24-31.659A158.805 158.805 0 0 1 122.795 742.4V704z"
  }));
};

var SvgSpsxNew1Icon = function SvgSpsxNew1Icon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "spsx-new1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M128 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 143.147 192h603.562a42.667 42.667 0 1 0 0-85.334H335.147A149.419 149.419 0 0 0 192 362.667zM351.317 384v-43.35h67.414V172.886h-3.286l-50.858 66.688-34.432-26.88 59.861-78.848h82.432v206.806h53.035V384H351.317zm378.752 0H553.003v-49.067l77.098-65.962c6.912-5.974 12.8-11.35 17.579-16.128 4.736-5.035 8.576-9.814 11.435-14.336 3.114-4.779 5.248-9.43 6.485-13.995 1.408-4.523 2.133-9.43 2.133-14.677V204.8a26.283 26.283 0 0 0-10.41-21.504 39.424 39.424 0 0 0-22.614-7.168 40.363 40.363 0 0 0-15.701 2.859 37.803 37.803 0 0 0-11.52 7.893 42.325 42.325 0 0 0-7.85 11.093 60.975 60.975 0 0 0-5.035 13.27l-46.934-17.92a104.25 104.25 0 0 1 11.819-24.32c5.035-7.936 11.221-14.72 18.645-20.48 7.68-5.974 16.64-10.624 26.88-13.952 10.24-3.371 21.846-5.035 34.774-5.035 13.61 0 25.685 1.92 36.181 5.76 10.539 3.84 19.37 9.045 26.539 15.787 7.381 6.656 13.013 14.677 16.853 23.978 3.84 9.088 5.717 18.987 5.717 29.739 0 10.752-1.792 20.565-5.376 29.397a102.912 102.912 0 0 1-14.72 25.088c-5.973 7.68-13.013 14.934-21.12 21.846-8.106 6.954-16.64 13.994-25.429 21.162l-46.635 36.566H730.07V384zm111.275-151.253c13.355 0 23.04-2.475 29.013-7.51a24.405 24.405 0 0 0 9.302-19.37v-2.475a28.288 28.288 0 0 0-8.96-21.888c-5.718-5.504-13.952-8.235-24.747-8.235-9.984 0-19.456 2.646-28.288 7.894a65.579 65.579 0 0 0-22.57 21.845l-33.707-31.573c4.821-6.187 9.941-11.776 15.445-16.811 5.461-5.248 11.69-9.685 18.603-13.227a87.04 87.04 0 0 1 23.296-8.618 119.893 119.893 0 0 1 29.013-3.243c13.397 0 25.472 1.579 36.267 4.693 10.965 3.072 20.266 7.638 27.904 13.611 7.893 5.717 13.866 12.63 17.92 20.779 4.309 8.106 6.485 17.194 6.485 27.221 0 7.893-1.323 15.061-3.968 21.504a48.725 48.725 0 0 1-10.368 16.853 55.893 55.893 0 0 1-15.061 11.819 68.565 68.565 0 0 1-18.262 6.101v2.134c7.382 1.45 14.208 3.84 20.395 7.168 6.443 3.114 11.947 7.168 16.512 12.202 4.779 5.035 8.448 11.008 11.093 17.92 2.646 6.699 3.968 14.336 3.968 22.955 0 11.221-2.304 21.333-6.826 30.464a67.03 67.03 0 0 1-19.371 23.296 93.653 93.653 0 0 1-30.08 15.019 140.587 140.587 0 0 1-38.699 5.034c-12.672 0-23.893-1.28-33.706-3.925a105.813 105.813 0 0 1-25.814-10.41 100.992 100.992 0 0 1-18.986-15.403 127.744 127.744 0 0 1-13.995-18.304l39.808-30.806c5.461 10.24 12.16 18.774 20.053 25.43 8.107 6.485 18.987 9.685 32.64 9.685 12.16 0 21.59-2.987 28.288-8.96a32 32 0 0 0 10.411-25.088v-2.133c0-10.283-3.968-17.92-11.819-22.955-7.68-5.248-18.304-7.893-31.914-7.893h-22.614v-44.8h23.339z"
  }));
};

var SvgSpsxIcon = function SvgSpsxIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "spsx_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M128 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0zm64-149.333a149.333 149.333 0 1 0 143.147 192h603.52a42.667 42.667 0 1 0 0-85.334h-603.52A149.419 149.419 0 0 0 192 362.667z"
  }));
};

var SvgSquareIcon = function SvgSquareIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "square_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M213.333 170.667a42.667 42.667 0 0 0-42.666 42.666v597.334a42.667 42.667 0 0 0 42.666 42.666h597.334a42.667 42.667 0 0 0 42.666-42.666V213.333a42.667 42.667 0 0 0-42.666-42.666H213.333zm-128 42.666a128 128 0 0 1 128-128h597.334a128 128 0 0 1 128 128v597.334a128 128 0 0 1-128 128H213.333a128 128 0 0 1-128-128V213.333z"
  }));
};

var SvgStarnoIcon = function SvgStarnoIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "starno_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 42.667a42.667 42.667 0 0 1 38.272 23.765l121.899 247.04 272.64 39.85a42.667 42.667 0 0 1 23.637 72.747L771.2 618.197l46.507 271.446a42.667 42.667 0 0 1-61.867 44.97L512 806.4 268.16 934.613a42.667 42.667 0 0 1-61.867-44.97L252.8 618.197 55.552 426.07a42.667 42.667 0 0 1 23.595-72.746l272.64-39.894L473.728 66.432A42.667 42.667 0 0 1 512 42.667zm0 139.093-93.568 189.525a42.667 42.667 0 0 1-32.085 23.296L176.98 425.216l151.467 147.499a42.667 42.667 0 0 1 12.288 37.76L304.98 818.816l187.179-98.432a42.667 42.667 0 0 1 39.68 0l187.179 98.432-35.755-208.341a42.667 42.667 0 0 1 12.288-37.76l151.467-147.499-209.366-30.635a42.667 42.667 0 0 1-32.085-23.296L512 181.717z"
  }));
};

var SvgStaryesIcon = function SvgStaryesIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "staryes_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 42.667a42.667 42.667 0 0 1 38.272 23.765l121.899 247.04 272.64 39.85a42.667 42.667 0 0 1 23.637 72.747L771.2 618.197l46.507 271.446a42.667 42.667 0 0 1-61.867 44.97L512 806.4 268.16 934.613a42.667 42.667 0 0 1-61.867-44.97L252.8 618.197 55.552 426.07a42.667 42.667 0 0 1 23.595-72.746l272.64-39.894L473.728 66.432A42.667 42.667 0 0 1 512 42.667z"
  }));
};

var SvgStrategyIcon = function SvgStrategyIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "strategy_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M298.667 85.333h426.666a213.333 213.333 0 0 1 213.334 213.334V512a213.333 213.333 0 0 1-213.334 213.333H298.667A213.333 213.333 0 0 1 85.333 512V298.667A213.333 213.333 0 0 1 298.667 85.333zm0 85.334a128 128 0 0 0-128 128V512a128 128 0 0 0 128 128h426.666a128 128 0 0 0 128-128V298.667a128 128 0 0 0-128-128H298.667zm246.528 128A42.667 42.667 0 0 1 587.86 256h137.472a42.667 42.667 0 0 1 30.166 72.832l-189.61 189.653a42.667 42.667 0 0 1-53.845 5.334l-71.168-47.446-118.528 79.019a42.667 42.667 0 1 1-47.36-70.997l142.293-94.806a42.667 42.667 0 0 1 47.36 0l65.707 43.819 91.946-92.075H587.82a42.667 42.667 0 0 1-42.667-42.666zM294.784 927.445a1536.085 1536.085 0 0 1 434.432 0l75.435 10.795a42.667 42.667 0 1 0 12.032-84.48l-75.392-10.795a1621.419 1621.419 0 0 0-458.582 0l-75.392 10.795a42.667 42.667 0 1 0 12.075 84.48l75.392-10.795z"
  }));
};

var SvgStrategyhistoryIcon = function SvgStrategyhistoryIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "strategyhistory_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M554.667 729.6a153.6 153.6 0 1 1 307.2 0 153.6 153.6 0 0 1-307.2 0zm153.6-230.4a230.4 230.4 0 1 0 0 460.8 230.4 230.4 0 0 0 0-460.8zm28.8 172.8a38.4 38.4 0 1 0-76.8 0v76.8c0 12.8 6.4 24.832 17.066 31.957l57.6 38.4a38.4 38.4 0 1 0 42.667-63.914l-40.533-27.008V672zM85.333 256A170.667 170.667 0 0 1 256 85.333h426.667A170.667 170.667 0 0 1 853.333 256v128A42.667 42.667 0 1 1 768 384V256a85.333 85.333 0 0 0-85.333-85.333H256A85.333 85.333 0 0 0 170.667 256v512A85.333 85.333 0 0 0 256 853.333h128a42.667 42.667 0 1 1 0 85.334H256A170.667 170.667 0 0 1 85.333 768V256zm587.435 112.64a42.667 42.667 0 1 0-65.536-54.613l-79.019 94.72-116.48-99.84a42.667 42.667 0 0 0-60.586 5.12l-106.667 128a42.667 42.667 0 0 0 65.579 54.613l79.061-94.72 116.48 99.84a42.667 42.667 0 0 0 60.587-5.12l106.666-128z"
  }));
};

var SvgStratrgyorderIcon = function SvgStratrgyorderIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "stratrgyorder_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M341.333 234.667a85.333 85.333 0 0 1 85.334-85.334h218.581a85.333 85.333 0 0 1 59.221 23.894l122.752 118.4a85.333 85.333 0 0 1 26.112 61.44V640A85.333 85.333 0 0 1 768 725.333H426.667A85.333 85.333 0 0 1 341.333 640V234.667zM426.667 64A170.667 170.667 0 0 0 256 234.667 170.667 170.667 0 0 0 85.333 405.333v384A170.667 170.667 0 0 0 256 960h302.507a166.827 166.827 0 0 0 165.93-149.333H768A170.667 170.667 0 0 0 938.667 640V353.067a170.667 170.667 0 0 0-52.224-122.88l-122.71-118.358A170.667 170.667 0 0 0 645.205 64H426.667zm211.456 746.667a81.536 81.536 0 0 1-79.616 64H256a85.333 85.333 0 0 1-85.333-85.334v-384A85.333 85.333 0 0 1 256 320v320a170.667 170.667 0 0 0 170.667 170.667h211.456zm-168.79-405.334a42.667 42.667 0 1 1 0-85.333H640a42.667 42.667 0 1 1 0 85.333H469.333zm-42.666 128A42.667 42.667 0 0 0 469.333 576h256a42.667 42.667 0 1 0 0-85.333h-256a42.667 42.667 0 0 0-42.666 42.666z"
  }));
};

var SvgSubtractIcon = function SvgSubtractIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "subtract_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M213.333 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h597.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H213.333zM755.5 398.507 456.832 682.965a44.203 44.203 0 0 1-60.33 0l-128-121.898a39.253 39.253 0 0 1 0-57.472 44.203 44.203 0 0 1 60.33 0l97.835 93.141 268.501-255.701a44.203 44.203 0 0 1 60.33 0 39.253 39.253 0 0 1 0 57.472z"
  }));
};

var SvgSunIcon = function SvgSunIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "sun_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 0a42.667 42.667 0 0 1 42.667 42.667V128a42.667 42.667 0 1 1-85.334 0V42.667A42.667 42.667 0 0 1 512 0zm362.112 149.888a42.667 42.667 0 0 1 0 60.33l-60.587 60.587a42.667 42.667 0 1 1-60.33-60.33l60.586-60.587a42.667 42.667 0 0 1 60.331 0zM341.333 512a170.667 170.667 0 1 1 341.334 0 170.667 170.667 0 0 1-341.334 0zM512 256a256 256 0 1 0 0 512 256 256 0 0 0 0-512zM0 512a42.667 42.667 0 0 1 42.667-42.667H128a42.667 42.667 0 1 1 0 85.334H42.667A42.667 42.667 0 0 1 0 512zm896-42.667a42.667 42.667 0 1 0 0 85.334h85.333a42.667 42.667 0 1 0 0-85.334H896zM270.805 753.195a42.667 42.667 0 0 1 0 60.33l-60.586 60.587a42.667 42.667 0 0 1-60.331-60.33l60.587-60.587a42.667 42.667 0 0 1 60.33 0zm482.39 0a42.667 42.667 0 0 1 60.33 0l60.587 60.586a42.667 42.667 0 0 1-60.33 60.331l-60.587-60.587a42.667 42.667 0 0 1 0-60.33zM210.219 149.888a42.667 42.667 0 0 0-60.331 60.33l60.587 60.587a42.667 42.667 0 0 0 60.33-60.33l-60.586-60.587zM554.667 896a42.667 42.667 0 1 0-85.334 0v85.333a42.667 42.667 0 1 0 85.334 0V896z"
  }));
};

var SvgSystemExchangeAppIcon = function SvgSystemExchangeAppIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "system_exchange_app_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M147.2 149.333c-22.4 0-40.533 19.115-40.533 42.667s18.133 42.667 40.533 42.667h729.6c22.4 0 40.533-19.115 40.533-42.667S899.2 149.333 876.8 149.333H147.2zm277.845 320C402.347 469.333 384 488.448 384 512s18.347 42.667 41.045 42.667h451.243c22.699 0 41.045-19.115 41.045-42.667s-18.346-42.667-41.045-42.667H425.045zM106.667 832c0-23.552 18.133-42.667 40.533-42.667h729.6c22.4 0 40.533 19.115 40.533 42.667S899.2 874.667 876.8 874.667H147.2c-22.4 0-40.533-19.115-40.533-42.667zM266.24 487.125l-116.48-97.152c-12.075-10.069-29.013-7.082-37.845 6.656a33.792 33.792 0 0 0-5.206 18.176v194.39c0 17.024 12.118 30.805 27.051 30.805a24.917 24.917 0 0 0 16-5.973l116.523-97.152c12.074-10.07 14.677-29.355 5.845-43.094a29.312 29.312 0 0 0-5.845-6.656z"
  }));
};

var SvgSystemExchangeWebIcon = function SvgSystemExchangeWebIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "system_exchange_web_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M147.2 149.333c-22.4 0-40.533 19.115-40.533 42.667s18.133 42.667 40.533 42.667h729.6c22.4 0 40.533-19.115 40.533-42.667S899.2 149.333 876.8 149.333H147.2zm0 640c-22.4 0-40.533 19.115-40.533 42.667s18.133 42.667 40.533 42.667h729.6c22.4 0 40.533-19.115 40.533-42.667S899.2 789.333 876.8 789.333H147.2zm764.16-319.616L814.208 586.24a29.397 29.397 0 0 1-6.656 5.845c-13.739 8.832-33.024 6.23-43.093-5.845l-97.152-116.48a24.917 24.917 0 0 1-5.931-16c0-14.933 13.781-27.05 30.805-27.05h194.39c6.528 0 12.928 1.834 18.176 5.247 13.738 8.79 16.725 25.728 6.656 37.803zm-762.027-.384a42.667 42.667 0 1 0 0 85.334h384a42.667 42.667 0 1 0 0-85.334h-384z"
  }));
};

var SvgTacticsIcon = function SvgTacticsIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "tactics_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M558.507 42.667a42.667 42.667 0 1 0-85.334 0v42.666a42.667 42.667 0 0 0 85.334 0V42.667zM42.667 495.36a42.667 42.667 0 1 0 0 85.333h31.061a42.667 42.667 0 0 0 0-85.333H42.667zm115.2-361.301a41.515 41.515 0 0 1 59.605 0l29.867 30.506a43.861 43.861 0 0 1 0 61.014 41.515 41.515 0 0 1-59.691 0l-29.781-30.464a43.861 43.861 0 0 1 0-61.014zm691.84 106.794 29.824-30.506a43.861 43.861 0 0 0 0-61.014 41.515 41.515 0 0 0-59.648 0l-29.867 30.507a43.861 43.861 0 0 0 0 61.013 41.515 41.515 0 0 0 59.69 0zm46.122 297.174a42.667 42.667 0 0 1 42.667-42.667h36.992a42.667 42.667 0 1 1 0 85.333h-36.992a42.667 42.667 0 0 1-42.667-42.666zm-153.856 268.97 20.224-20.736c138.24-141.44 138.24-370.773 0-512.17a348.288 348.288 0 0 0-500.522 0c-138.24 141.44-138.24 370.773 0 512.17l20.224 20.736c1.749 1.75 2.73 4.182 2.73 6.656 0 55.211 43.734 100.011 97.707 100.011h259.2c53.973 0 97.707-44.8 97.707-100.01 0-2.475.981-4.907 2.73-6.657zM702.55 335.104c105.302 107.733 105.302 282.41 0 390.144l-20.224 20.693c-17.536 17.963-27.434 42.326-27.434 67.712 0 7.552-5.974 13.654-13.355 13.654h-259.2a13.525 13.525 0 0 1-13.355-13.654c0-25.386-9.856-49.749-27.434-67.712l-20.224-20.693c-105.302-107.733-105.302-282.41 0-390.144a265.301 265.301 0 0 1 381.226 0zM381.141 938.667a42.667 42.667 0 1 0 0 85.333h256a42.667 42.667 0 0 0 0-85.333h-256zm299.35-474.71a42.667 42.667 0 0 1 2.517 60.288l-98.56 107.179a42.667 42.667 0 0 1-65.28-2.944l-51.243-66.859-64.298 69.846a42.667 42.667 0 1 1-62.806-57.771l98.56-107.136a42.667 42.667 0 0 1 65.28 2.901l51.243 66.859 64.213-69.803A42.667 42.667 0 0 1 680.405 464z"
  }));
};

var SvgTaskIcon = function SvgTaskIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M6 1.5a1 1 0 0 0-2 0V21H2.5a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H6v-6h12.43a2 2 0 0 0 1.812-2.846L18.77 9l1.472-3.154A2 2 0 0 0 18.43 3H6V1.5ZM18.43 13H6V5h12.43l-1.472 3.154a2 2 0 0 0 0 1.692L18.43 13ZM10.5 8a1 1 0 0 0 0 2h3a1 1 0 1 0 0-2h-3Z"
  }));
};

var SvgTelegramIcon = function SvgTelegramIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22Zm3.498 16.668a.777.777 0 0 1-1.103.386l-2.986-2.32-1.916 1.768a.33.33 0 0 1-.314.043l.367-3.287.012.01.008-.066s5.373-4.892 5.592-5.1c.222-.208.149-.254.149-.254.012-.253-.398 0-.398 0l-7.12 4.58-2.965-1.009s-.455-.163-.498-.522c-.045-.357.513-.55.513-.55l11.789-4.684s.969-.431.969.284l-2.1 10.72Z"
  }));
};

var SvgThumbsDownIcon = function SvgThumbsDownIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "thumbs_down_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M810.667 85.333H267.52a128 128 0 0 0-125.867 104.96L87.467 488.96A128 128 0 0 0 213.333 640h194.56L384 701.013a176.213 176.213 0 0 0 165.973 237.654 42.667 42.667 0 0 0 38.827-25.174L710.4 640h100.267a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128zM640 588.373l-116.053 261.12a90.88 90.88 0 0 1-58.88-118.613l22.613-61.013a85.333 85.333 0 0 0-79.787-115.2h-194.56a42.667 42.667 0 0 1-32.853-15.36 42.667 42.667 0 0 1-9.813-34.987l54.186-298.667a42.667 42.667 0 0 1 42.667-34.986H640v417.706zM853.333 512a42.667 42.667 0 0 1-42.666 42.667h-85.334v-384h85.334a42.667 42.667 0 0 1 42.666 42.666V512z"
  }));
};

var SvgThumbsUpIcon = function SvgThumbsUpIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "thumbs_up_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M908.8 430.08A128 128 0 0 0 810.667 384h-194.56L640 322.987A176.213 176.213 0 0 0 474.027 85.333a42.667 42.667 0 0 0-38.827 25.174L313.6 384H213.333a128 128 0 0 0-128 128v298.667a128 128 0 0 0 128 128H756.48a128 128 0 0 0 125.867-104.96l54.186-298.667A128 128 0 0 0 908.8 430.08zM298.667 853.333h-85.334a42.667 42.667 0 0 1-42.666-42.666V512a42.667 42.667 0 0 1 42.666-42.667h85.334v384zM853.333 519.68l-54.186 298.667a42.667 42.667 0 0 1-42.667 34.986H384V435.627l116.053-261.12a90.027 90.027 0 0 1 58.88 118.613l-22.613 61.013a85.333 85.333 0 0 0 79.787 115.2h194.56a42.667 42.667 0 0 1 32.853 15.36 42.667 42.667 0 0 1 9.813 34.987z"
  }));
};

var SvgTogglechartIcon = function SvgTogglechartIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "togglechart_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M213.333 170.667a42.667 42.667 0 0 0-42.666 42.666v597.334a42.667 42.667 0 0 0 42.666 42.666h597.334a42.667 42.667 0 0 0 42.666-42.666V213.333a42.667 42.667 0 0 0-42.666-42.666H213.333zm-128 42.666a128 128 0 0 1 128-128h597.334a128 128 0 0 1 128 128v597.334a128 128 0 0 1-128 128H213.333a128 128 0 0 1-128-128V213.333zM896 554.667H128v-85.334h768v85.334zM469.333 896V128h85.334v768h-85.334z"
  }));
};

var SvgTopLeftIcon = function SvgTopLeftIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "top_left_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M403.755 343.467h319.36a42.667 42.667 0 1 0 0-85.334H301.14a43.093 43.093 0 0 0-43.093 43.094V723.2a42.667 42.667 0 0 0 85.333 0V403.84l351.446 351.445c15.616 15.616 41.813 14.763 58.453-1.92 16.64-16.64 17.493-42.794 1.92-58.453L403.755 343.509z"
  }));
};

var SvgTopRightIcon = function SvgTopRightIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "top_right_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M680.576 403.84V723.2a42.667 42.667 0 1 0 85.333 0V301.227a43.093 43.093 0 0 0-43.093-43.094H300.843a42.667 42.667 0 1 0 0 85.334h319.402L268.8 694.955c-15.616 15.658-14.763 41.813 1.92 58.453 16.64 16.683 42.837 17.493 58.453 1.92l351.403-351.445z"
  }));
};

var SvgTradingIcon = function SvgTradingIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "trading_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 853.333c-188.672 0-341.333-152.661-341.333-341.333 0-188.672 152.661-341.333 341.333-341.333 188.672 0 341.333 152.661 341.333 341.333 0 188.672-152.661 341.333-341.333 341.333zm0 85.334c235.776 0 426.667-190.891 426.667-426.667S747.776 85.333 512 85.333 85.333 276.224 85.333 512 276.224 938.667 512 938.667z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "m588.373 633.6 182.912-174.933a44.394 44.394 0 0 0 10.07-14.08 42.07 42.07 0 0 0-9.686-48.086 46.635 46.635 0 0 0-63.957.555l-149.76 143.317-87.51-90.922a46.507 46.507 0 0 0-65.365-.768l-136.32 134.741A42.539 42.539 0 0 0 256 614.485a42.667 42.667 0 0 0 13.91 30.55c8.66 7.936 20.138 12.245 32 12.032 11.775-.214 23.125-4.864 31.445-13.142l103.21-101.973 86.998 90.325c4.096 4.31 9.088 7.723 14.592 10.112a46.507 46.507 0 0 0 50.218-8.789z"
  }));
};

var SvgTradingbotIcon = function SvgTradingbotIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "tradingbot_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M468.992 120.917a42.667 42.667 0 0 1 42.667-42.666h78.208a42.667 42.667 0 1 1 0 85.333H554.41l-.171 67.541h153.088a163.541 163.541 0 0 1 163.584 163.542v39.338a117.333 117.333 0 0 1 110.25 117.12v78.251a117.333 117.333 0 0 1-110.25 117.12v39.296a163.541 163.541 0 0 1-163.584 163.541H316.203A163.541 163.541 0 0 1 152.66 785.792v-39.296A117.333 117.333 0 0 1 42.496 629.333v-78.208a117.333 117.333 0 0 1 110.165-117.12v-39.338a163.541 163.541 0 0 1 163.542-163.542h152.746l.214-106.496a42.496 42.496 0 0 1-.171-3.712zm433.92 508.459v-78.208a39.125 39.125 0 0 0-32-38.485V667.86a39.125 39.125 0 0 0 32-38.485zm-750.25 38.443V512.683a39.125 39.125 0 0 0-31.958 38.485v78.208c0 19.157 13.781 35.072 32 38.443zm85.333.682v117.291c0 43.179 34.986 78.208 78.208 78.208h391.125c43.221 0 78.25-34.987 78.25-78.208V394.667c0-43.179-35.029-78.208-78.25-78.208H316.203c-43.179 0-78.208 34.986-78.208 78.208V512h.042v156.501zM417.707 512a42.667 42.667 0 1 0-85.334 0v156.459a42.667 42.667 0 1 0 85.334 0V512zm230.997-42.667A42.667 42.667 0 0 1 691.371 512v156.459a42.667 42.667 0 1 1-85.334 0V512a42.667 42.667 0 0 1 42.667-42.667z"
  }));
};

var SvgTransferassetsIcon = function SvgTransferassetsIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "transferassets_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M776.96 682.667 636.501 823.168a42.667 42.667 0 0 0 60.331 60.33l213.333-213.333-2.901-1.194c9.557-7.595 15.403-17.792 15.403-28.971 0-23.552-25.942-42.667-57.899-42.667h-694.87c-32 0-57.898 19.115-57.898 42.667s25.941 42.667 57.899 42.667h607.104zM398.208 200.832 257.707 341.333H864.81c32 0 57.898 19.115 57.898 42.667s-25.941 42.667-57.898 42.667H169.899c-32 0-57.899-19.115-57.899-42.667 0-11.179 5.845-21.333 15.36-28.97l-2.859-1.195L337.835 140.5a42.667 42.667 0 0 1 60.33 60.331z"
  }));
};

var SvgTransforIcon = function SvgTransforIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "transfor_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M730.112 96.256a41.216 41.216 0 0 0-58.667 2.816 42.283 42.283 0 0 0 2.816 59.307l72.747 66.858H321.749a200.533 200.533 0 0 0-135.594 51.883C149.46 310.827 128 357.504 128 407.083v69.973c0 23.168 18.603 41.941 41.515 41.941s41.514-18.773 41.514-41.941V407.04c0-24.619 10.582-49.11 30.976-67.84a118.059 118.059 0 0 1 79.744-30.08h425.259l-72.747 66.859a42.283 42.283 0 0 0-2.816 59.306 41.216 41.216 0 0 0 58.667 2.816L880.64 299.733c9.387-7.68 15.36-19.413 15.36-32.597a42.07 42.07 0 0 0-15.232-32.427L730.112 96.213zM896 546.986a41.728 41.728 0 0 0-41.515-41.983 41.728 41.728 0 0 0-41.514 41.984v69.93c0 24.619-10.582 49.11-30.976 67.84a118.059 118.059 0 0 1-79.744 30.08H276.907l72.789-66.858a42.283 42.283 0 0 0 2.773-59.307 41.216 41.216 0 0 0-58.624-2.816L141.568 725.76A42.027 42.027 0 0 0 128 756.139v.682a42.08 42.08 0 0 0 14.08 31.488l151.723 139.435a41.216 41.216 0 0 0 58.624-2.816 42.283 42.283 0 0 0-2.774-59.307l-72.746-66.858h425.386a200.533 200.533 0 0 0 135.552-51.883C874.54 713.173 896 666.496 896 616.917v-69.973z"
  }));
};

var SvgTransmitterIcon = function SvgTransmitterIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "transmitter_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M860.587 393.813 263.253 147.2A128 128 0 0 0 92.587 305.067L158.293 512 90.88 718.933a128 128 0 0 0 34.56 134.4 128 128 0 0 0 85.333 34.134c16.854 0 33.536-3.328 49.067-9.814L859.307 631.04a128 128 0 0 0 0-236.373l1.28-.854zM228.693 797.867a42.667 42.667 0 0 1-45.226-8.107 42.667 42.667 0 0 1-11.52-42.667l62.293-192.426h585.813l-591.36 243.2zm5.547-328.534-63.573-190.72a42.667 42.667 0 0 1 11.52-42.666 42.667 42.667 0 0 1 47.786-9.814l590.08 243.2H234.24z"
  }));
};

var SvgTrashIcon = function SvgTrashIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "trash_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M405.333 213.333V256h213.334v-42.667A42.667 42.667 0 0 0 576 170.667H448a42.667 42.667 0 0 0-42.667 42.666zM320 256v-42.667a128 128 0 0 1 128-128h128a128 128 0 0 1 128 128V256h192a42.667 42.667 0 1 1 0 85.333h-42.667V768a170.667 170.667 0 0 1-170.666 170.667H341.333A170.667 170.667 0 0 1 170.667 768V341.333H128A42.667 42.667 0 0 1 128 256h192zm341.333 85.333H256V768a85.333 85.333 0 0 0 85.333 85.333h341.334A85.333 85.333 0 0 0 768 768V341.333H661.333zm-234.666 128A42.667 42.667 0 0 1 469.333 512v170.667a42.667 42.667 0 1 1-85.333 0V512a42.667 42.667 0 0 1 42.667-42.667zM640 512a42.667 42.667 0 1 0-85.333 0v170.667a42.667 42.667 0 1 0 85.333 0V512z"
  }));
};

var SvgTrendlIcon = function SvgTrendlIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "trendl_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M789.333 170.667a64 64 0 1 0 0 128 64 64 0 0 0 0-128zm-149.333 64a149.333 149.333 0 1 1 71.808 127.658l-349.44 349.483a149.333 149.333 0 1 1-63.36-57.301l355.499-355.542A148.779 148.779 0 0 1 640 234.667zM170.667 789.333a64 64 0 1 0 128 0 64 64 0 0 0-128 0z"
  }));
};

var SvgUnblockIcon = function SvgUnblockIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "unblock_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M42.667 512a42.667 42.667 0 0 0 42.666 42.667h451.84l-98.133 97.706a42.752 42.752 0 0 0 13.867 69.931 42.667 42.667 0 0 0 46.72-9.344l170.666-170.667a42.667 42.667 0 0 0 8.96-14.08 42.667 42.667 0 0 0 0-32.426 42.667 42.667 0 0 0-8.96-14.08L499.627 311.04a42.795 42.795 0 1 0-60.587 60.587l98.133 97.706H85.333A42.667 42.667 0 0 0 42.667 512zm768-426.667H341.333a128 128 0 0 0-128 128v85.334a42.667 42.667 0 0 0 85.334 0v-85.334a42.667 42.667 0 0 1 42.666-42.666h469.334a42.667 42.667 0 0 1 42.666 42.666v597.334a42.667 42.667 0 0 1-42.666 42.666H341.333a42.667 42.667 0 0 1-42.666-42.666v-85.334a42.667 42.667 0 1 0-85.334 0v85.334a128 128 0 0 0 128 128h469.334a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128z"
  }));
};

var SvgUpcomingIcon = function SvgUpcomingIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "upcoming_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 128a384 384 0 0 0-384 384 382.72 382.72 0 0 0 115.2 274.219l-59.733 60.928A468.053 468.053 0 0 1 42.667 512C42.667 252.8 252.8 42.667 512 42.667V128zm0-85.333c15.53 0 30.848.768 45.995 2.218l-8.278 84.907A389.12 389.12 0 0 0 512.085 128V42.667zm136.32 20.096a468.376 468.376 0 0 1 85.035 35.242l-40.278 75.264a381.44 381.44 0 0 0-69.546-28.842l24.746-81.664zm161.493 86.442a472.984 472.984 0 0 1 65.024 65.024l-65.92 54.187a386.56 386.56 0 0 0-53.29-53.29l54.186-65.92zm116.182 141.483a465.505 465.505 0 0 1 35.285 85.035l-81.664 24.746a381.525 381.525 0 0 0-28.843-69.504l75.222-40.277zm53.162 175.36a474.837 474.837 0 0 1 0 91.904l-84.906-8.235a390.101 390.101 0 0 0 0-75.434l84.906-8.235zm-17.92 182.187a461.552 461.552 0 0 1-35.242 85.077l-75.222-40.277a382.002 382.002 0 0 0 28.843-69.547l81.664 24.747zm-86.4 161.536a472.405 472.405 0 0 1-65.024 65.024l-54.186-65.92a386.56 386.56 0 0 0 53.29-53.291l65.92 54.187zm-657.365 67.626c-11.819-9.557-23.168-19.626-33.963-30.25l59.734-60.928c8.874 8.704 18.133 16.981 27.818 24.746l-53.589 66.432zm515.84 48.598c-26.88 14.378-55.296 26.24-84.992 35.242l-24.747-81.664a381.61 381.61 0 0 0 69.504-28.8l40.278 75.179zm-355.84 35.754a466.347 466.347 0 0 1-84.139-34.389l39.808-75.52A379.96 379.96 0 0 0 401.877 880l-24.405 81.75zm180.523 17.366a473.387 473.387 0 0 1-91.307.042l8.107-84.906a388.48 388.48 0 0 0 74.922-.086l8.278 84.907zm-3.328-637.782a42.667 42.667 0 1 0-85.334 0v213.334A42.667 42.667 0 0 0 512 597.333h170.667a42.667 42.667 0 1 0 0-85.333h-128V341.333z"
  }));
};

var SvgUptoIcon = function SvgUptoIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "upto_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M128 128a42.667 42.667 0 0 1 42.667-42.667h682.666a42.667 42.667 0 1 1 0 85.334H170.667A42.667 42.667 0 0 1 128 128zm384 810.667A42.667 42.667 0 0 1 469.333 896V401.664L286.165 584.832a42.667 42.667 0 0 1-60.33-60.33l256-256a42.667 42.667 0 0 1 60.33 0l256 256a42.667 42.667 0 0 1-60.33 60.33L554.667 401.664V896A42.667 42.667 0 0 1 512 938.667z"
  }));
};

var SvgUsdcIcon = function SvgUsdcIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "usdc_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M917.333 512a405.333 405.333 0 1 1-810.666 0 405.333 405.333 0 0 1 810.666 0zM512 981.333c259.2 0 469.333-210.133 469.333-469.333S771.2 42.667 512 42.667 42.667 252.8 42.667 512 252.8 981.333 512 981.333zm101.675-817.92a22.741 22.741 0 0 0-20.95 2.944 23.552 23.552 0 0 0-9.088 19.328v27.904a29.44 29.44 0 0 0 4.992 15.787 27.435 27.435 0 0 0 12.886 10.795c108.032 40.448 185.258 146.688 185.258 271.445 0 124.373-77.525 230.955-185.173 271.403-11.563 4.053-17.92 15.53-17.92 26.624v27.904c0 7.722 2.901 14.848 8.875 19.328 5.973 4.522 13.653 5.29 21.077 2.986l.085-.042c144.214-47.318 248.15-185.259 248.15-348.587 0-162.859-103.894-301.227-248.192-347.776zM431.488 166.4c5.93 4.437 8.875 11.605 8.875 19.285v27.904a29.44 29.44 0 0 1-4.992 15.787 27.477 27.477 0 0 1-12.886 10.795C314.453 281.003 237.227 387.584 237.227 512c0 124.8 77.226 230.997 185.258 271.445 5.547 2.091 9.942 6.315 12.886 10.795a29.44 29.44 0 0 1 4.992 15.787v28.288c0 7.808-3.115 14.933-9.088 19.328a22.741 22.741 0 0 1-20.992 2.901C266.069 813.269 162.133 675.285 162.133 512c0-162.901 103.936-301.227 248.15-348.587h.085a22.912 22.912 0 0 1 21.077 2.987zm49.835 132.224c0-12.715 10.154-23.424 23.04-23.424h29.013c12.885 0 23.04 10.71 23.04 23.424v40.277c21.59 4.95 39.936 14.08 54.315 27.478 15.957 14.89 26.624 34.645 31.829 58.794a22.101 22.101 0 0 1-21.76 26.71h-30.464a22.955 22.955 0 0 1-21.973-16.939c-3.755-12.8-9.814-21.205-18.091-26.624-8.533-5.547-20.352-8.533-36.821-8.533-17.92 0-30.379 4.437-38.187 10.88a32.64 32.64 0 0 0-11.69 26.368c0 12.928 2.517 20.394 9.813 26.197 8.234 6.613 23.765 12.075 53.205 16.341 40.15 5.59 72.363 14.507 94.592 31.915 22.87 17.92 33.877 43.99 33.877 80.683 0 55.424-38.912 99.968-98.261 112.384v49.066h-1.963a23.04 23.04 0 0 1-21.461 14.891h-29.013a23.253 23.253 0 0 1-23.04-23.424v-39.595c-29.568-5.333-52.566-16.725-69.462-33.28-18.218-17.92-28.672-41.173-33.066-67.456a22.187 22.187 0 0 1 21.845-25.941h32.981c11.35 0 20.31 8.448 22.486 18.603v.085c2.901 13.653 7.978 24.576 17.194 32.256 9.259 7.637 23.894 13.056 48.128 13.056 17.067 0 31.104-4.95 40.662-12.843a40.533 40.533 0 0 0 14.976-32.213c0-14.421-3.414-22.443-11.307-28.501-8.96-6.827-24.704-11.99-52.181-16.64-40.875-5.632-72.747-14.976-94.336-32.342-22.272-17.877-32.598-43.221-32.598-77.653 0-52.992 37.974-94.165 94.678-105.088v-38.912z"
  }));
};

var SvgUserIcon = function SvgUserIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "user_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 896c99.328 0 189.867-37.717 258.005-99.584a266.795 266.795 0 0 0-516.01 0A382.592 382.592 0 0 0 512 896zm133.035-357.973A353.28 353.28 0 0 1 833.92 721.408a384 384 0 1 0-643.84 0 353.28 353.28 0 0 1 188.885-183.424 195.541 195.541 0 1 1 266.07 0zM981.333 512c0 120.192-45.184 229.845-119.466 312.875l-1.494 1.621-.981 1.067a472.107 472.107 0 0 1-83.115 72.362A467.2 467.2 0 0 1 512 981.333a467.2 467.2 0 0 1-271.701-86.613 471.979 471.979 0 0 1-78.166-69.803A467.584 467.584 0 0 1 42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512zM622.208 394.667a110.208 110.208 0 1 0-220.416 0 110.208 110.208 0 0 0 220.416 0z"
  }));
};

var SvgVerticalIcon = function SvgVerticalIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "vertical_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M469.333 655.147v283.52a42.667 42.667 0 1 0 85.334 0v-283.52a149.419 149.419 0 0 0 0-286.294V85.333a42.667 42.667 0 1 0-85.334 0v283.52a149.419 149.419 0 0 0 0 286.294zM448 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
  }));
};

var SvgVideoIcon = function SvgVideoIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "video_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M170.667 512c0 188.672 152.661 341.333 341.333 341.333 188.672 0 341.333-152.661 341.333-341.333 0-188.672-152.661-341.333-341.333-341.333-188.672 0-341.333 152.661-341.333 341.333zm768 0c0 235.776-190.891 426.667-426.667 426.667S85.333 747.776 85.333 512 276.224 85.333 512 85.333 938.667 276.224 938.667 512zM373.333 624.939a85.333 85.333 0 0 0 130.56 72.362L667.52 595.03a85.333 85.333 0 0 0 0-144.725L503.893 348.032a85.333 85.333 0 0 0-130.56 72.363v204.544zm248.96-102.272L458.667 624.939V420.395l163.626 102.272z"
  }));
};

var SvgViewProfileIcon = function SvgViewProfileIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "view_profile_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M938.667 213.333c0-34.133-12.8-68.266-38.4-89.6-21.334-25.6-55.467-38.4-89.6-38.4H213.333c-34.133 0-64 17.067-89.6 38.4-25.6 21.334-38.4 55.467-38.4 89.6v597.334c0 34.133 12.8 68.266 38.4 89.6 21.334 25.6 55.467 38.4 89.6 38.4h213.334c4.266 0 12.8 0 17.066-4.267 4.267 0 8.534-4.267 12.8-8.533 2.134-2.134 3.2-4.267 4.267-6.4 1.067-2.134 2.133-4.267 4.267-6.4 4.266-4.267 4.266-12.8 4.266-17.067 0-4.267 0-12.8-4.266-17.067 0-4.266-4.267-8.533-8.534-12.8-2.133-2.133-4.266-3.2-6.4-4.266a22.315 22.315 0 0 1-6.4-4.267c-4.266-4.267-12.8-4.267-17.066-4.267H213.333c-12.8 0-21.333-4.266-29.866-12.8-8.534-8.533-12.8-17.066-12.8-29.866V213.333c0-12.8 4.266-21.333 12.8-29.866 8.533-8.534 17.066-12.8 29.866-12.8h597.334c12.8 0 21.333 4.266 29.866 12.8 8.534 8.533 12.8 17.066 12.8 29.866v213.334c0 12.8 4.267 21.333 12.8 29.866 8.534 8.534 17.067 12.8 29.867 12.8s21.333-4.266 29.867-12.8c8.533-8.533 12.8-17.066 12.8-29.866V213.333zM341.333 593.067c0 136.533 110.934 247.466 247.467 247.466a246.101 246.101 0 0 0 129.707-36.693l92.16 92.16c17.066 12.8 42.666 17.067 59.733 0s17.067-42.667 0-59.733l-88.533-88.534a246.357 246.357 0 0 0 54.4-154.666c0-136.534-110.934-247.467-247.467-247.467-136.533 0-247.467 110.933-247.467 247.467zm85.334 0c0-89.6 72.533-162.134 162.133-162.134 89.6 0 162.133 72.534 162.133 162.134 0 89.6-72.533 162.133-162.133 162.133-89.6 0-162.133-72.533-162.133-162.133z"
  }));
};

var SvgVipIcon = function SvgVipIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "vip_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M742.315 245.461a106.555 106.555 0 0 1 87.125 45.184l131.584 186.71a106.581 106.581 0 0 1-18.347 142.805L580.736 925.653a106.539 106.539 0 0 1-137.472 0L81.365 620.16A106.539 106.539 0 0 1 63.02 477.355l131.541-186.71a106.539 106.539 0 0 1 87.125-45.226h112L352 136.064l102.827 35.968L512 64l57.173 107.99L672 136.02l-41.685 109.44h112zm-460.63 85.078a21.419 21.419 0 0 0-17.536 9.13L132.565 526.38a21.419 21.419 0 0 0 3.712 28.757L498.176 860.63a21.461 21.461 0 0 0 27.648 0l361.899-305.493c8.533-7.168 10.112-19.627 3.712-28.757L759.85 339.669a21.461 21.461 0 0 0-17.494-9.13H281.643zm106.411 94.89L512 623.701 635.904 425.43a42.581 42.581 0 0 1 72.192 45.142L564.352 700.544a61.781 61.781 0 0 1-104.704 0L315.904 470.571a42.581 42.581 0 0 1 72.192-45.184z"
  }));
};

var SvgVolumeIcon = function SvgVolumeIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "volume_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M743.253 118.741 381.44 291.84H228.267a121.6 121.6 0 0 0-121.6 121.685v147.371a121.6 121.6 0 0 0 121.6 121.643h157.226L742.06 857.94c80.81 39.766 175.274-19.072 175.274-109.184V228.48c0-89.515-93.354-148.395-174.08-109.739zm-496.81 725.59-40.406-128.086c5.12.64 10.24.982 15.531.982h186.027l26.581 87.168c15.744 51.541-13.013 99.84-66.005 110.933-50.347 10.581-106.283-22.059-121.728-70.997z"
  }));
};

var SvgWalletIcon = function SvgWalletIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "wallet_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M170.667 128a85.333 85.333 0 0 0-85.334 85.333v597.334A85.333 85.333 0 0 0 170.667 896h682.666a85.333 85.333 0 0 0 85.334-85.333V213.333A85.333 85.333 0 0 0 853.333 128H170.667zm682.666 256h-128a128 128 0 1 0 0 256h128v170.667H170.667V213.333h682.666V384zm0 170.667h-128a42.667 42.667 0 1 1 0-85.334h128v85.334z"
  }));
};

var SvgWeb3AssetsIcon = function SvgWeb3AssetsIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_assets_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M170.667 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h682.666a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H170.667zM896 384H746.667a149.333 149.333 0 1 0 0 298.667H896v128a42.667 42.667 0 0 1-42.667 42.666H170.667A42.667 42.667 0 0 1 128 810.667V213.333a42.667 42.667 0 0 1 42.667-42.666h682.666A42.667 42.667 0 0 1 896 213.333V384zm0 213.333H746.667a64 64 0 0 1 0-128H896v128z"
  }));
};

var SvgWeb3DappsIcon = function SvgWeb3DappsIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_dapps_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M927.317 386.56a85.333 85.333 0 0 0 0-120.661L791.552 130.133a85.333 85.333 0 0 0-120.661 0L535.125 265.9a85.333 85.333 0 0 0 0 120.661l135.766 135.765a85.333 85.333 0 0 0 120.661 0L927.317 386.56zM731.221 190.464l135.766 135.765L731.22 461.995 595.456 326.229l135.765-135.765zm-560.554-57.301a85.333 85.333 0 0 0-85.334 85.333v192a85.333 85.333 0 0 0 85.334 85.333h163.882A113.45 113.45 0 0 0 448 382.421V218.453a85.333 85.333 0 0 0-85.333-85.333h-192zm0 85.333h192v163.925a28.117 28.117 0 0 1-28.118 28.075H170.667v-192zm0 715.05a85.333 85.333 0 0 1-85.334-85.333v-192a85.333 85.333 0 0 1 85.334-85.333h163.882A113.45 113.45 0 0 1 448 684.33v163.883a85.333 85.333 0 0 1-85.333 85.334h-192zm0-85.333h192V684.331a28.117 28.117 0 0 0-28.118-28.118H170.667v192zm629.674 85.334a85.333 85.333 0 0 0 85.334-85.334v-192a85.333 85.333 0 0 0-85.334-85.333H636.46a113.45 113.45 0 0 0-113.494 113.45v163.883a85.333 85.333 0 0 0 85.334 85.334h192zm0-85.334h-192V684.331c0-15.531 12.587-28.118 28.118-28.118h163.84v192z"
  }));
};

var SvgWeb3Home1Icon = function SvgWeb3Home1Icon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_home1_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M554.667 874.667a405.333 405.333 0 1 1 0-810.667 405.333 405.333 0 0 1 0 810.667zm0 64c259.2 0 469.333-210.134 469.333-469.334S813.867 0 554.667 0 85.333 210.133 85.333 469.333s210.134 469.334 469.334 469.334zm89.258-563.2h-37.802v188.928h37.802v-22.443h1.28a35.03 35.03 0 0 0 12.758 18.347c3.2 2.218 6.826 3.925 10.709 5.12 3.925 1.365 8.107 2.048 12.501 2.048 17.067 0 29.867-5.974 38.571-17.878 8.661-12.074 13.013-29.525 13.013-52.309 0-22.827-4.352-40.192-13.013-52.096-8.704-11.947-21.547-17.92-38.57-17.92a39.552 39.552 0 0 0-23.211 7.168 31.573 31.573 0 0 0-12.8 18.39h-1.28v-77.355zm42.368 153.941a23.04 23.04 0 0 1-17.621 7.424 29.995 29.995 0 0 1-17.877-5.12 17.493 17.493 0 0 1-6.87-14.507v-39.594c0-6.144 2.262-10.923 6.87-14.294a28.97 28.97 0 0 1 17.877-5.376 22.613 22.613 0 0 1 17.621 7.68c4.779 4.907 7.168 11.648 7.168 20.139v23.253c0 8.534-2.389 15.318-7.168 20.438zm-408.746 34.219-40.32-178.219h38.314l16.854 85.547 9.429 49.536h.768l11.221-49.494 19.67-85.546h42.368l19.925 85.504 10.965 49.536h.768l9.472-49.494 17.067-85.546h36.821l-41.386 178.176h-44.16l-22.486-96.512-8.661-39.04h-.768l-8.96 39.04-22.443 96.512H277.59zm249.13 3.072c-10.24 0-19.328-1.622-27.306-4.864a59.99 59.99 0 0 1-20.48-14.038 62.976 62.976 0 0 1-12.459-22.186 97.024 97.024 0 0 1-4.096-29.099c0-10.581 1.365-20.096 4.096-28.587 2.73-8.704 6.699-16.128 11.99-22.229 5.46-6.144 12.074-10.837 19.925-14.08 7.808-3.413 16.768-5.12 26.794-5.12 11.094 0 20.48 1.92 28.331 5.675 8.021 3.712 14.507 8.746 19.413 15.061 5.12 6.272 8.79 13.61 10.966 21.93 2.389 8.193 3.584 16.769 3.584 25.814v11.221h-86.059v2.048c0 8.832 2.39 15.915 7.168 21.163 4.779 5.12 12.245 7.68 22.485 7.68a35.84 35.84 0 0 0 19.158-4.608c4.906-3.2 9.514-7.04 13.781-11.477l18.859 23.466c-5.974 6.998-13.782 12.459-23.467 16.384a85.376 85.376 0 0 1-32.683 5.846zm-.768-112.342c-7.68 0-13.696 2.56-18.133 7.68-4.267 4.907-6.4 11.563-6.4 19.883v2.048h47.019v-2.261a31.744 31.744 0 0 0-5.632-19.67c-3.584-5.12-9.216-7.68-16.854-7.68zm275.627 1.536c9.557 0 16.47-1.792 20.693-5.376a17.408 17.408 0 0 0 6.656-13.781v-1.792a20.139 20.139 0 0 0-6.4-15.573c-4.096-3.883-9.941-5.846-17.621-5.846a38.827 38.827 0 0 0-20.139 5.59 46.677 46.677 0 0 0-16.085 15.573l-24.021-22.443c3.413-4.437 7.082-8.448 10.965-11.989 3.925-3.755 8.363-6.912 13.27-9.472 4.949-2.73 10.495-4.779 16.64-6.101 6.1-1.536 13.013-2.304 20.65-2.304 9.557 0 18.133 1.109 25.813 3.285 7.808 2.219 14.464 5.461 19.883 9.728a40.79 40.79 0 0 1 12.8 14.805 40.832 40.832 0 0 1 4.565 19.414 40.235 40.235 0 0 1-20.906 35.712 48.768 48.768 0 0 1-13.056 4.352v1.536c5.29 1.024 10.154 2.73 14.549 5.12 4.608 2.218 8.533 5.12 11.776 8.661 3.413 3.584 6.016 7.85 7.893 12.8 1.878 4.736 2.816 10.197 2.816 16.341 0 7.979-1.621 15.19-4.864 21.675a47.744 47.744 0 0 1-13.781 16.64c-5.973 4.565-13.099 8.107-21.419 10.667a100.267 100.267 0 0 1-27.605 3.584c-9.003 0-17.024-.939-23.979-2.816a75.179 75.179 0 0 1-18.389-7.382 72.107 72.107 0 0 1-13.525-10.965 90.752 90.752 0 0 1-9.984-13.056l28.373-21.93c3.883 7.295 8.661 13.354 14.293 18.133 5.76 4.565 13.526 6.869 23.211 6.869 8.704 0 15.403-2.133 20.181-6.4a22.827 22.827 0 0 0 7.424-17.835v-1.536c0-7.338-2.816-12.8-8.448-16.341-5.418-3.755-13.013-5.632-22.698-5.632H784.98v-31.915h16.598zm-727.979 201.6a21.333 21.333 0 0 0-36.48-22.101A256 256 0 0 0 384 989.696a21.333 21.333 0 0 0-21.333-36.95A213.333 213.333 0 0 1 73.515 657.494z"
  }));
};

var SvgWeb3HomeIcon = function SvgWeb3HomeIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_home_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M559.787 83.541a85.333 85.333 0 0 0-96.683.043L100.907 332.885A85.333 85.333 0 0 0 64 403.2v466.901a85.333 85.333 0 0 0 85.333 85.334h725.419a85.333 85.333 0 0 0 85.333-85.334V403.2a85.333 85.333 0 0 0-37.034-70.315L559.787 83.541zM511.488 153.9l363.221 249.3v466.901H149.333V403.2l362.24-249.301 24.107-35.2-24.15 35.2zM362.667 640a42.667 42.667 0 1 0 0 85.333h298.666a42.667 42.667 0 1 0 0-85.333H362.667z"
  }));
};

var SvgWeb3RankIcon = function SvgWeb3RankIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_rank_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M170.667 85.333a128 128 0 0 0-128 128v597.334a128 128 0 0 0 128 128h682.666a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128H170.667zm-42.667 128a42.667 42.667 0 0 1 42.667-42.666h682.666A42.667 42.667 0 0 1 896 213.333v597.334a42.667 42.667 0 0 1-42.667 42.666H170.667A42.667 42.667 0 0 1 128 810.667V213.333zM682.667 384A42.667 42.667 0 1 1 768 384v256a42.667 42.667 0 1 1-85.333 0V384zM512 426.667a42.667 42.667 0 0 0-42.667 42.666V640a42.667 42.667 0 1 0 85.334 0V469.333A42.667 42.667 0 0 0 512 426.667zM298.667 512A42.667 42.667 0 0 0 256 554.667V640a42.667 42.667 0 1 0 85.333 0v-85.333A42.667 42.667 0 0 0 298.667 512z"
  }));
};

var SvgWeb3SwapIcon = function SvgWeb3SwapIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "web3_swap_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M128 512a384 384 0 1 1 768 0 384 384 0 0 1-768 0zM512 42.667C252.8 42.667 42.667 252.8 42.667 512S252.8 981.333 512 981.333 981.333 771.2 981.333 512 771.2 42.667 512 42.667zm187.563 437.077a10.667 10.667 0 0 0 7.509-18.219L554.667 309.333v85.334H341.333a42.667 42.667 0 0 0 0 85.333h256a42.59 42.59 0 0 0 4.694-.256h97.536zm-373.931 74.923a10.667 10.667 0 0 0-7.253 18.432l150.954 141.568V640h213.334a42.667 42.667 0 1 0 0-85.333H325.632z"
  }));
};

var SvgWechartIcon = function SvgWechartIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M16.247 8.253c.276 0 .548.02.818.05C16.33 4.916 12.67 2.4 8.495 2.4 3.825 2.4 0 5.55 0 9.549c0 2.308 1.273 4.204 3.4 5.674l-.85 2.529 2.969-1.474c1.063.208 1.915.422 2.976.422.266 0 .53-.013.792-.034a6.191 6.191 0 0 1-.262-1.76c0-3.673 3.187-6.653 7.222-6.653Zm-4.567-2.28c.64 0 1.063.418 1.063 1.05 0 .63-.423 1.052-1.063 1.052-.637 0-1.275-.422-1.275-1.052 0-.632.638-1.05 1.275-1.05ZM5.735 8.076c-.637 0-1.28-.422-1.28-1.052 0-.632.643-1.05 1.28-1.05s1.06.418 1.06 1.05c0 .63-.423 1.052-1.06 1.052ZM24 14.805c0-3.361-3.398-6.1-7.215-6.1-4.042 0-7.225 2.739-7.225 6.1 0 3.365 3.183 6.099 7.225 6.099.845 0 1.699-.21 2.548-.421l2.33 1.262-.639-2.1C22.73 18.379 24 16.7 24 14.805Zm-9.558-1.053c-.423 0-.85-.416-.85-.84 0-.42.427-.84.85-.84.643 0 1.063.42 1.063.84 0 .424-.42.84-1.063.84Zm4.672 0c-.42 0-.843-.416-.843-.84 0-.42.424-.84.843-.84.637 0 1.063.42 1.063.84 0 .424-.426.84-1.063.84Z"
  }));
};

var SvgWifiIcon = function SvgWifiIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "wifi_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M556.245 486.357a95.147 95.147 0 0 0-134.57 0l-1.878 1.92-178.773-178.773a32.597 32.597 0 0 0-46.08 0C54.827 449.621 61.739 683.691 210.347 832.341c148.65 148.651 382.72 155.563 522.837 15.446a32.597 32.597 0 0 0 0-46.123L554.368 622.805l1.877-1.877a95.147 95.147 0 0 0 0-134.57zM463.36 96.597a42.667 42.667 0 0 1 41.813-43.52 469.333 469.333 0 0 1 478.55 459.776 42.667 42.667 0 0 1-85.334 1.707 384 384 0 0 0-391.552-376.15 42.667 42.667 0 0 1-43.52-41.813zm4.267 212.95a42.667 42.667 0 0 1 41.813-43.52A256 256 0 0 1 770.475 516.82a42.667 42.667 0 1 1-85.334 1.707A170.667 170.667 0 0 0 511.104 351.36a42.667 42.667 0 0 1-43.52-41.813z"
  }));
};

var SvgWithdrawIcon = function SvgWithdrawIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "withdraw_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M128 597.333A42.667 42.667 0 0 1 170.667 640v170.667a42.667 42.667 0 0 0 42.666 42.666h597.334a42.667 42.667 0 0 0 42.666-42.666V640a42.667 42.667 0 1 1 85.334 0v170.667a128 128 0 0 1-128 128H213.333a128 128 0 0 1-128-128V640A42.667 42.667 0 0 1 128 597.333zM268.501 371.5a42.667 42.667 0 0 0 60.331 0l140.501-140.502V640a42.667 42.667 0 1 0 85.334 0V230.997L695.168 371.5a42.667 42.667 0 1 0 60.33-60.331L542.166 97.835A42.496 42.496 0 0 0 512 85.333m-.427 0a42.539 42.539 0 0 0-29.738 12.502L268.5 311.168a42.667 42.667 0 0 0 0 60.33"
  }));
};

var SvgXCircleIcon = function SvgXCircleIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    className: "x_circle_icon_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768zM42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512 771.2 981.333 512 981.333 42.667 771.2 42.667 512zm627.498-158.165a42.667 42.667 0 0 1 0 60.33L572.331 512l97.834 97.835a42.667 42.667 0 0 1-60.33 60.33L512 572.331l-97.835 97.834a42.667 42.667 0 0 1-60.33-60.33L451.669 512l-97.834-97.835a42.667 42.667 0 0 1 60.33-60.33L512 451.669l97.835-97.834a42.667 42.667 0 0 1 60.33 0z"
  }));
};

var SvgXIcon = function SvgXIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M17.751 3h3.067l-6.7 7.625L22 21h-6.172l-4.833-6.293L5.464 21h-3.07l7.167-8.155L2 3h6.328l4.37 5.752L17.75 3Zm-1.076 16.172h1.7L7.404 4.732H5.58l11.094 14.44Z"
  }));
};

var SvgYoutubeIcon = function SvgYoutubeIcon(props) {
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M22.581 7.07c-.466-1.53-.832-2.378-2.375-2.562 0 0-4.132-.208-8.241-.208-4.062 0-8.102.208-8.102.208-1.636.184-2.025 1.079-2.444 2.563 0 0-.419 2.363-.419 4.756 0 2.454.419 4.94.419 4.94.326 1.438.995 2.379 2.444 2.563 0 0 4.484.278 8.754.278 3.883 0 7.59-.278 7.59-.278 1.45-.277 1.955-1.032 2.374-2.562 0 0 .419-2.273.419-4.618 0-2.499-.419-5.08-.419-5.08ZM9.801 16.01V7.836l6.355 4.086L9.8 16.01Z"
  }));
};

exports.AccountswitchIcon = SvgAccountswitchIcon;
exports.AddIcon = SvgAddIcon;
exports.AddSolidIcon = SvgAddSolidIcon;
exports.AdddecIcon = SvgAdddecIcon;
exports.AirdropIcon = SvgAirdropIcon;
exports.AlertCircleSolidIcon = SvgAlertCircleSolidIcon;
exports.AlertTriangleSolidIcon = SvgAlertTriangleSolidIcon;
exports.AngleIcon = SvgAngleIcon;
exports.ApplynowIcon = SvgApplynowIcon;
exports.ArrowIcon = SvgArrowIcon;
exports.Arrowchevron2DownIcon = SvgArrowchevron2DownIcon;
exports.Arrowchevron2LeftIcon = SvgArrowchevron2LeftIcon;
exports.Arrowchevron2RightIcon = SvgArrowchevron2RightIcon;
exports.Arrowchevron2UpIcon = SvgArrowchevron2UpIcon;
exports.ArrowchevronDownIcon = SvgArrowchevronDownIcon;
exports.ArrowchevronLeftIcon = SvgArrowchevronLeftIcon;
exports.ArrowchevronRightIcon = SvgArrowchevronRightIcon;
exports.ArrowchevronUpIcon = SvgArrowchevronUpIcon;
exports.ArrowdownIcon = SvgArrowdownIcon;
exports.ArrowleftIcon = SvgArrowleftIcon;
exports.ArrowmoreIcon = SvgArrowmoreIcon;
exports.ArrowrightIcon = SvgArrowrightIcon;
exports.ArrowupIcon = SvgArrowupIcon;
exports.AssethistoryIcon = SvgAssethistoryIcon;
exports.AssetsMoreIcon = SvgAssetsMoreIcon;
exports.AssureIcon = SvgAssureIcon;
exports.BaseIcon = SvgBaseIcon;
exports.BatchIcon = SvgBatchIcon;
exports.BellIcon = SvgBellIcon;
exports.BookIcon = SvgBookIcon;
exports.BotIcon = SvgBotIcon;
exports.BottomLeftIcon = SvgBottomLeftIcon;
exports.BottomRightIcon = SvgBottomRightIcon;
exports.BrokenIcon = SvgBrokenIcon;
exports.BuyIcon = SvgBuyIcon;
exports.CalculatorIcon = SvgCalculatorIcon;
exports.CexHomeIcon = SvgCexHomeIcon;
exports.ChartIcon = SvgChartIcon;
exports.CheckCircleIcon = SvgCheckCircleIcon;
exports.CheckIcon = SvgCheckIcon;
exports.CircleIcon = SvgCircleIcon;
exports.CirclepromptIcon = SvgCirclepromptIcon;
exports.ClearIcon = SvgClearIcon;
exports.CloseIcon = SvgCloseIcon;
exports.CoinComingIcon = SvgCoinComingIcon;
exports.CoinCountdownIcon = SvgCoinCountdownIcon;
exports.CoinIneffectIcon = SvgCoinIneffectIcon;
exports.CoinProtectIcon = SvgCoinProtectIcon;
exports.CoinRemovedIcon = SvgCoinRemovedIcon;
exports.CoinWarnIcon = SvgCoinWarnIcon;
exports.CommentIcon = SvgCommentIcon;
exports.ContinuousdrawingIcon = SvgContinuousdrawingIcon;
exports.CopyIcon = SvgCopyIcon;
exports.CopytradingIcon = SvgCopytradingIcon;
exports.CouponIcon = SvgCouponIcon;
exports.CrossIcon = SvgCrossIcon;
exports.CumulativeincomeIcon = SvgCumulativeincomeIcon;
exports.CutoverIcon = SvgCutoverIcon;
exports.DAppsIcon = SvgDAppsIcon;
exports.DataIcon = SvgDataIcon;
exports.DateIcon = SvgDateIcon;
exports.DepositIcon = SvgDepositIcon;
exports.DetailsIcon = SvgDetailsIcon;
exports.DirectiondownIcon = SvgDirectiondownIcon;
exports.DirectionleftIcon = SvgDirectionleftIcon;
exports.DirectionrightIcon = SvgDirectionrightIcon;
exports.DirectionupIcon = SvgDirectionupIcon;
exports.DiscordIcon = SvgDiscordIcon;
exports.Download2Icon = SvgDownload2Icon;
exports.DownloadIcon = SvgDownloadIcon;
exports.DragdropIcon = SvgDragdropIcon;
exports.DrawingIcon = SvgDrawingIcon;
exports.EarningstodayIcon = SvgEarningstodayIcon;
exports.EarphoneIcon = SvgEarphoneIcon;
exports.EditIcon = SvgEditIcon;
exports.EmptyIcon = SvgEmptyIcon;
exports.ExchangeIcon = SvgExchangeIcon;
exports.ExitDrawingIcon = SvgExitDrawingIcon;
exports.ExpandIcon = SvgExpandIcon;
exports.ExtendIcon = SvgExtendIcon;
exports.EyeoffIcon = SvgEyeoffIcon;
exports.EyeonIcon = SvgEyeonIcon;
exports.FacebookIcon = SvgFacebookIcon;
exports.FiatdepositIcon = SvgFiatdepositIcon;
exports.FilterIcon = SvgFilterIcon;
exports.FilterPressed1Icon = SvgFilterPressed1Icon;
exports.FluctuationIcon = SvgFluctuationIcon;
exports.FoldIcon = SvgFoldIcon;
exports.FollowersIcon = SvgFollowersIcon;
exports.FullscreenOffIcon = SvgFullscreenOffIcon;
exports.FullscreenOnIcon = SvgFullscreenOnIcon;
exports.GiftIcon = SvgGiftIcon;
exports.GithubIcon = SvgGithubIcon;
exports.GlobeIcon = SvgGlobeIcon;
exports.GoogleIcon = SvgGoogleIcon;
exports.GuideIcon = SvgGuideIcon;
exports.HalfscreenOffIcon = SvgHalfscreenOffIcon;
exports.HalfscreenOnIcon = SvgHalfscreenOnIcon;
exports.HelpCircleSolidIcon = SvgHelpCircleSolidIcon;
exports.HelpIcon = SvgHelpIcon;
exports.HighindexIcon = SvgHighindexIcon;
exports.HomeIcon = SvgHomeIcon;
exports.HotkeyIcon = SvgHotkeyIcon;
exports.IconCompassIcon = SvgIconCompassIcon;
exports.ImIcon = SvgImIcon;
exports.ImportIcon = SvgImportIcon;
exports.InformationdisclosureIcon = SvgInformationdisclosureIcon;
exports.InstagramIcon = SvgInstagramIcon;
exports.JobmanagementIcon = SvgJobmanagementIcon;
exports.KlineEntranceAppIcon = SvgKlineEntranceAppIcon;
exports.KtvAreaIcon = SvgKtvAreaIcon;
exports.KtvBarsIcon = SvgKtvBarsIcon;
exports.KtvBaselineIcon = SvgKtvBaselineIcon;
exports.KtvCandlesIcon = SvgKtvCandlesIcon;
exports.KtvHeikinashiIcon = SvgKtvHeikinashiIcon;
exports.KtvHollowcandlesIcon = SvgKtvHollowcandlesIcon;
exports.KtvLineIcon = SvgKtvLineIcon;
exports.LabelUpgradeIcon = SvgLabelUpgradeIcon;
exports.LayerIcon = SvgLayerIcon;
exports.LevelIcon = SvgLevelIcon;
exports.Line1Icon = SvgLine1Icon;
exports.Line2Icon = SvgLine2Icon;
exports.LineBoldIcon = SvgLineBoldIcon;
exports.LineDottedIcon = SvgLineDottedIcon;
exports.LinePointIcon = SvgLinePointIcon;
exports.LinkIcon = SvgLinkIcon;
exports.LinkinIcon = SvgLinkinIcon;
exports.ListIcon = SvgListIcon;
exports.LoadingIcon = SvgLoadingIcon;
exports.LockIcon = SvgLockIcon;
exports.LogOutIcon = SvgLogOutIcon;
exports.LowindexIcon = SvgLowindexIcon;
exports.MagneticIcon = SvgMagneticIcon;
exports.MailIcon = SvgMailIcon;
exports.ManualIcon = SvgManualIcon;
exports.MapPinIcon = SvgMapPinIcon;
exports.MarketIcon = SvgMarketIcon;
exports.MediumIcon = SvgMediumIcon;
exports.MenuIcon = SvgMenuIcon;
exports.MoonIcon = SvgMoonIcon;
exports.MorehorizontalIcon = SvgMorehorizontalIcon;
exports.NewcomerIcon = SvgNewcomerIcon;
exports.NewsIcon = SvgNewsIcon;
exports.OrderIcon = SvgOrderIcon;
exports.OrdersIcon = SvgOrdersIcon;
exports.OriginalorderIcon = SvgOriginalorderIcon;
exports.OverviewIcon = SvgOverviewIcon;
exports.PadIcon = SvgPadIcon;
exports.ParallelIcon = SvgParallelIcon;
exports.PcIcon = SvgPcIcon;
exports.PencilIcon = SvgPencilIcon;
exports.PerpIcon = SvgPerpIcon;
exports.PhoneIcon = SvgPhoneIcon;
exports.PlacardIcon = SvgPlacardIcon;
exports.PlaceanorderIcon = SvgPlaceanorderIcon;
exports.PlusIcon = SvgPlusIcon;
exports.Pm1Icon = SvgPm1Icon;
exports.QuickjumpIcon = SvgQuickjumpIcon;
exports.QuoraIcon = SvgQuoraIcon;
exports.QuotesCutoverIcon = SvgQuotesCutoverIcon;
exports.RateIcon = SvgRateIcon;
exports.RaysIcon = SvgRaysIcon;
exports.RectangleIcon = SvgRectangleIcon;
exports.RecurringbuyIcon = SvgRecurringbuyIcon;
exports.RedditIcon = SvgRedditIcon;
exports.ReduceIcon = SvgReduceIcon;
exports.RefreshIcon = SvgRefreshIcon;
exports.RemoveIcon = SvgRemoveIcon;
exports.RemoveSolidIcon = SvgRemoveSolidIcon;
exports.ResourceIcon = SvgResourceIcon;
exports.RetraceIcon = SvgRetraceIcon;
exports.RewardsIcon = SvgRewardsIcon;
exports.RmIcon = SvgRmIcon;
exports.RulerIcon = SvgRulerIcon;
exports.SafetyIcon = SvgSafetyIcon;
exports.ScanIcon = SvgScanIcon;
exports.ScreenshotIcon = SvgScreenshotIcon;
exports.SearchIcon = SvgSearchIcon;
exports.SectorIcon = SvgSectorIcon;
exports.ServiceIcon = SvgServiceIcon;
exports.SettingIcon = SvgSettingIcon;
exports.SettingKlineIcon = SvgSettingKlineIcon;
exports.ShareIcon = SvgShareIcon;
exports.SortDefault1Icon = SvgSortDefault1Icon;
exports.SortIcon = SvgSortIcon;
exports.SpotIcon = SvgSpotIcon;
exports.SpsxIcon = SvgSpsxIcon;
exports.SpsxNew1Icon = SvgSpsxNew1Icon;
exports.SquareIcon = SvgSquareIcon;
exports.StarnoIcon = SvgStarnoIcon;
exports.StaryesIcon = SvgStaryesIcon;
exports.StrategyIcon = SvgStrategyIcon;
exports.StrategyhistoryIcon = SvgStrategyhistoryIcon;
exports.StratrgyorderIcon = SvgStratrgyorderIcon;
exports.SubtractIcon = SvgSubtractIcon;
exports.SunIcon = SvgSunIcon;
exports.SystemExchangeAppIcon = SvgSystemExchangeAppIcon;
exports.SystemExchangeWebIcon = SvgSystemExchangeWebIcon;
exports.TacticsIcon = SvgTacticsIcon;
exports.TaskIcon = SvgTaskIcon;
exports.TelegramIcon = SvgTelegramIcon;
exports.ThumbsDownIcon = SvgThumbsDownIcon;
exports.ThumbsUpIcon = SvgThumbsUpIcon;
exports.TogglechartIcon = SvgTogglechartIcon;
exports.TopLeftIcon = SvgTopLeftIcon;
exports.TopRightIcon = SvgTopRightIcon;
exports.TradingIcon = SvgTradingIcon;
exports.TradingbotIcon = SvgTradingbotIcon;
exports.TransferassetsIcon = SvgTransferassetsIcon;
exports.TransforIcon = SvgTransforIcon;
exports.TransmitterIcon = SvgTransmitterIcon;
exports.TrashIcon = SvgTrashIcon;
exports.TrendlIcon = SvgTrendlIcon;
exports.UnblockIcon = SvgUnblockIcon;
exports.UpcomingIcon = SvgUpcomingIcon;
exports.UptoIcon = SvgUptoIcon;
exports.UsdcIcon = SvgUsdcIcon;
exports.UserIcon = SvgUserIcon;
exports.VerticalIcon = SvgVerticalIcon;
exports.VideoIcon = SvgVideoIcon;
exports.ViewProfileIcon = SvgViewProfileIcon;
exports.VipIcon = SvgVipIcon;
exports.VolumeIcon = SvgVolumeIcon;
exports.WalletIcon = SvgWalletIcon;
exports.Web3AssetsIcon = SvgWeb3AssetsIcon;
exports.Web3DappsIcon = SvgWeb3DappsIcon;
exports.Web3Home1Icon = SvgWeb3Home1Icon;
exports.Web3HomeIcon = SvgWeb3HomeIcon;
exports.Web3RankIcon = SvgWeb3RankIcon;
exports.Web3SwapIcon = SvgWeb3SwapIcon;
exports.WechartIcon = SvgWechartIcon;
exports.WifiIcon = SvgWifiIcon;
exports.WithdrawIcon = SvgWithdrawIcon;
exports.XCircleIcon = SvgXCircleIcon;
exports.XIcon = SvgXIcon;
exports.YoutubeIcon = SvgYoutubeIcon;
//# sourceMappingURL=moly-icons.cjs.development.js.map
